export const chinese = () => {
    return {
        dashboard: '仪表板',
        cms_dashboard: '管理系统',
        content_dashboard: '内容',
        sales_dashboard: '销售量',
        booking_status_dashboard: '预订状态',
        booking_summary_dashboard: '预订摘要',
        contract_menu: '合同',
        contract_sub_menu: '合同',
        media_management_menu: '媒体管理',
        media_others_menu: '其他的',
        series_sub_menu: '亲子系列',
        season_sub_menu: '系列',
        episode_sub_menu: '独立剧集',
        program_sub_menu: '程序',
        movie_sub_menu: '电影',
        trailer_sub_menu: '拖车',
        interstitial_sub_menu: '插页式',
        commercial_sub_menu: '商业的',
        filler_sub_menu: '填料',
        music_sub_menu: '音乐',
        break_sub_menu: '休息',
        media_episode_group_sub_menu: '媒体剧集组',
        planning_menu: '规划',
        planning_sub_menu: '规划',
        formats_sub_menu: '格式',
        program_schedule_clash_sub_menu: '节目时间表冲突',
        scheduling_menu: '调度',
        curate_menu: '策展人',
        timeline_sub_menu: '时间轴',
        timeline_linear_sub_menu: '线性时间线',
        series_timeline_sub_menu: '系列时间表',
        rails_sub_menu: '导轨',
        pages_sub_menu: '页数',
        assets_sub_menu: '资产',
        tv_preview_sub_menu: '电视预览',
        web_preview_sub_menu: '网页预览',
        mobile_preview_sub_menu: '移动预览',
        ingestion_menu: '食入',
        posters_sub_menu: '海报',
        ingestion_template_sub_menu: '摄取模板',
        partner_ingestion_sub_menu: '合作伙伴摄取',
        jobs_sub_menu: '工作机会',
        sales_menu: '销售量',
        agency_sub_menu: '机构',
        client_sub_menu: '客户',
        campaign_sub_menu: '活动',
        booking_sub_menu: '预订',
        booking_transfer_sub_menu: '预订接送服务',
        update_booking_line_number_sub_menu: '更新预订行号码',
        sales_team_sub_menu: '销售团队',
        sales_executive_sub_menu: '销售主管',
        reconciliation_menu: '和解',
        as_run_reconciliation_sub_menu: '运行时调节',
        import_planning_sub_menu: '进口计划',
        import_asRun_sub_menu: '导入AsRun',
        manage_asRun_sub_menu: '管理AsRun',
        export_menu: 'Export',
        epg_sub_menu: '电子节目指南',
        epg_template_sub_menu: '电子节目指南模板',
        secondary_event_menu: '次要活动',
        prototype_sub_menu: '原型',
        styleSheet_sub_menu: '样式表',
        default_prototype_sub_menu: '默认原型',
        protoType_source_sub_menu: '原型源',
        secondary_event_dynamic_rule_sub_menu: '次要事件动态规则',
        billing_menu: '计费',
        billing_sub_menu: '计费',
        generated_bills_sub_menu: '生成的账单',
        masters_menu: '大师赛',
        master_menu_title: '掌握',
        language_sub_menu: '语言',
        content_sub_menu: '内容',
        assets_type_sub_menu: '资产类型',
        rails_type_sub_menu: '导轨类型',
        posters_type_sub_menu: "海报类型",
        users_sub_menu: '用户',
        department_sub_menu: '部门',
        role_sub_menu: '角色',
        content_category_sub_menu: '内容类别',
        region_sub_menu: '地区',
        brand_sub_menu: '品牌',
        product_sub_menu: '产品',
        bank_account_sub_menu: '银行账户',
        tax_sub_menu: '税',
        licensor_sub_menu: '许可人',
        channel_sub_menu: '渠道',
        currency_sub_menu: '货币',
        time_range_sub_menu: '时间范围',
        repeat_pattern_sub_menu: '重复模式',
        invoice_content_sub_menu: '发票内容',
        segemnt_type_sub_menu: '段类型',
        variation_sub_menu: '变化',
        break_format_sub_menu: '中断格式',
        payment_provider_sub_menu: '支付提供商',
        ott_period_type_sub_menu: '奥特周期类型',
        payment_type_sub_menu: '付款方式',
        schedule_constraints_sub_menu: '时间表限制',
        monetization_menu: '货币化',
        ott_period_sub_menu: '时期',
        subscriber_sub_menu: '订户',
        ott_campaign_sub_menu: '活动',
        coupon_sub_menu: '优惠券',
        data_migration_menu: '数据迁移',
        form_fields_menu: '表单字段',
        save_button_tooltip: '节省',
        save_button_text: '节省',
        back_button_tooltip: '后退',
        add_button_tooltip: '添加',
        add_button_text: '添加',
        add_multiple_button_text: '添加多个',
        add_dialog_header: '添加',
        new_button_dialog_header: '新的',
        new_title_editpageheader: '新的',
        edit_button_tooltip: '编辑',
        update_button_tooltip: '更新',
        remove_button_tooltip: '消除',
        delete_button_tooltip: '删除',
        select_button_tooltip: '选择',
        select_button_text: '选择',
        cancel_button_tooltip: '取消',
        cancel_button_text: '取消',
        preference_button_tooltip: '偏爱',
        options: '选项',
        refresh_button_tooltip: '刷新',
        archive: '档案',
        ExportBreaksOnly: '仅导出中断',
        loading_pleasewait: '正在加载请稍候...',
        no_records_found: '没有找到记录！！',
        contract_number_label: '合同号',
        platform_type_label: '平台类型',
        licensor_label: '许可人',
        payee_label: '收款人',
        start_date_label: '开始日期',
        end_Date_label: '结束日期',
        channel_label: '渠道',
        platform_label: '平台',
        region_label: '地区',
        exhibition_label: '展览',
        repeat_label: '重复',
        play_time_number_label: '播放时间数',
        playTime_label: '游玩时间',
        is_unlimited_label: '无限',
        add_media_episode_button_tooltip: '添加媒体片段',
        remove_media_episode_button_tooltip: '删除媒体片段',
        assetId_column: '资产编号',
        title_column: '标题',
        media_category_column: '媒体类别',
        start_date_column: '开始日期',
        end_date_column: '结束日期',
        is_unlimited_column: '是无限的',
        exhibition_column: '展览',
        repeat_column: '重复',
        play_time_number_column: '播放时间数',
        playTime_column: '游戏时间',
        media_library_dialog_header: '媒体库',
        summary: '概括',
        create_series_dialog_header: '创建父系列',
        content_label: '内容',
        asset_id_label: '资产ID',
        description_label: '描述',
        synopsis_label: '概要',
        islive_label: '居住',
        alwaysLive_label: '永远活着',
        seasons_title: '系列',
        series_cardlist_header: '系列',
        season_cardlist_header: '插曲',
        sidefix_season_tooltip: '季节',
        s_content_label: 'S.内容',
        season_no_label: '季节号',
        ep_content_label: 'EP。内容',
        episodes_label: '剧集数',
        no_of_episodes_label: '集数',
        duration_label: '持续时间（时:分:秒:晚）',
        playlist_duration_label: '持续时间（时:分:秒）',
        total_block_duration_label: '总区块持续时间 (hh:mm:ss:ff)',
        season_number_column: '季数',
        no_of_episodes_column: '集数',
        season_content_column: '赛季内容',
        episode_content_column: '剧集内容',
        duration_column: '期间',
        timerangefrom_column: '从',
        timerangeto_column: '到',
        select_image_collection_header: '选择图像',
        description_column: '描述',
        meta_data_label: '元数据',
        posters_label: '海报',
        publishing_label: '出版',
        search_by_title: '按标题搜索',
        genre_label: '类型',
        language_label: '语言',
        pg_rating_label: 'PG 评级',
        keywords_label: '关键词',
        add_poster_button_tooltip: '添加海报',
        poster_type_column: '海报类型',
        edit_poster_dialog_header: '编辑海报',
        poster_type_label: '海报类型',
        url_label: '网址',
        select_url_tooltip: '选择网址',
        add_publishing_button_tooltip: '添加发布',
        unlimited_rights_grid: '无限权利',
        tba_label: '待定',
        tba_column: '待定',
        publishing_dialog_header: '出版',
        platform_type_column: '平台类型',
        channel_column: '渠道',
        source_column: '来源',
        enter_title: '输入标题',
        create_season_dialog_header: '创建系列',
        season_number_label: '季数',
        series_label: '亲子系列',
        starting_episode_label: '起始剧集',
        select_series_collection_header: '选择父系列',
        video_label: '视频',
        videos_label: '视频',
        add_video_button_tooltip: '添加视频',
        video_type_column: '视频类型',
        video_type_label: '视频类型',
        url_column: '网址',
        edit_video_dialog_header: '编辑视频',
        create_video_dialog_header: '创建视频',
        episode_title_label: '剧集标题',
        episode_number_label: '集数',
        season_number_labelshort: "锡号。",
        episode_number_labelshort: 'EP 编号',
        release_date_label: '发布日期',
        version_label: '版本',
        content_category_label: '内容类别',
        format_label: '格式',
        cast_and_crew_label: '演职人员',
        dynamic_fields_label: '动态字段',
        censor_rating_label: '审查评级',
        technical_prototype_label: '技术原型',
        production_year_label: '生产年份',
        language_column: '语言',
        synopsis_column: '概要',
        cast_column: '投掷',
        name_column: '姓名',
        name_label: '姓名',
        cast_type_label: '铸造类型',
        segment_type_column: '类型',
        material_id_column: '材料编号',
        actual_duration_column: '实际持续时间',
        is_default_column: '默认',
        is_hard_parted_column: '难舍难分',
        edit_version_dialog_header: '编辑版本',
        create_version_dialog_header: '创建版本',
        segment_type_label: '段类型',
        material_id_label: '材料编号',
        is_hard_parted_label: '难舍难分',
        is_default_label: '默认',
        generate_segments_button_text: '生成片段',
        auto_distribute_button_text: '自动分发',
        sequence_column: '顺序',
        media_id_column: '媒体ID',
        start_time_column: '开始时间',
        end_time_column: '结束时间',
        previewed_column: '预览',
        parent_content_category_column: '家长内容类别',
        select_format_collection: '选择格式',
        select_content_category_collection_header: '选择内容类别',
        manual_assetid_label: '手动资产 ID',
        media_category_label: '媒体类别',
        media_category_type_label: '媒体类别类型',
        media_sub_category_type_label: '媒体子类别类型',
        tc_in_label: 'TC 输入 (hh:mm:ss:ff)',
        tc_out_label: 'Tc 输出（时:分:ss:ff）',
        media_episode_group_dialog_header: '创建媒体剧集组',
        program_group_dialog_header: '创建节目组',
        interstital_group_dialog_header: '创建间质组',
        media_category_type_column: '媒体类别类型',
        media_category_type_collection_header: '媒体类别类型',
        episode_dialog_header: '插曲',
        sidefixmenu_rails_asset_tooltip: '资产',
        cardlist_rails_title: '资产',
        cardlist_rails_assets_title: '资源库',
        rails_title_editpageheader: '导轨',
        display_title_label: '显示标题',
        rails_type_label: '类型',
        rails_note_label: '注：用户可以选择',
        publish_label: '发布',
        published_label: '已发表',
        unpublished_label: '未发表',
        rails_p_label: '磷',
        rails_up_label: '向上',
        ott_assets_collection_header: '奥特资产',
        options_actionbutton_menutext: '选项',
        delete_actionbutton_option: '删除',
        moveup_actionbutton_option: '向上移动',
        movedown_actionbutton_option: '下移',
        sidefixmenu_rails_tooltip: '轨',
        cardlist_page_rails_title: '导轨',
        cardlist_rails_page_title: '铁路图书馆',
        theme_label: '主题',
        icon_url_label: '图标网址',
        please_fill_out_details_label: '请填写此字段。',
        assets_dialog_header: '创建资产',
        validation: '请选择值',
        asset_type_label: '资产类型',
        portrait_image_url_label: '肖像图片网址',
        landscape_image_url_label: '风景图片网址',
        video_playback_url_label: '视频播放地址',
        select_portal_image_url_collection_header: '选择肖像图片网址',
        select_landscape_image_url_collection_header: '选择风景图片 URL',
        create_poster_dialog_header: '创建海报',
        image_url_label: '图片网址',
        file_path_label: '文件路径',
        poster_note_label: '注意：图像将在保存时上传，并且 URL 将被分配',
        template_name_label: '模板名称',
        module_type_label: '模块类型',
        ingestion_template_type_label: '摄取模板类型',
        save_template_text: '保存模板',
        send_text: '发送',
        send_button_tooltip: '发送',
        body_label: '身体',
        response_label: '回复',
        select_file_label: '选择文件',
        load_button_text: '加载',
        ingestion_template_note_label: '保存时将第一个参数值替换为搜索文本',
        key_column: '钥匙',
        value_column: '价值',
        key_label: '钥匙',
        value_label: '价值',
        template_details_label: '模板详细信息',
        template_label: '模板',
        search_title_label: '搜索标题',
        ingest_button_text: '摄取',
        ingest_button_tooltip: '摄取',
        load_button_tooltip: '加载',
        ingestion_details_label: '摄入详情',
        pg_rating_column: 'PG评级',
        genres_column: '流派',
        show_response_label: '显示回复',
        response_dialog_header: '回复',
        eye_tooltip: '眼睛',
        agency_dialog_header: '创建代理机构',
        code_label: '代码',
        address_label: '地址',
        pincode_label: '密码',
        email_label: '电子邮件',
        credit_limit_label: '信用额度',
        pan_label: '平底锅',
        gst_number_label: '商品及服务税号',
        default_tax_label: '违约税',
        is_credit_unlimited_label: '信用无限',
        client_dialog_header: '创建客户端',
        agency_label: '机构',
        campaign_number_label: '活动编号',
        order_date_label: '订购日期 *',
        period_from_label: '从',
        period_to_label: '到',
        campaign_type_label: '类型',
        deal_type_label: '交易类型',
        client_label: '客户',
        location_label: '地点',
        product_label: '产品',
        commission_label: '委员会',
        target_budget_label: '目标预算',
        target_spots_label: '目标点',
        target_seconds_label: '目标秒数',
        currency_label: '货币',
        discount_label: '折扣',
        tax_applicable_label: '适用税费',
        actual_booking_label: '实际预订',
        commercial_label: '商业的',
        fct_label: '光纤传输技术',
        billing_label: '计费',
        channel_tab_label: '渠道',
        channel_name_column: '频道名称',
        epg_code_column: '电子节目指南代码',
        asrun_code_column: '运行代码',
        content_column: '内容',
        add_channel_button_tooltip: '添加频道',
        add_commercial_button_tooltip: '添加商业/促销',
        commercial_promos_label: '商业/促销',
        add_fct_button_tooltip: '添加 FCT',
        add_billing_button_tooltip: '添加账单',
        channel_collection_header: '渠道',
        commercials_collection_header: '广告',
        fct_column: '光纤传输技术',
        from_date_column: '开始日期',
        to_date_column: '迄今为止',
        campaign_type_column: '露营类型',
        rate10sec_column: '速率10秒',
        days_column: '天',
        fct_dialog_header: '光纤传输技术',
        billing_dialog_header: '计费',
        from_date_label: '开始日期',
        to_date_label: '迄今为止',
        rate10sec_label: '速率10秒',
        rate30sec_label: '速率30秒',
        day_label: '天',
        select_all_label: '选择全部',
        sun_label: '太阳',
        mon_label: '周一',
        tue_label: '星期二',
        wed_label: '周三',
        thu_label: '星期四',
        fri_label: '周五',
        sat_label: '星期六',
        amount_column: '数量',
        amount_label: '数量',
        booking_label: '预订',
        campaign_label: '活动',
        year_label: '年',
        months_label: '几个月',
        booking_collection_header: '选择预订活动',
        from_label: '从：',
        to_label: '到：',
        total_spot_label: '总名额',
        total_seconds_label: '总秒数',
        total_budget_label: '总预算：',
        download_template_tooltip: '下载模板',
        file_tooltip: '选择文件',
        line_no_column: '行号',
        commercial_column: '商业的',
        program_column: '程序',
        house_number_column: '门牌号',
        type_column: '类型',
        deal_type_column: '交易类型',
        spot_rate_column: '即期汇率',
        position_column: '位置',
        from_time_column: '从',
        to_time_column: '到',
        product_code_column: '产品代码',
        total_spot_column: '现货总数',
        total_fct_column: '总 FCT',
        total_amount_column: '总金额',
        booked_spots_lable: '预订地点：',
        current_spots_label: '当前景点：',
        booked_seconds_label: '预订秒数：',
        current_seconds_label: '当前秒数：',
        booked_amount_label: '预订金额：',
        current_amount_label: '当前金额：',
        add_booking_dialog_header: '添加预订',
        type_label: '类型',
        from_time_label: '从时间',
        spot_per_day_label: '现货（每天）',
        spot_per_week_label: '现货（每周）',
        rate_label: '速度',
        estimate_code_label: '估计代码',
        remark_label: '评论',
        count_label: '数数',
        transfer_from_label: '转自',
        transfer_to_label: '转移至',
        transfer_button_tooltip: '转移',
        transfer_button_text: '转移',
        campaign_column: '活动',
        booking_date_column: '预订日期',
        time_range_from_column: '时间范围从',
        time_range_to_column: '时间范围至',
        edit_actionbutton_menutext: '编辑',
        select_all_Header_menutext: '选择所有标题',
        delete_actionbutton_menutext: '删除',
        editduration_actionbutton_menutext: '编辑持续时间',
        cut_actionbutton_menutext: '切',
        update_booking_line_number_label: '更新预订行号码',
        select_campaign_collection_text: '选择活动',
        edit_campaign_collection_text: '编辑活动',
        select_campaign_collection_tooltip: '选择',
        already_scheduled_label: '已安排',
        not_scheduled_label: '未安排',
        edit_booking_dialog_header: '编辑预订',
        spot_rate_label: '即期汇率',
        time_range_from_label: '时间范围从',
        time_range_to_label: '时间范围至',
        auto_reconcile_button_tooltip: '自动协调',
        auto_reconcile_button_text: '自动协调',
        import_as_run_button_text: '导入为运行',
        import_as_run_button_tooltip: '导入为运行',
        reconciled_r_label: "右",
        reconciled_label: '和解了',
        non_reconciled_label: '不甘心',
        non_reconciled_nr_label: 'NR',
        total_label: '全部的',
        total_commercial: '商业总额：',
        sno_column: '编号',
        slot_date_time_column: '时段日期时间',
        episode_number_column: '集数',
        category_column: '类别',
        reconciled_status_column: '调节状态',
        is_reconciled_column: '已和解',
        reconsilation_by_column: '和解者',
        status_column: '地位',
        ref_force_match_label: '力量匹配',
        force_match_label: '力量匹配',
        force_match_fm_label: '调频',
        ref_force_unmatch_label: '强制不匹配',
        ref_cancel_label: '取消',
        ref_export_xml_label: '导出XML',
        purge_button_tooltip: '清除',
        unpurge_button_tooltip: '取消清除',
        campaign_no_label: '活动编号',
        fic_dxb_0002486_label: 'FIC-DXB-0002486',
        total_spot_857_label: '857',
        total_amount_label: '总金额',
        total_seconds_19935_label: '19935',
        total_cast_2478_label: '2478.00',
        purged_label: '净化的',
        date_column: '日期',
        is_purged_column: '被清除',
        ref_purged_label: '清除',
        ref_unpurged_label: '取消清除',
        ref_calculate_spot_rate_label: '计算即期汇率',
        total_fct_label: '总 FCT',
        total_spot_rate: '总即期汇率',
        ref_calculate_fct_label: '计算 FCT',
        ref_change_time_range_label: '变更时间范围',
        ref_transfer_label: '转移',
        ref_update_estimate_code_label: '更新估算代码',
        ref_change_commercial_label: '更改商业广告',
        ref_change_spot_rate_label: '更改即期汇率',
        change_time_range_dialog_header: '变更时间范围',
        start_time_label: '开始时间',
        to_time_label: '到时间',
        transfer_dialog_header: '转移',
        transfer_to_date_label: '转移至今',
        change_spot_rate_dialog_header: '更改即期汇率',
        change_spot_rate_label: '更改即期汇率',
        change_commercial_dialog_header: '更改广告',
        change_commercial_label: '更改商业广告',
        update_product_estimate_code_dialog_header: '更新产品估算代码',
        update_button_text: '更新',
        update_all_button_text: '全部更新',
        add_file_label: '添加文件',
        import_file_label: '导入文件',
        message_column: '信息',
        file_upload_tooltip: '文件上传',
        import_file_name_column: '导入文件名',
        comment_load_data_label: '点击load加载数据',
        program_label: '程序',
        select_program_booking_collection_header: '选择预订项目',
        export_report_dialog_header: 'Export EPG',
        import_template_dialog_heade: '导入模板',
        filters_label: '过滤器',
        operator_label: '操作员',
        operator_column: '操作员',
        export_button_tooltip: 'Export',
        export_button_text: 'Export',
        export_playlist_button_tooltip: 'Export Playlist',
        export_and_sftp_playlist_button_tooltip: 'Export & SFTP Playlist',
        export_playlist_button_text: 'Export Playlist',
        up_button_tooltip: '向上',
        down_button_tooltip: '向下',
        export_template_editpageheader: 'Export EPG Template',
        save_template_as_label: '将模板另存为',
        module_name_label: '模块名称',
        selected_Columns_label: '选定的列',
        available_Column_label: '可用栏',
        display_name_label: '显示名称',
        add_blank_button_tooltip: '添加空白',
        add_blank_button_text: '添加空白',
        add_column_button_tooltip: '添加列',
        add_column_button_text: '添加列',
        available_Column: '可用栏',
        display_column: '显示名称',
        format_name_column: '格式',
        id_label: 'ID',
        source_label: '来源',
        segment_position_label: '段位',
        group_label: '团体',
        select_media_episode_collection_header: '选择媒体剧集',
        start_type_label: '启动类型',
        start_offset_label: '起始偏移',
        time_hh_mm_ss_ff_label: '时:分:秒:晚',
        negative_label: '消极的',
        end_type_label: '末端类型',
        end_offset_label: '结束偏移',
        add_secondary_event_button_toottip: '添加次要事件',
        text_number_column: '文字编号',
        prefix_column: '前缀',
        rule_column: '规则',
        text_number_label: '文字编号',
        prefix_label: '前缀',
        rule_label: '规则',
        style_sheet_editpageheader: '样式表',
        add_prototype_button_tooltip: '添加原型',
        id_column: 'ID',
        protoType_source_column: '原型源',
        group_column: '团体',
        select_prototype_collection_header: '选择原型',
        default_prototype_editpageheader: '默认原型',
        create_secondary_event_dynamic_rule_dialog_header: '创建次要事件动态规则',
        formula_label: '公式',
        secondary_event_overview_dialog_header: '次要事件概述',
        start_type_column: '启动类型',
        start_offset_column: '起始偏移',
        end_type_column: '结束类型',
        end_offset_column: '结束偏移',
        confirm_button_text: '确认',
        billing_period_label: '计费周期',
        upto_label: '厄普托',
        generate_bill_button_tooltip: '生成账单',
        generate_bill_button_text: '生成账单',
        agency_column: '机构',
        client_column: '客户',
        comission_column: '委员会 ％',
        from_column: '从',
        to_column: '到',
        total_budget_spot_column: '目标点',
        total_booked_spot_column: '预订名额总数',
        missing_spot_column: '缺失点',
        reconciled_spots_column: '协调点',
        generated_bill_Spots_column: '生成的票据现货',
        contact_label: '联系',
        contact_info_label: '联系方式',
        telephone_label: '电话',
        address1_label: '地址1',
        address2_label: '地址2',
        agency_info_label: '代理信息',
        spots_label: '景点',
        amounts_label: '金额',
        total_booked_label: '预订总数',
        missing_label: '丢失的',
        generated_bill_label: '生成的账单',
        payment_recived_label: '已收到付款',
        due_amount_label: '应付金额',
        credit_balance_label: '信用余额',
        selected_campaign_info_label: '选定的活动信息',
        booked_label: '已预订',
        detail_for_selected_date_range_and_campaign_label: '选定日期范围和活动的详细信息',
        invoice_denomination_dialog_header: '发票面额',
        invoice_period_label: '发票期限',
        invoice_campaign_brabd_label: '活动品牌',
        select_period_label: '选择期间',
        show_button_tooltip: '展示',
        show_button_text: '展示',
        details_label: '细节',
        caption_column: '标题',
        spots_column: '景点',
        tax_column: '税',
        tax_label: '税',
        tax_not_applicable_label: '税款不适用',
        discount_amount_label: '折扣金额',
        invoice_date_label: '发票日期',
        bank_account_label: '银行账户',
        gross_total_label: '总金额',
        tax_amount_label: '税额',
        commission_amount_label: '佣金金额',
        target_amount_label: '目标金额',
        invoice_no_column: '发票号码',
        campaign_no_column: '活动编号',
        invoice_date_column: '发票日期',
        period_from_column: '期间从',
        period_to_column: '期间至',
        validated_amount_column: '已验证金额',
        discount_percentage_column: '折扣比例',
        discount_amount_column: '折扣金额',
        company_menu: '公司',
        logo_url_label: '徽标网址',
        logo_width_label: '标志宽度',
        suffix_label: '后缀',
        next_number_label: '下一个号码',
        full_channel_name_label: '完整频道名称',
        short_channel_name_label: '短频道名称',
        epg_code_label: '电子节目指南代码',
        as_run_code_label: '作为运行代码',
        automation_channel_name_label: '自动化通道名称',
        color_label: '颜色',
        automation_label: '自动化',
        repeated_pattern_details_dialog_header: '重复模式细节',
        add_repeat_button_tooltip: '添加重复',
        create_repeat_pattern_editpage_header: '创建重复模式',
        create_variation_editpage_header: '创造变化',
        create_break_format_editpage_header: '创建中断格式',
        edit_variation_editpage_header: '编辑变体',
        edit_break_format_editpage_header: '编辑中断格式',
        add_primary_pattern_button_tolltip: '添加主要',
        primary_events_no_column: '主要事件 否',
        repeat_events_no_column: '重复事件 否',
        nominal_start_column: '标称启动',
        primary_events_no_label: '主要事件 否',
        days_label: '天',
        times_label: '时代',
        create_invoice_content_dialog_header: '创建发票内容',
        number_length_label: '号码长度',
        label: '标签',
        sequence_label: '顺序',
        entity_name_label: '实体名称',
        max_length_label: '最大长度',
        width_label: '宽度',
        required_label: '必需的',
        edit_label: '编辑',
        slot_time_column: '时段',
        please_generate_segment_to_load_media_label: '请生成片段以加载媒体！',
        filter_button_tooltip: '筛选',
        search_content_dialog_header: '搜索内容',
        clear_button_tooltip: '清除',
        clear_button_text: '清除',
        search_button_tooltip: '搜索',
        search_button_text: '搜索',
        select_preference_for_dialog_header: '选择列首选项',
        available_label: '可用的',
        preference_label: '偏爱',
        note_preference: '注意：-对于默认列，请将首选项留空',
        house_number_label: '门牌号',
        category_type_label: '类别类型',
        slot_time_label: '时段',
        actual_duration_label: '实际持续时间',
        nominal_duration_label: '标称持续时间',
        segments_label: '段',
        recursive_button_text: '递归',
        recursive_dialog_header: '递归',
        generate_button_toottip: '产生',
        generate_button_text: 'Excel',
        inclusion_range_label: '包含范围',
        episode_range_label: '剧集范围',
        example_label: '例子',
        exclusion_range_label: '排除范围',
        exclude_days_label: '排除天数',
        format_icon_tooltip: '格式',
        no_segment_icon_tooltip: '无段',
        contract_icon_tooltip: '合同',
        slot_duration_title_label: '时段持续时间',
        maximize_button_tooltip: '最大化',
        copy_Schedule_button_tooltip: '复制',
        planing_preference_button_tooltip: '规划偏好',
        export_planning_button_tooltip: 'Export Planning',
        selected_label: '已选择',
        copied_label: '已复制',
        select_channels_dialog_header: '选择频道',
        date_label: '日期',
        copy_Schedule_dialog_header: '复制时间表',
        copy_from_label: '复制自',
        copy_to_label: '复制到',
        selected_date_should_be_equal_error_message: '所选日期范围应该相等',
        from_channel_label: '来自频道',
        to_channel_label: '前往频道',
        activity_label: '活动',
        create_button_tootltip: '创建',
        create_button_text: '创建',
        planing_preference_dialog_header: '规划偏好',
        events_label: '活动',
        columns_label: '专栏',
        general_label: '一般',
        note_select_the_events_you_want_to_change: '选择您要更改的事件',
        events_type_lable: '活动类型',
        foreground_Color_label: '前景色',
        available_columns_label: '可用列',
        view_type_label: '视图类型',
        show_format_label: '显示格式',
        show_no_seg_label: '显示无段',
        show_contract_label: '显示合同',
        day_Start_time_label: '日开始时间',
        prime_end_time_label: '黄金结束时间',
        prime_Start_time_label: '黄金开始时间',
        episode_Column: '插曲',
        season_Column: '季节',
        versions_column: '版本',
        search_filter_dialog_header: '搜索过滤器',
        release_year_label: '发布年份',
        is_live_label: '正在直播',
        save_as_template_label: '另存为模板',
        show_search_options_media_liberary_tooltip: '显示搜索选项',
        place_holder_dialog_header: '占位符',
        please_choose_one_publishing_rights_collection_header: '请选择一项出版权',
        export_excel_dialog_header: 'Export Excel',
        export_excel_button_tooltip: 'Export Excel',
        export_csv_button_tooltip: 'Export CSV',
        export_excel_button_text: 'Export Excel',
        history_dialog_header: '历史',
        slot_date_column: '时段日期',
        exhibition_no_column: '展览编号',
        repeat_no_column: '重复 否',
        planning_loaded_label_note: '规划已加载',
        planning_loading_label_note: '计划加载中....',
        time_column: '时间',
        prototypes_column: '原型',
        info_column: '信息',
        cut_button_tooltip: '切',
        paste_button_tooltip: '粘贴',
        download_pdf_button_tooltip: '下载PDF',
        open_planning_button_tooltip: '开放式规划',
        delete_all_footer_button_tooltip: '删除所有页脚',
        delete_All_secondary_events_button_tooltip: '删除所有次要事件',
        global_replacement_button_tooltip: '全球更换',
        apply_style_sheet_button_tooltip: '应用样式表',
        apply_button_tooltip: '申请',
        apply_button_text: '申请',
        schedule_preference_button_tooltip: '时间表偏好',
        auto_save_button_tooltip: '自动保存',
        secondary_events_label: '次要活动',
        text_1_column: '文字1',
        text_2_column: '文字2',
        text_3_column: '文字3',
        prototypes_label: '原型',
        insert_break_actionbutton_menutext: '插入中断',
        delete_header_actionbutton_menutext: '删除标题',
        program_replacement_actionbutton_menutext: '程序替换',
        attach_format_reload_actionbutton_menutext: '附加格式',
        history_actionbutton_menutext: '历史',
        select_program_to_replace_with_collection_title: '选择要替换的程序',
        global_replacement_dialog_header: '全球更换',
        replace_button_tooltip: '更换',
        replace_button_text: '更换',
        replacement_method_label: '更换方法',
        include_isBreak_label: '包括休息',
        replace_with_same_duration_only: '仅替换为相同持续时间',
        enable_cross_category_replacement: '启用跨类别',
        replacement_material_label: '替换材料',
        delete_all_button_tooltip: '全部删除',
        delete_all_button_text: '全部删除',
        group_all_button_tooltip: '集团媒体剧集',
        group_all_button_text: '集团媒体剧集',
        select_media_episode_dialoag_header: '选择媒体剧集',
        select_media_episode_group_dialoag_header: '选择媒体剧集组',
        remove_filter_actionbutton_menutext: '删除过滤器',
        filter_actionbutton_menutext: '筛选',
        copy_actionbutton_menutext: '复制',
        paste_actionbutton_menutext: '粘贴',
        se_overview_actionbutton_menutext: 'SE概述',
        global_replacement_actionbutton_menutext: '全球更换',
        sales_team_label: '销售团队',
        department_label: '部门',
        password_label: '密码',
        phone_no_label: '电话号码',
        pobox_label: '邮政信箱',
        reporting_to_lable: '汇报对象',
        role_label: '角色',
        issalesexecutive_label: '是销售主管',
        sales_executive_editpageheader: '销售主管',
        email_column: '电子邮件',
        phone_no_column: '电话号码',
        select_sales_executive_colllection_header: '选择销售主管',
        select_collection_button_text: '选择',
        export_planet_cast_button_tooltip: 'Export Planet Cast',
        check_list_button_tooltip: '检查清单',
        check_lists_dialog_header: '检查清单',
        success_label: '成功',
        failure_lable: '失败',
        module_menu: '模块',
        sales_team_dailog_header: '创建销售团队',
        module_dialog_header: '模块',
        role_dialog_header: '角色',
        admin_label: '管理员',
        sales_label: '销售量',
        media_management_label: '媒体管理',
        rights_manager_label: '版权经理',
        role_editpageheader: '角色',
        select_module_collection_header: '选择模块',
        users_editpage_header: '用户',
        select_Role_collection_header: '选择角色',
        module_column: '模块',
        role_column: '角色',
        add_role_collection_text: '添加角色',
        add_role_button_text: '从角色添加',
        add_module_collection_text: '添加模块',
        sales_executive_editpage_header: '销售主管',
        timeline_page_breadcrumb: '时间线',
        linear_timeline_page_breadcrumb: '线性时间线',
        series_timeline_page_breadcrumb: "系列时间线",
        assets_type_page_breadcrumb: '资产类型',
        rails_type_page_breadcrumb: '导轨类型',
        posters_type_page_breadcrumb: '海报类型',
        department_page_breadcrumb: '部门',
        users_page_breadcrumb: '用户',
        role_page_breadcrumb: '角色',
        assets_page_breadcrumb: '资产',
        posters_page_breadcrumb: '海报',
        client_page_breadcrumb: '客户',
        agency_page_breadcrumb: '机构',
        sales_team_page_breadcrumb: '销售团队',
        trailer_page_breadcrumb: '拖车',
        sales_executive_page_breadcrumb: '销售主管',
        content_page_breadcrumb: '内容',
        channel_page_breadcrumb: '渠道',
        currency_page_breadcrumb: '货币',
        repeat_pattern_page_breadcrumb: '重复模式',
        invoice_content_page_breadcrumb: '发票内容',
        segment_type_page_breadcrumb: '段类型',
        contract_page_breadcrumb: '合同',
        series_page_breadcrumb: '亲子系列',
        season_page_breadcrumb: '系列',
        programs_page_breadcrumb: '节目',
        episode_page_breadcrumb: '插曲',
        movies_page_breadcrumb: '电影',
        interstitial_page_breadcrumb: '插页式',
        commercial_page_breadcrumb: '商业的',
        music_page_breadcrumb: '音乐',
        filler_page_breadcrumb: '填料',
        break_page_breadcrumb: '休息',
        group_page_breadcrumb: '团体',
        program_group_page_breadcrumb: '节目组',
        interstital_group_page_breadcrumb: '间质集团',
        schedule_constraints_page_breadcrumb: '时间表限制',
        campaign_page_breadcrumb: '活动',
        utilisied_label: '已利用',
        over_booked_label: '超额预订',
        counts_label: '计数',
        active_label: '活跃',
        top_10_agency_label: '十大代理机构',
        top_10_client_label: '十大客户',
        pending_vs_on_air_booking_label: '待定与 OnAirBooking',
        revenue_by_location_label: '按地点划分的收入',
        revenue_by_months_label: '每月收入',
        booking_by_deal_type_label: '按交易类型预订',
        time_range_label: '时间范围',
        language_page_breadcrumb: '语言',
        region_page_breadcrumb: '地区',
        brand_page_breadcrumb: '品牌',
        product_page_breadcrumb: '产品',
        rails_page_breadcrumb: '导轨',
        page_breadcrumb: '页数',
        content_caegory_page_breadcrumb: '内容类别',
        ingestion_page_breadcrumb: '食入',
        jobs_page_breadcrumb: '工作机会',
        prototype_page_breadcrumb: '原型',
        prototype_style_sheet_page_breadcrumb: '原型样式表',
        default_prototype_style_sheet_page_breadcrumb: '默认原型样式表',
        prototype_source_page_breadcrumb: '原型来源',
        export_template_page_breadcrumb: 'Export Template',
        form_fields_page_breadcrumb: '表单字段',
        secondary_event_dynamic_rule_page_breadcrumb: '次要事件动态规则',
        format_page_breadcrumb: '格式',
        time_range_page_breadcrumb: '时间范围',
        company_page_breadcrumb: '公司',
        bank_account_page_breadcrumb: '银行账户',
        tax_page_breadcrumb: '税',
        licensor_page_breadcrumb: '许可人',
        delete_successfully_grid_data_success_toast_message: '删除成功',
        delete_all_successfully_grid_data_success_toast_message: '全部删除成功',
        please_select_first_contract_collection_error_message: '请先选择！！',
        please_enter_contarct_number_contract_error_message: '请输入合同号',
        please_select_platform_type_error_message: '请选择平台类型',
        please_select_licensor_error_message: '请选择许可方',
        please_select_payee_error_message: '请选择收款人',
        please_select_platform_error_message: '请选择平台',
        please_select_channel_error_message: '请选择频道',
        please_select_region_error_message: '请选择地区',
        please_select_content_error_message: '请选择内容',
        please_select_play_time_error_message: '请选择游玩时间',
        please_select_media_category_type_error_message: '请选择媒体类别类型',
        please_select_genres_media_episode_error_message: '请选择类型',
        please_select_department_error_message: '请选择部门',
        please_enter_title_error_message: '请输入标题',
        please_enter_description_error_message: '请输入描述',
        please_enter_name_error_message: '请输入姓名',
        please_enter_phone_no_error_message: '请输入电话号码',
        please_enter_email_error_message: '请输入有效的电子邮件',
        please_select_roletype_error_message: '请选择角色类型',
        please_enter_user_name_users_error_message: '请输入用户名',
        please_enter_password_users_error_message: '请输入密码',
        invalid_duration_error_message: '请输入有效期限',
        please_attach_atleast_one_media_episode_group_error_message: '请附上至少一种媒体',
        please_add_atleast_one_module_rights_users_error_message: '请添加至少一个模块权限',
        please_select_reportingto_user_error_message: '请选择报告对象',
        please_select_sales_team_error_message: '请选择销售团队',
        exhibition_should_not_be_zero_error_message: '展览应大于零',
        repeat_should_not_be_zero_error_message: '重复次数应大于零',
        play_time_number_should_not_be_zero_error_message: '播放时间数应大于零',
        end_date_should_be_greater_than_start_date_error_message: '结束日期应晚于开始日期',
        please_attach_atleast_one_media_contract_error_message: '请附上至少一种媒体',
        please_select_season_content_series_error_message: '请选择季节内容',
        value_is_not_greater_then_zero_season_number_series_error_message: '季节编号应大于零',
        please_select_epiosde_content_series_error_message: '请选择剧集内容',
        value_is_not_greater_then_zero_episode_number_series_error_message: '集数应大于零',
        please_attach_series_season_error_message: '请附上系列',
        please_add_atleast_one_season_series_error_message: '请添加至少一季',
        entering_same_season_number_twice_series_error_message: '输入同一季号码两次',
        enter_title_expender: '输入标题',
        please_select_poster_type_first_media_episode_poster_error_message: '请选择海报类型',
        please_select_url_first_media_episode_poster_error_message: '请先选择网址',
        please_select_the_value_in_start_date_media_episode_publishing_error_message: '请选择开始日期中的值',
        please_select_the_value_in_end_date_media_episode_publishing_error_message: '请选择结束日期中的值',
        you_delete_this_deal_right_from_contract_only_media_episode_publishing_error_message: '您只能从合同中删除此交易！',
        please_select_ottvideo_type_media_episode_video_error_message: '请选择视频类型',
        create_dialog_header: '创建',
        synopsis_can_not_be_null_media_episode_Synopsis_error_message: '概要不能为空',
        please_select_language_media_episode_Synopsis_error_message: '请选择语言',
        please_enter_name_cast_crew_media_episode_error_message: '请输入姓名',
        please_select_casttype_cast_crew_media_episode_error_message: '请输入演员类型',
        please_select_segment_type_media_episode_version_error_message: '请选择航段类型',
        please_generate_segments_first_media_episode_version_error_message: '请生成段',
        media_episode_entity_duration_segment_error_message: '实际持续时间为空。请更新“应用分段的持续时间”中的有效持续时间',
        please_select_brand_media_episode_error_message: '请选择品牌',
        please_select_product_media_episode_error_message: '请选择产品',
        please_enter_value_media_episode_error_message: '请输入值',
        please_enter_valid_value_tcin_should_not_be_greater_than_tcout_media_episode_error_message: '请输入有效值，TcIn 不应大于 TcOut',
        error_while_generating_house_number_media_episode_error_message: '生成门牌号码时出错',
        already_exists_global_error_message: '已经存在了！！',
        you_can_update_this_deal_right_from_contract_only_media_episode_publishing_error_message: '您只能根据合同直接更新此交易！',
        this_segment_is_already_been_scheduled_segmnet_media_episode_error_message: '该段已安排',
        please_enter_title_display_rails_error_message: '请输入标题显示',
        atleast_attach_one_ottassets_rails_error_message: '至少附加一项 OttAssets',
        please_enter_enter_icon_uel_error_message: '请输入图标网址',
        create_label: '创建',
        edit_lable: '编辑',
        select_label: '选择',
        please_select_media_category_type_first_media_episode_group_error_message: '请先选择媒体类别类型',
        please_select_role_users_error_message: '请选择角色',
        user_name_error_message: '具有相同用户名的用户/销售主管',
        no_data_found_scheduling_reconciliation_error_message: '没有找到数据！',
        schedule_and_as_run_data_load_successfully_scheduling_reconciliation_success_message: '计划和 AsRun 数据加载成功',
        error_while_loading_as_run_data_scheduling_reconciliation_error_message: '加载 AsRun 数据时出错：',
        auto_recocile_successfully_scheduling_reconciliation_success_message: '自动对账成功！！',
        select_first_scheduling_reconciliation_error_message: '请选择要匹配的计划和运行项目！',
        already_reconsiled_scheduling_reconciliation_error_message: '已经重新协商了！',
        select_item_have_different_assetid_scheduling_reconciliation_error_message: '所选项目有不同的 AssetId ！',
        force_unmatch_successfully_scheduling_reconciliation_success_message: '强制无敌成功！！',
        please_select_schedule_and_as_run_item_scheduling_reconciliation_error_message: '请选择日程和AsRun项目！',
        select_item_is_not_reconsiled_scheduling_reconciliation_error_message: '所选项目未重新核对！',
        select_schedule_and_asrun_item_not_reconciled_together_scheduling_reconciliation_error_message: '选定的计划和正在运行的项目未协调在一起',
        select_schedule_item_already_billed_error_message: '所选计划项目已计费。',
        saved_successfully_scheduling_reconciliation_success_message: '保存成功！！！',
        role_type_label: '角色类型',
        please_load_first_scheduling_reconciliation_error_message: '请先加载！！',
        tx_mode_label: '发射模式',
        segment_count_label: '段数',
        create_segment_type_dialog_header: '创建段类型',
        please_enter_type_name_segment_type_error_message: '请输入类型名称',
        please_select_tx_mode_segment_type_error_message: '请选择发送模式',
        please_enter_segment_count_segment_type_error_message: '请输入段数',
        interstitial_group_sub_menu: '插页式组',
        program_group_sub_menu: '节目组',
        variation_page_breadcrumb: '变化',
        breakformat_page_breadcrumb: '中断格式',
        payment_provider_page_breadcrumb: '支付提供商',
        ott_period_type_page_breadcrumb: '奥特周期类型',
        payment_type_page_breadcrumb: '付款方式',
        ott_period_page_breadcrumb: '时期',
        subscriber_page_breadcrumb: '订户',
        media_type_label: '媒体类型',
        atleast_attach_one_item_variation_error_message: '至少附加一件物品',
        please_select_media_type_error_message: '请选择媒体类型',
        season_number_should_not_be_zero_error_message: '季节号应大于零',
        number_of_epiosde_should_not_be_zero_error_message: '集数应大于零',
        starting_epiosde_should_not_be_zero_error_message: '起始剧集应大于零',
        please_select_potraitimageurl_otteditform_error_message: '请选择肖像图片网址',
        please_select_landscapeimageurl_otteditform_error_message: '请选择风景图片网址',
        include_pre_opening_label: '包括开盘前',
        include_closing_label: '包括结束语',
        break_number_column: '休息号码',
        break_duration_column: '休息时间',
        commercial_duration_column: '商业时长',
        promo_duration_Column: '促销持续时间',
        total_break_duration_label: '总休息时间',
        segment_count_should_be_zero_error_message: '段数应大于 1',
        invalid_slot_duration_error_message: '无效时段持续时间',
        invalid_total_break_duration_error_message: '总休息时间无效',
        break_not_distribute_breakformat_error_message: '休息时间未分配',
        slot_duration_should_Be_greater_than_total_break_duration_breakformat_error_message: '时段持续时间应大于总休息持续时间',
        break_count_segment_count_does_not_match_breakformat_error_message: '中断计数和段计数不匹配',
        please_enter_template_name_error_toast: '请输入模板名称',
        please_select_module_type_error_message: '请选择模块类型',
        please_select_ingestion_template_type_error_message: '请选择摄取模板类型',
        saved_successfully_message: '保存成功',
        please_enter_code_error_message: '请输入代码',
        please_select_agency_error_message: '请选择代理机构',
        please_select_default_tax_error_message: '请选择默认税费',
        please_select_agency_type_error_message: '请选择代理机构类型',
        please_select_atleast_one_Sales_executive: '请选择至少一名销售主管',
        add_sales_executive_button_tooltip: '添加销售主管',
        please_enter_prefix_error_message: '请输入前缀',
        please_enter_suffix_error_message: '请输入后缀',
        please_attach_atleast_one_media_error_message: '请附上至少一种媒体',
        please_enter_full_Channel_name_error_message: '请输入完整频道名称',
        please_enter_short_Channel_name_error_message: '请输入频道短名称',
        please_select_atleast_one_repeat_pattern_error_message: '请选择至少一项重复！',
        primary_delete_succesfully_repeat_pattern_error_message: '初次删除成功',
        repeat_delete_succesfully_repeat_pattern_error_message: '重复删除成功',
        please_select_atleast_one_days_repeat_pattern_error_message: '请至少选择一天！',
        please_enter_automation_channel_name_error_message: '请输入自动化通道名称',
        please_enter_epg_code_error_message: '请输入EPG代码',
        please_select_automation_error_message: '请选择自动化',
        please_enter_color_error_message: '请输入颜色',
        please_add_atleast_one_module_role_error_message: '请添加至少一个模块！',
        data_loaded_successfully_ingestion_template_message: '数据加载成功',
        please_enter_positive_value_in_creditlimit_error_message: '请在 CreditLimit 中输入正值',
        please_enter_gst_no_error_message: '请输入商品及服务税号',
        please_enter_campaign_no_error_message: '请输入活动编号',
        please_select_client_error_message: '请选择客户',
        period_from_should_be_less_then_periodto_campaign_error_message: 'periodFrom 应小于 periodTo',
        commission_exceeded_limit_from_less_than_100_campaign_error_message: '佣金超出允许的限额（必须小于 100）。',
        discount_exceeded_from_limit_less_than_100_campaign_error_message: '折扣超过允许的限额（必须小于 100）。',
        please_enter_target_budget_error_message: '请输入目标预算',
        please_enter_target_spots_error_message: '请输入目标地点',
        please_enter_target_seconds_error_message: '请输入目标秒数',
        please_attach_atleast_one_commercials_campaign_error_message: '请附上至少一则广告',
        please_attach_atleast_one_channel_campaign_error_message: '请附上至少一个频道',
        please_select_campaign_type_error_message: '请选择活动类型',
        please_enter_rate10sec_error_message: '请选择速率10秒',
        please_enter_fct_error_message: '请输入 FCT',
        please_enter_from_date_error_message: '请输入开始日期',
        please_enter_to_date_error_message: '请输入截止日期',
        please_enter_amount_error_message: '请输入金额',
        data_loading_error_message: '数据加载中...',
        no_record_found_error_message: '没有找到记录！',
        total_sum_spot_rate_success_message: '总即期汇率',
        total_fct_success_message: '总 FCT',
        booking_is_used_in_schedule_show_spot_error_message: '预订已在时间表中使用',
        changes_Will_Reflect_in_new_planned_items_only_segmenttype_error_message: '更改仅反映在新计划的项目中',
        please_select_campaign_first_booking_error_message: '请先选择活动',
        error_reading_file_booking_error_message: '读取文件时出错',
        wrong_month_selected_booking_error_message: '选择了错误的月份',
        wrong_year_selected_booking_error_message: '选择了错误的年份',
        error_downloading_template_booking_error_message: '下载模板时出错',
        please_select_a_value_to_update_booking_error_message: '请选择要更新的值',
        exceding_target_spots_limit_booking_error_message: '超出目标点限制',
        exceding_target_budget_booking_error_message: '超出目标预算',
        commercials_not_updated_in_line_no_booking_error_message: '广告未更新在线否',
        exceding_target_seconds_booking_error_message: '超出目标秒数',
        booking_saved_booking_error_message: '预订已保存',
        no_data_found_booking_error_message: '没有找到数据',
        from_time_should_be_less_than_To_time_booking_error_message: '从时间应该小于到时间',
        please_enter_spot_booking_error_message: '请输入现货',
        please_enter_rate_booking_error_message: '请输入费率',
        please_select_transfer_from_date_booking_transfer_error_message: '请选择转账起始日期',
        please_select_transfer_date_booking_transfer_error_message: '请选择转账日期',
        please_select_item_booking_transfer_error_message: '请先选择商品！',
        booking_transfer_succesfully_to_booking_transfer_error_message: '预订成功转移至',
        exceding_target_spots_limit_update_booking_line_number_error_message: '超出目标点限制',
        exceding_target_budget_update_booking_line_number_error_message: '超出目标预算',
        exceding_target_seconds_update_booking_line_number_error_message: '超出目标秒数',
        loading_data_update_booking_line_number_error_message: '正在加载数据！！',
        data_loaded_update_booking_line_number_success_message: '数据加载成功！！',
        loading_booking_update_booking_line_number_success_message: '正在加载预订...',
        bill_is_already_generated_for_this_linenumber_update_booking_line_number_success_message: '已为此 LineNumber 生成账单！',
        please_select_file_error_message: '请选择文件',
        downlaod_file_error_message: '下载文件',
        no_import_type_defined_error_message: '未定义导入类型',
        upload_Successfully_import_success_message: '上传成功',
        asrun_Save_Successfully_import_success_message: 'AsRun 保存成功',
        asrun_save_failed_import_error_message: 'AsRun 保存失败',
        update_failed_import_error_message: '上传失败',
        assest_not_found_import_message: '未找到资产',
        planning_imported_successfully_import_message: '规划导入成功',
        import_planning_failed_import_message: '导入计划失败。',
        read_to_upload_import_message: '阅读并上传',
        please_select_from_date: '请选择开始日期',
        please_select_to_date_greater_than_from_date_error_message: '请选择“截止日期”大于“起始日期”',
        please_select_the_value_in_template_name_first_export_report_error_message: '请先选择模板名称中的值！',
        please_select_the_value_in_format_first_export_report_error_message: '请先选择格式中的值',
        please_add_at_least_one_item_list_export_report_error_message: '请添加至少一项项目列表。',
        please_select_the_value_in_filters_first_export_report_error_message: '请先选择过滤器中的值。',
        Please_select_the_value_in_Operator_first_export_report_error_message: '请先选择运算符中的值。',
        value_can_not_be_null_export_report_error_message: '值不能为空',
        report_is_exported_successfully_message: 'EPG导出成功',
        content_report_is_exported_successfully_message: '报告导出成功',
        please_select_valid_dates_export_template_error_message: '请选择有效日期',
        exporting_data_please_wait_export_template_error_message: 'Exporting data please wait....',
        successfully_exported_export_template_message: '成功导出',
        no_data_found_to_export_template_message: '没有找到要导出的数据',
        please_select_the_value_in_available_column_export_template_error_message: '请在可用列中选择值',
        please_enter_display_name_error_message: '请输入显示名称',
        please_enter_savetempleteas_export_template_error_message: '请输入模板另存为',
        please_add_column_atleast_one_item_export_template_error_message: '请添加至少一栏',
        is_saved_successfully_export_template_message: '保存成功',
        please_select_module_error_message: '请选择模块',
        please_enter_id_error_message: '请输入身份证号',
        please_select_source_error_message: '请选择来源',
        please_select_atleast_one_secondary_events_error_message: '请选择至少一项次要活动',
        invalid_startoffset_error_message: '无效的起始偏移量',
        invalid_endoffset_error_message: '无效的结束偏移',
        please_enter_text_no_error_message: '请输入文字编号',
        please_select_the_value_in_rule_first_error_message: '请先选择规则中的值',
        please_attach_atleast_one_prototype_stylesheet_error_message: '请附上至少一个原型',
        please_enter_formula_error_message: '请输入公式',
        please_wait_loading_data_billing_error_message: '请稍候，正在加载数据...',
        data_loaded_successfully_billing_template_message: '数据加载成功',
        please_select_a_billing_detail_first_billing_template_message: '请先选择账单明细！',
        no_reconciled_spots_found_for_selected_details_billing_template_message: '未找到所选详细信息的协调点！',
        please_select_bank_billing_error_message: '请选择银行！',
        please_select_tax_billing_error_message: '请选择税费！',
        please_select_brand_billing_error_message: '请选择品牌！',
        no_invoice_details_are_available_to_bill_billing_error_message: '没有可用于计费的发票详细信息！',
        campaign_brands_label: '品牌',
        all_label: '全部',
        selected_brand: '精选品牌',
        selected_channel: '选定频道',
        brand_label: '品牌',
        please_select_file_first_datamigration_error_message: '请先选择文件！！！',
        empty_media_grid_datamigration_error_message: '请在下面的网格中加载数据以导入！',
        please_select_type_datamigration_error_message: '请选择类型！！',
        imported_successfully_datamigration_success_message: '导入成功',
        please_select_language_error_message: "请选择语言",
        please_select_logo_url_first_error_mesage: '请先选择徽标网址。',
        please_select_segment_type_and_channel_format_error_message: '请选择分段类型和通道',
        new_create_formfield_dialog_header: '新创造',
        please_select_segment_type_format_error_message: '请选择航段类型',
        not_allowed_for_segments_format_error_message: '不允许段',
        cannot_delete_segments_format_error_message: '无法删除段',
        select_atleast_one_mediaDealRight_planner_error_message: '选择至少一项媒体交易权',
        first_copy_planner_items_you_want_to_paste_planner_error_message: '首先复制要粘贴的计划表项目。',
        please_select_area_on_planner_where_to_paste_planner_error_message: '请在规划器上选择要粘贴的区域。',
        from_date_cant_be_greater_than_to_date_paste_planner_error_message: '起始日期不能大于截止日期！',
        call_planner_error_message: '打电话',
        data_copy_schedule_please_wait_copyschedule_error_message: '正在检查复制计划的验证，请稍候......',
        copy_schedule_data_copyschedule_successfully_message: '复制计划数据复制成功....',
        no_data_found_to_copy_schedule_error_message: '找不到可复制时间表的数据',
        applying_recursive_pattern_please_wait_planner_error_message: '正在应用递归模式，请稍候...',
        recursive_pattern_applied_successfully_planner_success_message: '递归模式成功应用',
        pasted_pattern_planner_error_message: '粘贴的',
        items_pattern_planner_error_message: '项目',
        to_date_is_mandatory_recursive_error_message: '迄今为止是强制性的。',
        to_date_should_be_greater_than_base_program_start_date_recursive_error_message: '迄今为止应晚于基本计划开始日期',
        select_one_item_to_open_schedule_planner_helper_error_message: '选择一项以打开日程表',
        copy_button_text: '复制',
        open_schedule_button_text: '开放时间表',
        paste_button_text: '粘贴',
        delete_button_text: '删除',
        error_fetching_channel_list_planning_wrapper_error_message: '获取频道列表时出错',
        please_select_planning_item_planning_wrapper_error_message: '请选择规划项目',
        recursive_applied_successfully_planning_wrapper_message: '递归应用成功！',
        select_program_group_label: '选择节目组',
        select_break_format__label: '选择中断格式',
        please_enter_template_name_to_save_template_planningfilter_error_message: '请输入模板名称以保存模板',
        selected_content_text_planning_footer: '精选内容',
        copied_content_text_planning_footer: '复制内容',
        first_copy_planner_items_you_want_to_paste_planning_performance_error_message: '首先复制要粘贴的计划表项目。',
        please_select_area_on_planner_where_to_paste_planning_performance_error_message: '请在规划器上选择要粘贴的区域。',
        select_atleast_one_mediadealright_planning_performance_error_message: '正确选择至少一项交易',
        first_select_replace_items_global_replacement_error_message: '首先选择替换项目',
        please_select_content_to_delete_planning_performance_error_message: '请选择要删除的内容',
        not_allowed_Control_with_schedule_planning_performance_error_message: '不允许，按计划控制',
        entry_already_exist_try_with_different_values_collection_error_message: '条目已存在，请尝试使用不同的值。',
        please_select_first_collection_error_message: '请先选择！',
        already_attached_collection_error_message: '已经附上了！！',
        export_current_booking_tooltip: 'Export Current Booking',
        export_saved_booking_tooltip: 'Export Saved Booking',
        please_select_poster_type_error_message: '请选择海报类型',
        browser_button_text: '浏览',
        file_selected_label: '选定文件',
        only_jpg_jpeg_and_png_files_are_allowed_msg: '只允许 jpg/jpeg 和 png 文件！',
        please_add_programs_format_error_message: '请添加程序格式',
        please_select_atleast_one_item: '请至少选择一项。',
        please_enter_season_number_error_message: '请输入季号',
        repeat_pattern_label: '重复模式',
        select_repeat_pattern_collection_header: '选择重复模式',
        please_select_from_date_error_message: '请选择开始日期',
        please_select_to_date_error_message: '请选择截止日期',
        please_select_to_date_grater_then_from_date_error_message: '请选择“截止日期”大于“起始日期”',
        parent_content_category_label: '家长内容类别',
        rail_will_be_added_soon2_label: '铁路即将添加2！',
        rail_will_be_added_soon3_label: '铁路即将添加3！',
        no_select_image_error_message: '无选择图像',
        please_enter_key_error_message: '请输入密钥',
        please_enter_value_error_message: '请输入值',
        please_wait_generating_bill: '生成比尔。请稍等...',
        bill_generated_successfully: '账单生成成功',
        please_select_template_error_message: '请选择模板',
        please_select_file_first_error_message: '请先选择文件！',
        please_enter_first_error_message: '请先输入！',
        please_select_channel_first: '请先选择频道',
        please_select_start_date_error_message: '请选择开始日期',
        please_select_end_date_error_message: '请选择结束日期',
        please_enter_valid_sequnce_number_error_message: '请输入有效的序列号',
        program_schedule_clash_breadcrumb: '节目时间表冲突',
        clash_channel_column: '冲突频道',
        clashed_time_Column: '冲突时间',
        source_time_Column: '源时间',
        no_data_found_error_message: '没有找到数据！',
        movie_name_column: '电影名称',
        create_ott_period_type_dialog_header: '创建奥特时期',
        create_subscriber_dialog_header: '创建订阅者',
        play_type_label: '玩法类型',
        ott_period_type_label: '奥特周期类型',
        please_enter_play_time_error_message: '播放时间应大于零',
        please_select_play_type_error_message: '请选择游戏类型',
        please_select_ott_period_type_error_message: '请选择奥特经期类型',
        ott_period_label: '奥特时期',
        payment_type_label: '付款方式',
        trials_tab_label: '试炼',
        fixed_trials_tab_label: '固定试验',
        reminders_tab_label: '提醒事项',
        payment_Provider_label: '支付提供商',
        send_label: '提醒',
        dayPrior_label: '事先提醒日',
        enable: '启用',
        trials_dialog_header: '试炼',
        reminders_dialog_header: '提醒事项',
        add_trial_button_tooltip: '添加试用',
        add_reminders_button_tooltip: '添加提醒',
        paymentPlan_sub_menu: '付款计划',
        please_select_Payment_Provider_error_message: '请选择支付提供商',
        please_select_PlayType_error_message: '请选择游戏类型',
        please_select_OttPeriod_error_message: '请选择奥特时期',
        please_select_Currency_error_message: '请选择货币',
        please_select_PaymentType_error_message: '请选择付款方式',
        ott_product_sub_menu: '产品',
        ott_product_label: '产品',
        sales_status_label: '销售状况',
        geo_Region_label: '地理区域',
        create_ott_product_type_dialog_header: '创建奥特产品',
        please_select_geo_region_error_message: '请选择地理区域',
        please_select_sales_status_error_message: '请选择销售状态',
        please_select_Payment_Plan_error_message: '请选择付款计划',
        show_app_bar_label: '显示应用栏',
        isHomePage_label: '是主页',
        route_type_label: '航线类型',
        page_label: '页面',
        rails_l_label: 'L',
        rails_uat_label: 'U',
        live_label: '居住',
        uat_label: 'UAT',
        media_is_already_attached_with_another_asset_error_message: '媒体已附加另一个资产',
        add_payment_plan_tooltip: '添加付款计划',
        trial_price_label: '试用价',
        trial_days_label: '试用日',
        sort_index_label: '排序索引',
        hide: '隐藏',
        select_payment_plan_collection: '选择付款计划',
        payments_dialog_header: '付款方式',
        daysBefore_label: '几天前',
        subscription_id_label: '订阅ID',
        package_label: '套餐',
        last_updated_label: '最后更新',
        please_enter_subscription_id_error_message: '请输入订阅ID',
        please_enter_package_error_message: '请输入套餐',
        please_enter_last_update_error_message: '请输入最后更新',
        please_select_route_type: "请选择路线类型",
        please_select_video_playback_url: '请选择视频播放网址',
        please_select_page: '请选择页面',
        ott_campaign_page_breadcrumb: '活动',
        edit_campaign_editpage_header: '编辑奥特竞选活动',
        add_rails_button_tootip: '添加导轨',
        select_rails_collection: '选择导轨',
        publish_column: '出版',
        from_date_should_be_less_than_to_date_error_message: '起始日期应小于截止日期',
        please_select_rails_error_message: '请选择至少一轨',
        ott_rails_type_column: '奥特导轨类型',
        add_above_option: '添加上面',
        add_below_option: '添加如下',
        select_any_one_collection_selection_error_message: '选择任意一项',
        please_attach_media_first: '请附上媒体',
        edit_actionbutton_option: '编辑',
        asset_label: '资产ID',
        job_id_label: '职位编号',
        job_started_label: '开始',
        job_finished_label: '完成',
        elapsed_label: '已过去',
        job_input_file_label: '输入文件',
        media_type_column: '媒体类型',
        file_location_column: '文件位置',
        attach_media_button_tooltip: '附加媒体',
        attach_media_button_text: '附加媒体',
        select_media_collection_header: "选择媒体",
        assets_label_ott_collection: '资产',
        select_assets_collection_header: "选择资产",
        some_bookings_are_already_Scheduled_Could_not_transfer_error_message: '部分预订已安排，无法转让',
        jobs_title: '工作机会',
        total_assets_label: '总资产',
        makegoodspot_sub_menu: '做好准备',
        makegoodspot_title: '做好准备',
        makegoodspottransfer_dialog_header: '做好现货转让',
        select_item_date_between_from_and_to_error_message: '选定的转移日期应介于活动期间的起始日期和截止日期之间',
        please_transfer_error_date_greater_than_bookingdate_message: '请选择大于当前预订日期的接送日期！',
        latest_jobs_label: '最新职位',
        invalid_date_range_copy_to_planning_error_message: '复制到日期范围无效',
        invalid_date_range_copy_from_planning_error_message: '副本起始日期范围无效',
        date_range_between_seven_day_copy_from_planning_error_message: '复制起始日期范围应在 31 天内',
        date_range_between_seven_day_copy_to_planning_error_message: '复制截止日期范围应在 31 天内',
        height_label: "身高",
        create_ott_asset_label: '创建奥特资产',
        media_label: '媒体*',
        recent_jobs_label: '最近的工作',
        please_select_type_error_message: '请选择类型',
        create_schedule_constraints_editpage_header: '创建计划约束',
        schedule_constraints_error_message: '时间表限制',
        constraints_lable: '约束条件',
        fill_under_run_button_tooltip: '根据变化和默认格式填写时间表',
        resetautofill_button_tooltip: '重置自动填充',
        please_select_amount_error_message: '请选择金额',
        please_enter_sort_index_error_message: '请输入排序索引',
        please_enter_trial_price_error_message: '请输入试用价格',
        please_enter_trial_days_error_message: '请输入试用天数',
        please_select_reminder_error_message: '请选择提醒',
        please_enter_days_before_error_message: '请输入前天数',
        enable_reminder_label: '启用提醒',
        coupon_page_breadcrumb: '优惠券',
        discount_type_label: '折扣类型',
        discount_value_label: '折扣值',
        create_coupon_dialog_header: '创建优惠券',
        please_select_discount_type_error_message: '请选择折扣类型',
        percentage_can_not_be_greater_than_error_message: '百分比不能大于100',
        enable_fixed_trial_label: '启用固定试用',
        limited_period_label: '限期',
        valid_from_label: '有效期自',
        valid_to_label: '有效期至',
        please_select_valid_from_date_error_message: '请选择有效日期',
        please_select_valid_to_date_error_message: '请选择有效至',
        discount_should_be_greater_then_zero_error_message: '折扣应大于零',
        please_select_valid_date_error_message: '请选择有效日期',
        payment_plan_label: '付款计划',
        coupon_label: '优惠券',
        add_coupon_tooltip: '添加优惠券',
        select_coupon_collection: '选择优惠券',
        code_column: '代码',
        discount_type_column: '折扣类型',
        discount_value_column: '折扣值',
        audit_log_menu: '审核日志',
        audit_log_breadcrumb: '审核日志',
        genre_sub_menu: '类型',
        media_category_sub_menu: '媒体类别',
        genre_page_breadcrumb: '类型',
        media_category_page_breadcrumb: '媒体类别',
        module_label: '模块',
        event_label: '活动',
        please_select_event_error_message: '请选择活动',
        download_button_tooltip: '下载',
        date_time_label: '日期时间',
        confirm_password_label: '确认密码',
        password_do_not_match_error_message: '密码不匹配',
        please_enter_confirm_password_users_error_message: '请输入确认密码',
        atleast_attach_atleast_one_platform_error_message: '请选择至少一个平台',
        upload_file_button_tooltip: '上传文件',
        role_tab_label: '角色',
        add_channel_button_text: '添加频道',
        select_channel_collection_header: '选择频道',
        please_add_atleast_one_channel_users_error_message: '请添加至少一个频道',
        please_select_order_date_error_message: '请选择订购日期',
        please_select_period_from_date_error_message: '请选择期间',
        please_select_period_to_date_error_message: '请选择期间至',
        please_select_deal_type_error_message: '请选择交易类型',
        please_select_location_error_message: '请选择地点',
        please_select_product_error_message: '请选择产品',
        ott_segment_sub_menu: '段',
        payment_plan_page_breadcrumb: '付款计划',
        ott_segment_page_breadcrumb: '段',
        create_segment_dialog_header: '创建细分',
        segment_label: '段',
        please_select_segment_error_message: '请选择细分',
        monetization_dashboard: '货币化',
        segment_by_subscribe_label: '按订阅者细分',
        segment_by_product_label: '按产品细分',
        products_column: '产品展示',
        total_coupon_column: '总优惠券',
        total_subscriber_column: '订阅者总数',
        coupon_name_column: '优惠券名称',
        pgrating_sub_menu: 'PG 评级',
        pgrating_page_breadcrumb: 'PG 评级',
        open_in_a_new_tab_label: '在新选项卡中打开',
        column_preference_label: '列首选项',
        parent_label: '家长',
        vod_channel_label: '点播频道',
        overrun_underrun_label: '超载和欠载',
        copy_count_label: '份数',
        selected_header_label: '选定的标题',
        selected_count_label: '选定数量',
        platform_column: '平台',
        please_enter_old_password_users_error_message: '请输入旧密码',
        old_password_does_not_match_error_message: '旧密码不匹配',
        please_enter_new_password_error_message: '请输入新密码',
        confirm_password_do_not_match_error_message: '确认密码不匹配',
        old_password_label: '旧密码',
        new_password_label: '新密码',
        account_label: '账户',
        change_password_label: '更改密码',
        log_out_label: '退出',
        media_by_category_menu: '媒体按类别',
        movie_label: '电影',
        season_label: '季节',
        view_details_label: '查看详情',
        executive_label: '行政人员',
        subscriber_label: '订户',
        confirm_logout_label: '确认退出',
        are_you_sure_you_want_to_generate_payment: '您确定要生成付款吗？',
        yes_label: '是的',
        no_label: '否',
        confirm_delete_label: '确认删除',
        are_you_sure_you_want_to_delete: '您确定要删除吗？',
        scheduling_label: '调度',
        planning_label: '规划',
        options_label: '选项',
        un_archive_label: '取消存档',
        create_from_label: '创建自',
        category_label: '类别',
        select_category_label: '选择类别',
        grid_view_label: '网格视图',
        tile_view_label: '平铺视图',
        linear_label: '线性',
        non_linear_label: '非线性',
        audit_log_label: '审核日志',
        entry_date_and_time_column: '报名日期时间',
        event_column: '活动',
        user_column: '用户',
        close_button_tooltip: '关闭',
        apply_recursive_button_text_planning: '应用递归',
        history_button_text_planning: '历史',
        open_schedule_button_text_planning: '开放时间表',
        insert_program_group_label_planning: '插入程序组',
        export_planner_button_text: 'Export Planner',
        export_epg_button_text: 'Export EPG ',
        planning_loaded_label: '规划已加载',
        planning_loading_error_label: '计划加载错误',
        error_fetching_planning_data_error_message: '获取计划数据时出错',
        planning_loading_label: '计划装载',
        creating_label: '创造',
        successfully_created_group_label: '创建群组成功！',
        pasted_label: '粘贴的',
        items_label: '项目',
        last_updated_from_label_msg: '最后更新自',
        cannot_delete_segment_label_msg: '无法删除段',
        cannot_delete_header_label_msg: '无法删除标题，请在标题上右键单击使用删除标题',
        select_item_to_error_message: '选择项目',
        cannot_cut_footer_msg_scheduling: '无法剪切页脚。',
        cannot_delete_multiple_footer_msg_scheduling: '无法删除多个页脚。',
        cannot_delete_multiple_footer_please_select_one_footer_at_a_time_msg_scheduling: '无法删除多个页脚，请一次选择一个页脚。',
        no_item_selected_to_copy_msg_scheduling: '没有选择要复制的项目',
        cannot_copy_segment_msg_scheduling: '无法复制 - SEGMENT',
        cannot_copy_break_msg_scheduling: '无法复制 - 中断',
        cannot_copy_header_msg_scheduling: '无法复制 - 标题',
        deleting_footer_msg_scheduling: '删除页脚',
        footer_deleted_msg_scheduling: '页脚已删除',
        no_footer_to_deleted_error_message: '没有页脚可删除',
        all_footer_deleted_error_message: '所有页脚已删除',
        there_are_some_at_server_side_please_contact_admin: '服务器端有一些，请联系管理员',
        loading_schedule_please_wait_msg_scheduling: '正在加载时间表，请稍候...',
        loading_schedule_completed_msg_scheduling: '加载计划已完成！',
        please_selct_one_item_msg_scheduling: '请选择一项',
        no_media_selected_msg_scheduling: '未选择媒体',
        deleted_secondary_events_msg_scheduling: '已删除的次要事件',
        all_secondary_events_deleted_successfully_msg_scheduling: '所有次要事件已成功删除！',
        style_sheet_applied_successfully_msg_scheduling: '样式表应用成功！',
        secondary_event_updated_msg_scheduling: '次要活动已更新',
        no_secondary_events_error_message: '无次要事件',
        select_target_item_from_schedule_error_message: '从计划中选择目标项目',
        first_cut_or_copy_item_error_message: '首先剪切或复制项目。',
        please_select_Item_to_paste_error_message: '请选择要粘贴的项目。',
        Please_select_one_Item_where_need_to_paste_error_message: '请选择一项，需要粘贴到的位置。',
        delete_msg: '删除',
        cut_msg: '删除',
        cannot_segment_please_unselect_segment_error_message: '分段无法删除，请取消选择分段',
        cannot_delete_header_please_unselect_header_error_message: '标题无法删除，请取消选择标题或使用右键删除标题选项。',
        Confirmation_label: '确认',
        are_you_sure_you_want_to_delete_footer_label: '您确定要删除页脚吗？',
        Are_you_sure_you_want_to_items_label_confirm_alert: '您确定要吗',
        cannot_select_footer_error_message: '无法选择页脚。',
        cannot_multi_select_items_from_different_headers_error_message: '无法从不同的标题中选择多个项目。',
        please_select_first_error_message: '请先选择。',
        cannot_select_items_from_different_headers_error_message: '无法从不同的标题中选择项目。',
        please_choose_right_media_categor_error_message: '请选择正确的媒体类别',
        prototype_drop_not_allowed_for_headers_error_message: '标头不允许原型删除',
        break_type_item_is_not_allowed_error_message: '不允许使用中断类型的项目。',
        cannot_move_segment_to_different_program_schedule_error_message: '无法将片段移至不同的节目表',
        prototype_drop_not_allowed_for_headers_and_footers_error_message: '页眉和页脚不允许使用原型放置',
        please_select_header_firsts_error_message: '请先选择标题',
        cannot_delete_selected_header_contains_booked_commercials_error_message: '无法删除！！选定的标题包含预订的广告',
        cannot_delete_selected_header_contains_reconciled_items_error_message: '无法删除！！选定的标头包含已调节的项目',
        confirm_delete_header_confirm_alert_msg: '确认删除标头',
        are_you_sure_you_want_to_delete_confirm_alert_msg: '您确定要删除吗',
        select_one_program_to_replace_with_error_message: '选择一个程序来替换',
        header_from_confirm_alert_msg: '标题来自',
        please_select_schedule_item_error_message: '请选择日程项目',
        not_allowed_on_this_postion_error_message: '此职位不允许',
        please_select_one_item_error_message: '请选择一项',
        no_secondary_events_attached_to_delete_error_message: '没有附加要删除的次要事件',
        prototype_drop_not_allowed_for_break_error_message: '原型掉落不允许中断',
        added_secondary_events_success_message: '添加了次要事件',
        please_load_schedule_first_error_message: '请先加载时间表。',
        variations_are_not_available_info_message: '没有可用的变体',
        process_completed_success_message: '流程已完成',
        select_atleast_one_header_error_message: '选择至少一个标题',
        user_favourite_page_breadcrumb: '最爱',
        please_enter_template_name_to_save_template_error_message: '请输入模板名称以保存模板',
        rmn_label: 'RMN',
        please_enter_rmn_error_message: '请输入 RMN 号码',
        expand_collapse_headers_label: '展开/折叠标题',
        pages_label: '页数',
        total_product_column: '总产品',
        update_synopsis: '更新概要',
        invalid_time_range: '无效时间范围',
        schedule_automatic_break_tooltip: '创建自动休息时间',
        select_icon_url_collection_header: '选择图标',
        planningdistributionformat_sub_menu: '规划分配格式',
        planningdistributionformat_page_breadcrumb: '规划分配格式',
        edit_planningdistributionformat_editpage_header: '编辑计划分配格式',
        create_planningdistributionformat_editpage_header: '创建计划分配格式',
        subtitle_label: '副标题',
        subtitle_type_label: '字幕类型',
        please_select_segment_type_error_message: '请选择航段类型',
        audio_track_label: '音轨',
        track_number_label: '曲目编号',
        add_language_group_prototype_button_tooltip: '添加语言组',
        add_language_group_prototype_button_text: '添加语言组',
        please_enter_track_number_error_message: '请输入曲目编号',
        please_select_atleast_one_language_error_message: '请选择至少一种语言',
        language_already_added_error_message: '语言已添加',
        track_number_already_added_error_message: '曲目编号已添加',
        please_select_atleast_one_rule_error_message: '请选择至少一项规则',
        update_template_label: '更新模板',
        media_category_type_sub_menu: '媒体类别类型',
        media_sub_category_type_sub_menu: '媒体子类别类型',
        work_order_dashboard: '工单',
        todo_tile_label: '待办事项',
        in_progress_tile_label: '进行中',
        done_tile_label: '完成',
        workflow_label: '工作流程',
        notes_label: '注释',
        please_select_atleast_one_role_error_message: '请至少选择一个角色',
        workflow_dialog_header: '创建工作流程',
        workorder_dialog_header: '创建工单',
        roles_label: '角色',
        workflow_page_breadcrumb: '工作流程',
        workflow_menu: '工作流程',
        current_status_column: '目前状态',
        created_date_column: '创建日期',
        please_select_workflow_error_message: '请选择工作流程',
        media_column: '媒体',
        transmission_label: '传输',
        transmission_column: '传输',
        mamID_label: '妈妈身份证',
        apply_distribution_button_text_planning: '分配规划',
        min_gap_label: '最小间隙',
        apply_fix_gap_label: '应用修复间隙',
        plan_till_label: '计划直至',
        max_placement_label: '最大放置位置',
        valid_days_label: '有效天数',
        retry_gap_label: '重试间隙',
        planning_distribution_label: '规划分配',
        please_enter_minimum_gap_error_message: '请输入最小间隙',
        please_select_plan_till_date_error_message: '请选择截止日期的计划',
        please_enter_max_placement_error_message: '请输入最大展示位置',
        please_select_days_error_message: '请选择日期',
        please_enter_retry_gap_error_message: '请输入重试间隔',
        please_select_starting_role_error_message: '请选择起始角色',
        starting_role_label: '起始角色',
        plan_till_date_cannot_be_less_than_original_planned_item_error_message: '截止日期计划不能少于原计划项目',
        applying_planning_distribution_template_please_wait_planner_status_message: "正在应用计划分配模板，请稍候...",
        planning_distribution_template_applied_success_planner_status_message: "规划分配模板已成功应用",
        note_for_parent_select_root_label: '注意：父节点选择root',
        payments_label: '付款方式',
        schedule_autofill_button_tooltip: "自动填充预订商业广告",
        schedule_reset_all_header_to_nominal_start_time_button_tooltip: "将所有标头开始时间重置为计划标称时间",
        work_orders_label: '工单',
        role_wise_work_orders_label: '角色明智的工作指令',
        user_wise_work_orders_label: '用户明智的工作指令',
        select_media_info_message: '选择媒体',
        history_label: '历史',
        booking_details_label: '预订详情',
        show_jobs_button_text: '显示职位',
        please_check_label: '请检查',
        categories_label: '类别',
        job_status_label: '工作状态',
        invalid_start_date: '开始日期无效',
        invalid_end_date: '结束日期无效',
        target_budget_should_be_greater_then_zero: '目标预算应大于零',
        target_spots_should_be_greater_then_zero: '目标点应大于零',
        target_seconds_should_be_greater_then_zero: '目标秒数应大于负值',
        please_select_date_format_error_message: '请选择日期格式',
        no_data_schedule_to_save_scheduling_reconciliation_error_message: '未找到数据 时间表',
        no_data_asrun_to_save_scheduling_reconciliation_error_message: '没有找到数据',
        reset_password_label: '重置密码',
        date_column_is_not_present_in_this_csv_file_label: '此 csv 文件中不存在日期列',
        time_column_is_not_present_in_this_csv_file_label: '此 csv 文件中不存在时间列',
        house_number_column_is_not_present_in_this_csv_file_label: '此 csv 文件中不存在 HouseNumber 列',
        user_favourite_add_button_title: '添加收藏夹',
        user_favourite_menu: '最爱',
        user_favorite_menu_dropdown_label: '菜单',
        user_favorite_menu_text_label: '姓名',
        please_select_user_favourite_menu_error_message: '请选择菜单',
        please_select_user_favourite_name_error_message: '请输入姓名',
        vodtype_label: '点播类型',
        replace_existing_planning_label: '替换现有规划',
        region_column: '地区',
        live_events_menu: '现场活动',
        vodtype: '点播类型',
        version_sub_menu: '版本',
        version_page_breadcrumb: '版本',
        spot_can_not_be_negative_error_message: '现货不能为负数',
        rate_can_not_be_negative_error_message: '利率不能为负数',
        please_add_booking_first_booking_error_message: '请先添加预订',
        transfer_from_and_transfer_to_are_same_date_error_message: '不能在同一天转让',
        tournament_dialog_header: '创建锦标赛',
        live_match_dialog_header: '创建匹配',
        no_booking_data_error_message: '没有找到预订数据！',
        ott_assets_video: '视频',
        ott_assets_poster: '海报',
        update_successfully_booking_success_toast_message: '预订更新成功',
        please_select_a_value_to_delete_booking_error_message: '请选择要删除的值',
        ott_assets_video_url_error_message: '请输入网址',
        LiveEventRound_sub_menu: '现场活动回合',
        LiveEventType_sub_menu: '现场活动类型',
        TournamentType_sub_menu: '赛事类型',
        commission_negative_value_campaign_error_message: '佣金不能为负数',
        discount_negative_value_campaign_error_message: '折扣不能为负数',
        invalid_spots_value_line_no_booking_error_message: '负点值 行号',
        channels_not_updated_in_booking_error_message: '频道未在线更新',
        attach_media_label: '附加媒体',
        media_episode_localization: '本地化',
        media_episode_id_column: '媒体剧集 ID',
        manage_content_template_sub_menu: '管理内容模板',
        fct_can_not_be_negative_error_message: 'FCT 不能为负数',
        rate_10_sec_can_not_be_negative_error_message: 'Rate10Sec 不能为负数',
        amount_can_not_be_negative_error_message: '金额不能为负数',
        booked_spots_scheduled_error_message: '部分选定的预订已按计划使用。',
        booking_line_no: '行号',
        please_select_import_type_error_message: '请选择导入类型',
        optimisation_sun_menu: '优化',
        optimisation_page_breadcrumb: '优化',
        booking_date_label: '预订日期',
        agency_name_column: '机构名称',
        assurance_type_column: '保障类型',
        assured_value_column: '保证价值',
        please_select_booking_date_error_message: '请选择预订日期',
        optimisation_label: '优化',
        please_show_atleast_one_item_error_message: '请展示至少一件商品！',
        please_enter_valid_percentage_error_message: '请输入有效百分比',
        campaign_target_seconds_actual_seconds_booking_error: '目标秒数不能小于总预订秒数',
        campaign_target_budget_actual_budget_booking_error: '目标预算不能低于预订预算总额',
        campaign_target_spots_actual_spots_booking_error: '目标名额不能少于总预订名额',
        assured_value_is_greater_than_total_fct_error_message: '保证价值大于总fct',
        assured_value_is_less_than_zero_error_message: '保证值小于零',
        booking_schedule_status: '预订安排状态',
        makegood_column: '弥补',
        booked_spots_unique_line_no_selection_error_message: '请选择相同行号的点进行更新',
        booking_file_import_error_message: '无法从文件读取数据。错误 -',
        spot_status_column: '地位',
        booking_transfer_from_date_greater_than_transfer_to_date_error_message: '转账起始日期不能大于转账截止日期',
        spot_time_from_time_to_error_message: '从时间应该小于到时间',
        material_type_label: '材料类型',
        cancreatedeal_label: '可以创造交易',
        please_enter_material_type_error_message: '请输入材料类型',
        automation_type_label: '自动化类型',
        download_button_text: '下载',
        edit_black_out_date_button_tooltip: '编辑限制日期',
        add_black_out_date_button_tooltip: '添加限制日期',
        edit_black_out_date_dialog_header: '编辑停电',
        add_black_out_date_dialog_header: '添加停电',
        black_out_date_dialog_header: '禁止日期',
        please_add_atleast_one_black_out_date_error_message: '请添加至少一个不适用日期',
        update_successfully_grid_data_success_toast_message: '更新成功',
        black_out_channel_column: '停电通道',
        black_out_start_date_column: '停电开始日期',
        black_out_end_date_column: '停电结束日期',
        black_out_date_should_be_within_publishing_dates_range_error_message: '限制日期应在发布日期范围内',
        some_bookings_are_out_of_campaign_date_range_could_not_transfer_error_message: '部分预订超出了露营日期范围，无法转移',
        report_menu: '报告',
        interstitial_history_sub_menu: '间隙历史',
        interstitial_history_report_dialog_header: '间隙历史报告',
        client_agency_booking_report_sub_menu: '客户代理订舱报告',
        primary_channel_column: '主要渠道',
        order_date_error_message: '订单日期应早于期间',
        please_select_tournament_type: '请选择比赛类型',
        please_enter_tournament_ID: '请输入比赛ID',
        tournament_type_label: '赛事类型',
        tournament_ID_label: '比赛ID',
        as_run_label: '阿斯运行',
        schedule_label: '时间表',
        update_booking_multiple_dialog_header: '更新预订',
        commercial_duration_lable: '期间',
        no_as_run_found_error_message: '未找到 AsRun',
        copy_from_and_copy_to_date_range_should_be_same: "（复制自）选定的天数应等于（复制到）选定的天数。",
        exclusive_label: '独家',
        exclusive_start_date_column: '独家开始日期',
        exclusive_end_date_column: '独家结束日期',
        technical_details_prototype_sub_menu: '技术细节原型',
        technical_details_prototype_page_breadcrumb: '技术细节原型',
        audio_codec_page_breadcrumb: '音频编解码器',
        video_codec_page_breadcrumb: '视频编解码器',
        delivery_method_page_breadcrumb: '交货方式',
        video_aspect_ratio_page_breadcrumb: '视频宽高比',
        video_type_page_breadcrumb: '视频类型',
        audio_codec_sub_menu: '音频编解码器',
        video_codec_sub_menu: '视频编解码器',
        delivery_method_sub_menu: '交货方式',
        video_aspect_ratio_sub_menu: '视频宽高比',
        video_type_sub_menu: '视频类型',
        is_exclusive_column: '是独家的',
        ref_off_setting_label: '偏置设定',
        offset_time_minus_label: '偏移时间减',
        offset_time_plus_label: '偏移时间加',
        ignore_duration_lable: '忽略持续时间',
        reference_no_label: '参考编号',
        please_enter_reference_no_error_message: '请输入参考号',
        create_technical_details_prototype_header_dialog: '创建技术细节原型',
        audio_codec_label: '音频编解码器',
        video_codec_label: '视频编解码器',
        video_aspect_ratio_label: '视频宽高比',
        delivery_method_label: '交货方式',
        is_quality_checked_label: '是否经过质量检查',
        enable_caption_label: '启用字幕',
        distributer_label: '经销商',
        please_select_audio_codec_error_message: '请选择音频编解码器',
        please_select_video_codec_error_message: '请选择视频编解码器',
        please_select_delivery_method_error_message: '请选择送货方式',
        please_select_video_aspect_ratio_error_message: '请选择视频宽高比',
        please_select_video_type_error_message: '请选择视频类型',
        offsetsetting_dialog_header: '偏置设置',
        please_enter_OffSet_Time_Minus_error_message: '请输入偏移时间减去',
        please_enter_offSet_time_plus_error_message: '请输入偏移时间加上',
        booking_schedule_status_sub_menu: '预订安排状态',
        edit_multiple_tooltip: '编辑多个',
        select_commercial_error_message: '请选择商业',
        invalid_spotRate_error_message: '请输入有效的即期汇率',
        invalid_rate10Sec_error_message: '请输入有效速率 10 秒',
        please_select_atleast_one_value_to_update_error_message: '请至少选择一个要更新的值',
        rate_10_sec_column: '速率10秒',
        missing_media_report_dialog_header: '失踪媒体报道',
        missing_media_report_sub_menu: '失踪媒体报道',
        schedule_date_label: '安排日期',
        please_select_schedule_date_error_message: '请选择预定日期',
        mam_assets_sub_menu: '妈妈资产',
        mamassets_page_breadcrumb: '妈妈资产',
        create_mamasset_dialog_header: '创建妈妈资产',
        please_enter_programeditstatus_error_message: '请输入节目编辑状态',
        end_time_label: '结束时间',
        program_edit_status_label: '节目编辑状态',
        tx_ready_label: '发射就绪',
        subtitle_availble_label: '可用字幕',
        censorship_report_available_label: '可用的审查报告',
        qcpass_label: '质量控制合格证',
        please_enter_valid_end_time_message: '请输入有效结束时间',
        please_enter_valid_actual_duration_message: '请输入有效的实际持续时间',
        time_in_label: '时间',
        time_out_label: '超时',
        commercial_limit_label: '商业限额',
        please_enter_valid_commercial_limit_error_message: '请输入有效的商业限额',
        contract_number_column: '合同号',
        duration_should_be_greater_than_zero_error_message: '持续时间应大于零',
        number_of_episode_can_be_greater_than_zero_error_message: `集数应大于零`,
        staring_episode_can_be_greater_than_zero_error_message: `起始剧集应大于零`,
        segment_qc_page_header: '段质检',
        segment_qc_button_tooltip: '段质检',
        media_title_label: '媒体标题',
        qc_status_label: '质量控制状态',
        frame_rate_label: '帧率',
        note_label: '注意事项',
        please_select_qc_status_error_message: '请选择质量控制状态',
        please_enter_note_error_message: '请输入备注',
        please_select_frame_rate_error_message: '请选择帧率',
        please_enter_positive_value_in_pin_code_error_message: '请在 Pincode 中输入正值',
        please_enter_commission_error_message: '请输入佣金',
        please_enter_discount_error_message: '请输入折扣',
        please_configure_checklist_preference_error_message: '请配置清单首选项！',
        preference_saved_successfully: '首选项保存成功！',
        please_select_csv_file_error_message: '请选择csv文件！',
        cannot_delete_channel_campaign_already_has_booking_error_message: "无法删除已预订的频道活动",
        cannot_delete_commercial_campaign_already_has_booking_error_message: "无法删除已预订的商业活动",
        ref_change_rate10sec_label: '变化率 10 秒',
        change_rate10sec_dialog_header: '变化率 10 秒',
        change_rate10sec_label: '变化率 10 秒',
        import_pdf_file: '导入 PDF 文件',
        please_select_atleast_one_media_category_type_error_message: '请至少选择一种媒体类别类型',
        please_select_episode_content_error_message: '请选择剧集内容',
        iso_code_label: 'ISO代码',
        google_api_code_label: '谷歌API代码',
        create_language_dialog_header: '创建语言',
        please_enter_iso_code_error_message: '请输入 ISO 代码',
        please_enter_google_api_code_error_message: '请输入谷歌API代码',
        click_here_to_check_ISO_code_error_message: '单击此处查看 ISO 代码',
        booking_update_successfully: '预订更新成功',
        cast_Type_page_breadcrumb: '铸造类型',
        cast_Type_sub_menu: '铸造类型',
        spots_out_of_campaign_date_range_error_message: '有些地点超出了活动日期范围。请检查',
        import_pdf_booking_file: '导入 PDF 预订',
        import_booking_label: '进口订舱',
        download_template_label: '下载模板',
        export_saved_booking_label: ' Export Saved Booking',
        export_current_booking_label: ' Export Current Booking',
        planning_is_locked_on_some_days_in_this_date_range: '计划已锁定在此日期范围内的某些日子',
        payment_schedule_label: '付款时间表',
        promotional_excerpts_label: '促销摘录',
        governing_laws_label: '适用法律',
        add_linear_page_header: '添加线性',
        add_linear_button_tooltip: '添加线性',
        amount_should_be_negative_error_message: '金额不能为负数',
        currency_column: "货币",
        total_booked_spots_label: '预订地点',
        total_booked_seconds_label: '预订秒数',
        booking_exceeded_target_budget: '超出目标预算，请刷新并重试',
        booking_exceeded_target_seconds: '超出目标秒数，请刷新并重试',
        booking_exceeded_target_amount: '超出目标金额，请刷新并重试',
        broadcaster_id_label: '广播公司 ID',
        restriction_label: '限制',
        create_restriction_dialog_header: '创建限制',
        dynamic_rules_label: '动态规则',
        censorship_details_label: '审查细节',
        term_label: '条款',
        reason_label: '原因',
        hold_all_payment_label: '保留所有付款',
        generate_payment_button_text: '生成付款',
        contract_payment_schedule_dialog_header: '合同付款时间表',
        generate_payment_schedule_dialog_header: '生成付款计划',
        due_date_label: '截止日期',
        interest_rate_label: '利率',
        no_of_installment_label: '分期付款次数',
        recurring_label: '重复出现',
        due_date_column: '截止日期',
        due_amount_column: '应付金额',
        approve_status_column: '批准状态',
        amount_paid_column: '支付金额',
        balance_amount_column: '余额金额',
        please_select_recurring_error_message: '请选择重复',
        interest_rate_should_be_negative_error_message: '利率应该是负数',
        no_of_installment_should_be_greater_than_zero_error_message: '分期付款次数应大于零',
        generate_payment_label: '生成付款',
        are_you_sure_you_want_to_generate_payment_schedule: '您确定要重新生成付款计划吗',
        amount_paid_label: '支付金额',
        approve_status_label: '审批状态',
        remark_column: '备注',
        edit_contract_title_button_text: '编辑合同标题',
        edit_black_out_date_button_text: '编辑限制日期',
        delete_contract_title_button_text: '删除合同标题',
        classification_label: '分类',
        cut_tc_in_label: '切入 Tc (hh:mm:ss:ff)',
        cut_tc_out_label: '剪切 Tc (hh:mm:ss:ff)',
        done_date_label: '完成日期',
        result_label: '结果',
        officer_label: '军官',
        cut_label: '切',
        classification_column: '分类',
        cut_tc_in_column: '切入 Tc',
        cut_tc_out_column: '切掉 Tc',
        done_date_column: '完成日期',
        reference_no_column: '参考编号',
        result_column: '结果',
        officer_column: '军官',
        cut_column: '切',
        create_censorship_details_dialog_header: '创建审查细节',
        please_enter_valid_value_cut_tcin_error_message: '请输入有效的 CutTcIn',
        can_not_delete_error_message: '无法删除仪表板右侧',
        add_brand_button_tooltip: '添加品牌',
        add_product_button_tooltip: '添加产品',
        ratecard_page_breadcrumb: '价目表',
        ratecard_sun_menu: '价目表',
        create_ratecard_dialog_header: '创建价目表',
        rate_10sec_label: '速率 10 秒',
        please_enter_time_in_error_message: '请输入时间',
        please_enter_time_out_error_message: '请输入超时时间',
        view_label: '查看',
        other_option_label: '其他选项',
        prime_time_label: '黄金时间',
        no_rights_scheduling_error_message: '无调度权',
        used_to_configure_prefix_suffix_and_incremental_next_number_for_assetid_tooltip: '用于配置资产 ID 的前缀后缀和增量下一个数字',
        sales_executive_label: '销售主管',
        please_select_sales_executive_error_message: '请选择销售主管',
        material_content_page_breadcrumb: '材料内容',
        material_content_sub_menu: '材料内容',
        added_by_column: '添加者',
        modified_by_column: '修改者',
        show_history_button_text: '显示历史',
        successfully_download_success_message: '下载成功',
        top_5_sales_executive_label: '前 5 名销售主管',
        add_job_url_button_tooltip: '添加职位网址',
        checklist_preference_label: '清单偏好',
        select_playback_url_header: '选择播放网址',
        duration_mismatch_error_message: '持续时间不匹配',
        no_invoice_details_are_available_to_preview_bill_error_message: '没有发票详细信息可供预览！',
        selected_commercial_label: '精选商业广告',
        no_data_schedule_to_download_error_message: '没有可供下载的数据时间表',
        from_date_can_not_be_less_than_campaign_start_date_error_message: '开始日期不能早于广告系列开始日期',
        to_date_can_not_be_greater_than_campaign_end_date_error_message: '迄今为止不能晚于活动结束日期',
        cancel_invoice_waiting_message: '正在取消发票，请稍候...',
        series_dialog_header: '系列',
        manage_content_template_breadcrumb: '管理内容模板',
        ottmenu_sub_menu: '菜单',
        ottmenu_page_breadcrumb: '菜单',
        cardlist_pages_menu_title: '页数',
        select_pages_header_collection: '页数',
        ottmenu_title_editpageheader: '菜单',
        sidefixmenu_rails_pages_tooltip: '页数',
        atleast_attach_one_ott_pages_rails_error_message: '至少附一页',
        menu_type_label: '菜单类型',
        team_a_label: 'A队',
        team_b_label: 'B队',
        round_label: '圆形',
        bottom_menu_sub_menu: '底部菜单',
        bottom_menu_page_breadcrumb: '底部菜单',
        top_menu_sub_menu: '顶部菜单',
        top_menu_page_breadcrumb: '顶部菜单',
        please_select_asset_type_to_media_asset_error_message: '请选择媒体资产的资产类型',
        multi_versioning_tooltip_button: '多版本控制',
        title_view_tooltip_button: '标题视图',
        close_title_view_tooltip_button: '关闭标题视图',
        sidefix_episode_tooltip: '插曲',
        please_select_valid_start_date_error_message: '请选择有效开始日期',
        please_select_valid_end_date_error_message: '请选择有效结束日期',
        please_select_exclusive_start_date_error_message: '请选择独家开始日期',
        please_select_exclusive_end_date_error_message: '请选择独家结束日期',
        please_select_start_date_smaller_than_end_date_media_episode_publishing_error_message: '开始日期应早于结束日期',
        amount_paid_can_not_be_negative_error_message: '支付金额不能为负数',
        print_button_tooltip: '打印',
        print_telecast_certificate_in_pdf_button_tooltip: '打印 PDF 格式的电视广播证书',
        print_telecast_certificate_in_excel_button_tooltip: '在 Excel 中打印电视广播证书',
        cancel_invoice_button_tooltip: '取消发票',
        campagn_type_page_breadcrumb: '活动类型',
        deal_type_page_breadcrumb: '交易类型',
        location_page_breadcrumb: '地点',
        campaigntype_sub_menu: '活动类型',
        dealtype_sub_menu: '交易类型',
        location_sub_menu: '地点',
        ott_setting_sub_menu: '设置',
        ott_setting_page_breadcrumb: '设置',
        application_name_label: '应用名称',
        logo_label: '标志',
        logo_position_label: '标志位置',
        pi_page_template_label: 'PiPage 模板',
        show_bottom_menu_label: '显示底部菜单',
        home_page_label: '主页',
        show_hamburger_menu_label: '显示汉堡菜单',
        image_cdn_base_url_label: '图片 CDN 基本 URL',
        video_cdn_base_url_label: '视频 CDN 基本 URL',
        image_cdn_credentials_label: '图像 CDN CRED',
        video_cdn_credentials_label: '视频 CDN CRED',
        key_name_label: '按键名称',
        key_value_label: '关键值',
        add_image_cdn_credentials_dialog_header: '添加图片 CDN CRED',
        add_video_cdn_credentials_dialog_header: '添加视频 CDN CRED',
        please_enter_key_name_error_messgae: '请输入密钥名称',
        please_enter_key_value_error_message: '请输入键值',
        settings_label: '设置',
        please_enter_application_name_error_message: '请输入应用名称',
        please_select_logo_error_message: '请选择标志',
        please_select_logo_position_error_message: '请选择标志位置',
        please_select_pi_page_template_error_message: '请选择PiPage模板',
        please_select_home_page_error_message: '请选择首页',
        please_select_theme_error_message: '请选择主题',
        please_enter_image_cdn_base_url_error_message: '请输入图片 CDN 基本 URL',
        please_enter_video_cdn_base_url_error_message: '请输入视频 CDN 基本 URL',
        icon_label: '图标',
        please_select_icon_error_message: '请选择图标',
        please_select_hamburger_menu_error_message: `请选择汉堡菜单`,
        hamburger_menu_label: '汉堡菜单',
        select_package_header: '选择套餐',
        please_select_package_error_message: '请选择套餐',
        vod_type_validation_error_message: `VOD 类型 FREE 只能与 AVOD 一起应用`,
        server_health_sub_menu: '服务器健康状况',
        server_health_page_breadcrumb: '服务器健康状况',
        text_number_can_not_be_negative_error_message: '文本编号不能为负数',
        prelog_postlog_report_sub_menu: '前/后日志报告',
        pre_log_report_title_button: '预记录报告',
        post_log_report_title_button: '日志报告',
        download_pre_log_report_tooltip_button: '下载预记录报告',
        download_post_log_report_tooltip_button: '下载日志报告',
        credit_line_report_sub_menu: '信用额度报告',
        download_credit_line_report_tooltip_button: '下载信用额度报告',
        please_select_date_error_message: '请选择日期',
        logo_size_label: '标志尺寸',
        application_color_label: '应用颜色',
        purge_Spot_report_sub_menu: '清除现场报告',
        download_purge_Spot_report_tooltip_button: '下载清除现场报告',
        download_client_agency_booking_report_tooltip_button: '下载客户代理预订报告',
        download_purge_spot_report_tooltip_button: '下载清除现场报告',
        client_agency_booking_report_header: '客户代理订舱报告',
        pre_post_log_report_header: '前/后日志报告',
        credit_line_report_header: '信用额度报告',
        purge_spot_report_header: '清除现场报告',
        interstitial_history_report_header: '间隙历史报告',
        download_interstitial_history_report_tooltip_button: '下载插页式历史报告',
        telecast_certificate_details_not_found_error_message: "未找到电视转播详细信息",
        air_time_consumption_report_sub_menu: '通话时间消耗报告',
        download_air_time_consumption_report_tooltip_button: '下载通话时间消耗报告',
        air_time_consumption_report_header: '通话时间消耗报告',
        prototypecontent_sub_menu: '原型内容',
        prototypecontent_page_breadcrumb: '原型内容',
        create_prototypecontent_dialog_header: '创建原型内容',
        please_enter_max_length_error_message: '请输入最大长度',
        manual_prototype_id_label: '手册ID',
        prototype_id_label: 'ID',
        error_while_generating_prototype_number_error_message: '生成原型编号时出错',
        refresh_generated_segments_tooltip: '刷新生成的段',
        generated_segments_selected_segmentType_mismatch_error_message: '生成的段数与所选段类型不同',
        materialID_mediaID_mismatch_generated_segment_error_message: 'Material ID 与生成片段中的 MediaID 不同，请刷新',
        please_select_subtitle_type_error_message: '请选择字幕类型',
        number_of_generated_segments_is_not_same_as_selected_segment_Type_error_message: '生成的段数与所选段类型不同',
        select_material_content_first_error_message: '首先选择材料内容',
        segment_already_exist_with_same_material_id_and_segment_type_error_message: '已存在具有相同材质 ID 和段类型的段',
        amazon_delivery_group_page_breadcrumb: '亚马逊配送集团',
        amazon_delivery_group_sub_menu: '亚马逊配送集团',
        amazon_delivery_group_edit_page_header: '亚马逊配送集团',
        tv_preview_label: '电视预览',
        mobile_preview_label: '移动预览',
        ditribute_by_percentage_label: '按百分比分配',
        ditribute_by_percentage_error_message: '选定的商业发行百分比总和应为 100',
        select_commercial_for_booking_error_message: '请至少选择一个广告进行预订',
        distribute_selected_equal_lable: '平均分配所选内容',
        feature_label: '特点',
        select_secondary_event_error_message: '首先选择次要事件',
        delete_secondary_event_tooltip: '删除选定的次要事件',
        select_campaign_header_dialog: '选择活动',
        select_pages_header_dialog: '选择页面',
        display_name_column: '显示名称',
        spot_separation_label: '点分离',
        please_enter_valid_spot_separation_error_message: '请输入有效的点间隔',
        ott_package_delivery_schedule_menu: '奥特包裹递送时间表',
        service_menu: '服务',
        ott_package_delivery_schedule_page_breadcrumb: '奥特包裹递送时间表',
        schedule_delivery_button_tooltip: '安排交货',
        schedule_delivery_button_text: '安排交货',
        schedule_delivered_successfully_success_message: '时间表已成功交付',
        schedule_auto_fill_interstitial_page_breadcrumb: '安排自动填充插页式广告',
        schedule_auto_fill_interstitial_sub_menu: '安排自动填充插页式广告',
        schedule_auto_fill_interstitial_edit_page_header: '安排自动填充插页式广告',
        interstitial_label: '插页式',
        filler_label: '填料',
        music_label: '音乐',
        new_subscriber_in_week_label: '本周新订阅者',
        no_pack_users_label: '无包用户',
        users_subscription_expiring_in_current_week_label: '一周内到期的用户',
        user_by_plan_label: '按计划划分的用户',
        media_asset_label: '媒体资产',
        vod_label: '视频点播',
        dummy_page_breadcrumb: '假人',
        dummy_sub_menu: '假人',
        ref_attach_formats_label: '附加格式',
        format_attached_success_message: '格式附加成功',
        ref_delete_formats_label: '删除所有格式',
        formats_deleted_success_message: '所有格式删除成功',
        insert_break_label: '插入中断',
        slot_duration_label: '时段持续时间',
        please_enter_slot_duration_error: '请输入时段持续时间',
        actual_duration_slot_duration_format_error_message: '实际持续时间不能大于时段持续时间',
        total_amount_is_smaller_than_amount_paid_error_message: '总金额小于支付金额',
        is_dummy_label: '是假人',
        downloading_log_report_label: '下载日志报告',
        bill_generate_label: '账单生成',
        contract_run_report_button_tooltip: '合同运行报告',
        contract_run_report_label: '合同运行报告',
        total_run_column: '总跑动次数',
        preview_button_tooltip: '预览',
        preview_image_title_label: '预览图像',
        poster_dimension_title_label: '海报尺寸',
        show_poster_dimension_title_label: '显示海报尺寸',
        mam_asset_report_sub_menu: '妈妈资产报告',
        mam_asset_report_page_breadcrumb: '妈妈资产报告',
        schedule_duration_column: '时间表持续时间',
        mam_duration_column: '妈妈持续时间',
        total_column: '全部的',
        schudule_column: '时间表',
        pending_colun: '待定',
        tomorrow_pending_booking_status_label: '明天待定预订状态',
        pending_approval_sun_menu: '待批准',
        pending_approval_page_breadcrumb: '待批准',
        approve_button_text: '批准',
        reject_button_text: '拒绝',
        booking_status_updated_successfully: '预订状态已成功更新',
        total_segment_duration_lable: '总航段持续时间',
        other_label: '其他',
        comment_label: '评论',
        please_enter_comment_error_message: '请输入评论',
        unpurged_label: '未净化',
        please_add_deeplink_in_video_list_error_message: '请在视频列表中添加深层链接',
        please_attach_atleast_one_video_error_message: '请附上至少一个视频',
        please_attach_atleast_one_poster_error_message: '请附上至少一张海报',
        deeplink_url_label: '深层链接网址',
        rental_wholesale_price_label: '租赁批发价',
        rental_retail_price_label: '租赁零售价',
        actual_on_air_column: '实际播出',
        nominal_on_air_column: '标称直播',
        parent_series_code_label: '父系列代码',
        series_code_label: '系列代码',
        duration_only_label: '期间',
        reference_code_label: '参考代码',
        material_type_column: '材料类型',
        break_configuration_page_breadcrumb: '中断配置',
        break_configuration_sub_menu: '中断配置',
        create_break_configuration_dialog_header: '创建中断配置',
        please_select_atleast_one_allow_media_category_type_error_message: '请至少选择一种允许的媒体类别类型',
        please_select_atleast_one_day_error_message: '请选择至少一天',
        please_enter_from_time_label: '请输入时间',
        please_enter_to_time_label: '请输入时间',
        fct_should_be_greater_than_zero_error_message: 'FCT 应大于零',
        from_time_should_be_less_than_To_time_error_message: '从时间应该小于到时间',
        to_date_should_be_greater_than_from_date_error_message: '截止日期应大于起始日期',
        fct_already_exists_error_message: 'FCT 已存在于同一频道/时间范围/天数中',
        fct_should_not_be_greater_than_campaign_target_seconds_error_message: 'FCT 不应大于活动目标秒数',
        sort_by_label: '排序方式',
        billing_summary_report_sub_menu: '帐单摘要报告',
        no_scheduling_found_auto_fill_commercial_error: '没有找到日程安排',
        no_break_item_found_auto_fill_commercial_error: '这一天没有安排休息项目',
        no_booked_spot_found_auto_fill_commercial_error: '已预订的位置不可用',
        save_bill_button_text: '拯救比尔',
        save_bill_button_tooltip: '拯救比尔',
        preview_button_text: '预览',
        parent_series_lable: '亲子系列',
        ott_setting_label: '奥特设置',
        bottom_menu_label: '底部菜单',
        series_only_label: '系列',
        add_insert_break_label: '添加插入中断',
        playlist_lock_status_sub_menu: '播放列表锁定状态',
        playlist_lock_page_breadcrumb: '播放列表锁定状态',
        generate_pdf_message: '正在生成 PDF，请稍候...',
        generate_pdf_successfully_message: '成功生成PDF',
        payment_received_label: '已收到付款',
        payment_received_button_tooltip: '已收到付款',
        payment_received_button_text: '已收到付款',
        print_button_text: '打印',
        to_txt_button_toolip: '发送至TXT',
        to_txt_button_text: '发送至TXT',
        pdf_button_text: 'PDF',
        excel_button_text: 'Excel',
        received_date_label: '收到日期',
        payment_mode_label: '付款方式',
        cheque_no_label: '支票号码',
        payment_received_successfully: '付款成功收到',
        is_paymnet_received_column: '是否收到付款',
        payment_received_date_column: '付款收到日期',
        payment_mode_column: '付款方式',
        cheque_no_column: '支票号码',
        payment_already_received_error_message: '付款已收到',
        please_select_received_date_error_message: '请选择收货日期',
        please_select_payment_mode_error_message: '请选择付款方式',
        please_enter_cheque_no_error_message: '请输入支票号码',
        booked_commercial_label: '已预订商业广告',
        booked_announcement_label: '预订公告',
        announcement_label: '公告',
        export_commercial_break_playlist_button_tooltip: 'Export Commercial Break Playlist',
        credit_line_report_page_breadcrumb: '信用额度报告',
        brand_column: '品牌',
        time_range_column: '时间范围',
        schedule_spot_column: '安排现货',
        total_duration_column: '总持续时间',
        booking_schedule_status_header: '预订安排状态',
        no_data_found_for_selected_filter_error_message: '未找到所选过滤器的数据！',
        artist_label: '艺术家',
        please_enter_artist_error_message: '请输入艺术家',
        announcement_reconcile_sun_menu: '公告对账',
        announcement_reconcile_page_breadcrumb: '公告对账',
        edit_header_dialog: '编辑',
        actual_on_air_label: '实际播出',
        reconciled_successfully_message: '对账成功',
        reconcile_label: '调和',
        please_enter_actualonair_error_message: '请输入实际直播',
        please_select_atleast_one_saleteam_error_message: '请至少选择一个销售团队',
        export_announcement_tooltip: 'Export Announcement',
        export_jazzler_automation_playlist: 'Export Jazzler Commercial Break',
        point_of_contact_label: '联络点',
        please_enter_point_of_contact_error_message: '请输入联系方式',
        please_enter_pin_code_error_message: '请输入密码',
        epg_menu: '电子节目指南',
        epg_channel_sub_menu: '渠道',
        epg_channel_page_breadcrumb: '渠道',
        create_channel_dialog_header: '创建频道',
        please_enter_image_url_error_message: '请输入图片网址',
        faq_category_page_breadcrumb: '常见问题类别',
        faq_category_sub_menu: '常见问题类别',
        faq_page_breadcrumb: '常见问题解答',
        faq_sub_menu: '常见问题解答',
        please_select_faq_Category_error_message: '请选择类别',
        faq_category_label: '常见问题类别',
        question_label: '问题',
        answer_label: '回答',
        please_enter_question_error_message: '请输入问题',
        please_enter_answer_error_message: '请输入答案',
        select_a_category_column: '选择一个类别',
        faqs_column: '常见问题解答',
        faqs_dailog_header: '常见问题解答',
        faqs_page_breadcrumb: '常见问题解答',
        top_news_menu: '热门新闻',
        top_news_page_breadcrumb: '热门新闻',
        favorite_channel_sub_menu: '最喜欢的频道',
        favorite_channel_page_breadcrumb: '最喜欢的频道',
        create_favorite_channel_dialog_header: '创建喜爱的频道',
        logo_column: '标志',
        please_select_atleast_one_channel_error_message: '请至少选择一个频道',
        tutorial_videos_page_breadcrumb: '教程视频',
        tutorial_videos_sub_menu: '教程视频',
        summary_label: '概括',
        playback_url_label: '播放网址',
        create_tutorial_videos_dialog_header: '创建教程视频',
        please_enter_summary_error_message: '请输入摘要',
        please_enter_playback_url_error_message: '请输入播放网址',
        create_top_news_dialog_header: '创建热门新闻',
        source_id_label: '源 ID',
        featured_image_url_label: '特色图片网址',
        image_caption_label: '图片说明',
        time_stamp_label: '时间戳',
        pull_latest_top_news_button_tooltip: '拉取最新热门新闻',
        thumbnail_url_label: '缩略图网址',
        please_enter_thumbnail_url_error_message: '请输入缩略图网址',
        please_enter_source_id_error_message: '请输入来源ID',
        please_enter_image_caption_error_message: '请输入图片说明',
        header_address_label: '标头地址',
        footer_address_label: '页脚地址',
        ok_label: '好的',
        cancel_label: '取消',
        session_expired_please_login_again_label: '会话已过期。请重新登录',
        please_select_episodes_first: `请先选择剧集`,
        successfully_saved_updated_message: '成功保存/更新！',
        please_select_all_platforms_message: "请选择所有平台更改位置",
        please_book_spots_within_campaign_date_message: '请在活动日期范围内预订席位：',
        invalid_file_format: `文件格式无效`,
        import_already_in_progress: '导入已在进行中。进程中止',
        invalid_template_file: '模板文件无效！！',
        date_time_houseNumber_column_is_mandatory: '日期、时间和门牌号列在导入文件中是强制性的',
        commercial_used_in_booking_cannot_change_duration_message: '预订时使用的商业广告不能更改时长！',
        please_enter_team: `请输入团队`,
        please_select_round_error: '请选择回合',
        please_select_start_date_between_tournament_date_range_error: `请选择锦标赛日期范围内的开始日期`,
        match_scheduled_successfully_message: '比赛安排成功！！',
        some_spots_are_reconciled_bill_generated_selected_spots: `某些地点已对账或在选定地点生成账单`,
        media_master_report_sub_menu: '媒体大师报告',
        media_master_report_page_breadcrumb: '媒体大师报告',
        video_column: '视频',
        product_column: '产品',
        data_load_successfully_message: '数据加载成功',
        please_enter_address_error_message: '请输入地址',
        target_seconds_should_be_greater_then_zero_error_message: '目标秒数应大于零',
        missing_seasone_detail_form_error_message: '缺少季节细节',
        ott_menu: '奥特',
        manage_content_menu: '管理内容',
        to_do_column: '待办事项',
        in_progress_column: '进行中',
        done_column: '完成',
        work_order_button_tooltip: '工单',
        show_spots_button_tooltip: '演出地点',
        show_spots_button_text: '演出地点',
        save_and_create_work_order_button_tooltip: '保存并创建工单',
        save_and_create_work_order_button_text: '保存WO',
        planning_prime_time_sub_menu: '规划黄金时间',
        breaks_label: '休息时间',
        add_line_button_tooltip: '添加线路',
        add_line_button_text: '添加线路',
        perday_label: '每天',
        perweek_label: '每周',
        trp_label: 'TRP',
        booking_yearly_sub_menu: '每年预订',
        booking_yearly_page_breadcrumb: '每年预订',
        days_of_week_column: '一周中的几天',
        edit_multiple_button_text: '编辑多个',
        delete_multiple_button_tooltip: '删除多个',
        delete_multiple_button_text: '删除多个',
        announcements_label: '公告',
        recorded_commercial_label: '录制的商业广告',
        read_outs_column: '读出',
        scripts_column: '脚本',
        booking_status_column: '预订状态',
        asset_id_column: '资产ID',
        delete_strand_label: '删除链',
        delete_strand_items_confirm_message: '删除链项目',
        press_yes_to_delete_all_the_strand_from_the_selected_slot_onwards_confirm_message: '按 YES（是）删除所选槽位以后的所有股线',
        show_media_label: '展会媒体',
        lock_unlock_label: '锁定/解锁',
        show_exhibitions_label: '展会展览',
        expand_all_breaks_label: '展开所有中断',
        mnimize_all_breaks_label: '尽量减少所有中断',
        please_select_atleast_one_days_error_message: '请选择至少一天',
        session_time_out_label: '会话超时',
        please_enter_session_time_out_error_message: '请输入会话超时',
        session_time_out_should_be_greater_than_one_hour_error_message: '会话超时应大于一小时',
        non_reconciled_spot_column: '未调节点',
        time_in_should_be_less_than_time_out_error_message: '进入时间应小于超时',
        promotional_screens_sub_menu: '宣传画面',
        promotional_screens_page_breadcrumb: '宣传画面',
        marketing_screens_sub_menu: '营销屏幕',
        marketing_screens_page_breadcrumb: '营销屏幕',
        frequency_type_label: '频率类型',
        frequency_label: '频率',
        enable_label: '启用',
        marketing_screens_editpageheader: '营销屏幕',
        promotional_screens_editpageheader: '宣传画面',
        frequency_should_be_greater_than_zero_error_message: '频率应大于零',
        verbiage_key_label: '措辞',
        access_level_label: '访问级别',
        ottcampaign_label: '奥特运动',
        ott_campaign_dialog_header: '活动',
        successfully_add_campaign_message: '添加活动成功',
        rail_is_already_attach_in_selected_campaign_info_message: '铁路已附加在选定的活动中',
        deattach_ott_campaign_dialog_header: '分离活动',
        deattach_successfully_message: '分离成功',
        confirm_deattach_label: '确认解除附加',
        are_you_sure_do_you_want_to_deattach_campaign_label: '您确定要取消附加广告系列吗',
        ott_camapign_status_label: '活动状态',
        expire_label: '已过期',
        rails_dialog_header: '导轨',
        please_select_provider_error_message: '请选择提供商',
        are_you_sure_do_you_want_to_deattach_rail_label: '您确定要拆下导轨吗',
        rail_is_already_attach_in_selected_page_info_message: '导轨已附加在所选页面中',
        successfully_add_rails_message: '添加导轨成功',
        provider_sub_menu: '提供者',
        provider_page_breadcrumb: '提供者',
        logourl_label: '标志网址',
        please_enter_logourl_error_message: '请输入徽标URL',
        please_select_at_least_one_product_error_message: '请选择至少一种产品',
        products_label: '产品展示',
        active_ottcampaign_label: '活跃活动',
        total_active_subscriber_label: '活跃订阅者总数',
        preview_menu: '预览',
        module_sub_menu: '模块',
        module_page_breadcrumb: '模块',
        path_label: '路径',
        create_module_header_dialog: '创建模块',
        select_product_header_dialog: '选择产品',
        successfully_add_product_succes_message: '添加产品成功',
        campaign_prefix_label: '活动前缀',
        please_enter_campaign_prefix_error_message: '请输入活动前缀',
        please_enter_valid_release_year_error_message: '请输入有效的发布年份！',
        traffic_sub_menu: '交通',
        adSales_sub_menu: '广告销售',
        curate_sub_menu: '策展人',
        monetize_sub_menu: '货币化',
        sms_sub_menu: '短信',
        couponing_sub_menu: '优惠券',
        print_pdf_button_tooltip: '打印 PDF',
        please_enter_code: '请输入代码',
        external_description_label: '外部描述',
        alternate_description_label: '替代描述',
        please_select_access_level_error_message: '请选择访问级别',
        company_setting_label: '公司设置',
        invoice_label: '发票',
        successfully_saved_message: '保存成功',
        export_edi_format_label: 'Export EDI Format',
        do_you_want_print_campaign_billing_lines_label: '您想要印刷活动账单行吗？',
        cancel_invoice_label: '取消发票',
        do_you_want_cancel_this_invoice_label: '您想取消这张发票吗？',
        please_wait_cancel_invoice_message: '请稍候取消发票...',
        please_select_menu_type_error_message: '请选择菜单类型',
        is_parent_menu_label: '是父菜单项',
        submenu_label: '子菜单',
        please_select_sub_menu_error_message: '请选择子菜单',
        warning_label: '警告',
        user_channel_warning_message: '该用户没有附加频道权限。您想继续吗？',
        financial_year_page_breadcrumb: '财政年度',
        sales_target_page_breadcrumb: '销售目标',
        financial_year_dialog_header: '创建财政年度',
        sales_target_dialog_header: '创建销售目标',
        financial_year_sub_menu: '财政年度',
        sales_target_sub_menu: '销售目标',
        financial_year_label: '财政年度',
        quarter_label: '季度',
        target_label: '目标',
        please_select_financial_year_error_message: '请选择财政年度',
        please_enter_target_error_message: '请输入目标',
        please_select_quarter_error_message: '请选择季度',
        please_update_target_details_error_message: '请更新目标详细信息',
        please_update_target_wrong_distribution_error_message: '目标应等于分布式目标',
        target_details_label: '目标详情',
        sales_target_achived_label: '销售主管目标/已实现的目标',
        total_target_label: '总目标：',
        distributed_target_label: '分布式目标：',
        please_enter_assetid_error_message: '请输入资产 ID',
        end_time_should_be_greater_than_start_time_error_message: "结束时间应大于开始时间",
        please_select_vod_type_validation_error_message: '请选择点播类型',
        sum_of_percentages_should_be_100_error_message: '百分比总和应为 100',
        campaign_actionbutton_option: '活动',
        upcoming_label: '即将推出',
        select_ott_assets_header_dialog: '选择 OTT 资产',
        ott_asset_label: '奥特资产',
        fast_segmentation_actionbutton_menutext: '快速分割',
        is_negative_asrun_diff_label: '负 Asrun 差异',
        ott_enabled_label: '奥特启用',
        create_provider_dialog_header: '创建提供者',
        insert_dummy_label_planning: '插入假人',
        please_enter_duration: '请输入持续时间',
        sum_of_entered_duration_should_be_less_then_or_equal_to_media_duration: '输入的持续时间总和应小于或等于媒体持续时间',
        please_select_area_on_planner_to_insert_dummy_planning_performance_error_message: '请在规划器上选择要插入假人的区域。',
        insert_dummy_dialog_title: '插入假人',
        edit_dummy_actionbutton_menutext: '编辑虚拟人',
        upload_fail_error_message: '上传失败',
        replace_actionbutton_menutext: '更换',
        media_not_valid_for_selected_channel_error_message: "媒体对于所选频道无效",
        replacement_media_lost_error_message: '更换介质丢失。',
        are_you_sure_you_want_to_logout: '您确定要退出吗？',
        translate_dialog_header: '翻译',
        text_area_label: '文本区',
        translate_button_name: '翻译',
        missing_google_api_code_error_message: '缺少 Google API 代码',
        please_enter_text_area_first_error_message: '请先输入文字区',
        please_translate_first_error_message: '请先翻译',
        confirm_saved_label: '确认已保存',
        changes_you_made_may_not_be_saved_label: '您所做的更改可能不会保存。',
        sign_in_label: '登录',
        username_login_label: '用户名',
        password_login_label: '密码',
        please_enter_user_name_login_label: '请输入用户名',
        enter_your_password_login_label: '输入您的密码',
        login_lable: '登录',
        material_id_and_media_id_mismatch_please_re_generate_segments_first_error_message: '材质 ID 和媒体 ID 不匹配，请先重新生成片段！',
        please_enter_material_id_error_message: '请输入物料ID',
        poster_note_image_size_label: '注意：图像大小小于 1 MB',
        entry_already_exists_in_system_for_same_prefix_and_suffix_error_message: '系统中已存在相同前缀的条目。',
        loop_till_selected_end_date: '注意：选中循环直到选定的结束日期',
        please_select_material_content_error_message: '请选择素材内容',
        document_page_breadcrumb: '文件',
        document_sub_menu: '文件',
        document_type_label: '文件类型',
        please_select_document_type_error_message: '请选择文件类型',
        please_enter_doc_error_message: '请输入文档',
        create_Document_dialog_header: '创建文档',
        upload_documents_label: '上传文件',
        doc_label: '医生',
        please_upload_documents_error_message: '请上传文件',
        delete_selected_label: '删除所选内容',
        delete_slot_and_push_forward_in_the_strand_label: '删除槽并在股线中向前推进',
        delete_slot_and_pull_backward_in_the_strand_label: '删除剧集并向后拉',
        delete_all_the_events_forward_in_the_strand_label: '删除链中所有转发的事件',
        delete_episode_in_future_from_selected_slot_forward_label: '从选定的时段向前删除未来的剧集',
        to_enable_other_options_select_only_one_item_label: '要启用其他选项，请仅选择一项。',
        selected_item_should_be_episode_planning_item_error_message: '递归仅适用于剧集媒体类别。',
        selected_item_already_part_of_another_strand_error_message: '所选项目是另一条链的一部分',
        select_documents_header_dialog: '选择文件',
        revenue_share_label: '收入分成',
        revenue_share_should_be_negative_error_message: '收入分成应该是负数',
        revenue_share_column: '收入分成',
        screen_saver_page_breadcrumb: '屏幕保护程序',
        screen_saver_sub_menu: '屏幕保护程序',
        screen_saver_editpageheader: '屏幕保护程序',
        old_value_label: '旧值',
        new_value_label: '新价值',
        show_changes_label: '显示变更',
        planning_slot_sub_menu: '规划槽位',
        planning_slot_page_breadcrumb: '规划槽位',
        timerangefrom_should_be_greater_then_zero: 'TimeRangeFrom 应大于零',
        timerangefrom_should_be_less_then_timerangeto: 'TimeRangeFrom 应小于 TimeRangeTo',
        timerangeTo_should_be_greater_then_zero: 'TimeRangeTo 应大于零',
        show_details_column: '显示详情',
        show_all_label: '显示全部',
        isImportable_label: '可导入',
        invalid_file_error_message: '所选文件无效',
        enable_filter_label: '启用过滤器',
        rails_label: '导轨',
        promotional_page_page_breadcrumb: '促销页面',
        promotional_page_sub_menu: '促销页面',
        slug_label: '蛞蝓',
        thumb_img_label: '缩略图',
        ban_img_label: '横幅图片',
        app_img_label: '应用图片',
        tags_label: '标签',
        show_buy_button_label: '显示购买按钮',
        show_in_app_label: '在应用程序中显示',
        please_enter_slug_error_message: "请输入蛞蝓",
        promotional_page_editpageheader: "促销页面",
        comma_seprated_value_should_be_enter_label: "应输入逗号分隔值",
        please_enter_next_number_error_message: '下一个数字应该大于 0',
        please_enter_number_length_error_message: '数字长度应大于0',
        generate_button_tooltip: '下载 Excel 中的 TC',
        generate_xml_message: '正在生成 Excel，请稍候...',
        create_new_button_label: '新建',
        rating_label: '评级',
        please_enter_rating_error_message: '请输入 1 - 10 之间的评分',
        sponsor_type_page_breadcrumb: '赞助商类型',
        sponsor_type_sub_menu: '赞助商类型',
        note_for_sponsor_type_select_null_label: '注：评分应在 1-10 之间',
        please_enter_sponsor_type_error_message: '请输入赞助商类型',
        sponsor_type_label: '赞助商类型',
        default_currency_label: '默认货币',
        web_assets_sub_menu: '网络资产',
        web_assets_page_breadcrumb: '网络资产',
        web_assets_page_editpageheader: '网络资产',
        web_assets_label: '网络资产',
        logs_label: '日志',
        enable_audit_log_label: '启用审核日志',
        please_select_web_assets_error_message: '请选择网络资产',
        select_web_assets_dialog_header: '选择网络资产',
        select_media_dialog_header: '选择媒体',
        create_new_button_tooltip: '新建',
        create_new_button_text: '新建',
        select_rule_label: '选择过滤器',
        from_date_should_be_less_then_to_date_error_message: '起始日期应小于截止日期',
        show_repeat_pattern_detail_tooltip: '显示重复图案详细信息',
        please_select_repeat_pattern_error_message: '请先选择重复模式',
        account_name_label: '账户名称',
        bank_name_label: '银行名称',
        account_number_label: '帐号',
        swift_code_label: '斯威夫特代码',
        iban_number_label: '伊班号码',
        branch_label: '分公司',
        bank_details_label: '银行详情',
        hero_banner_mobile_label: '英雄横幅手机',
        hero_banner_tv_label: '英雄旗帜电视',
        square_label: '广场',
        circle_label: '圆',
        landscape_label: '风景',
        partner_ingestion_media_deal_right_confirmation_message: '您确定要导入没有交易权的媒体吗？',
        no_internet_connection_please_check_your_connection_and_try_again_label: '没有互联网连接。请检查您的连接并重试。',
        there_is_no_product_assigned_to_your_company_kindly_contact_team_BMS_label: '没有产品分配给您的公司，请联系 BMS 团队',
        you_dont_have_any_module_access_please_contact_your_admin_label: `您没有任何模块访问权限，请联系您的管理员`,
        show_break_only_label: '仅显示中断',
        locked_by_label: '锁定者',
        auto_plot_interstitial_label: '自动绘图插页式',
        show_logs_label: '显示日志',
        default_label: '默认',
        from_default_label: '从默认',
        update_successfully_label: '更新成功',
        show_provider_label: '显示提供商',
        show_censor_rating_label: '显示审查评级',
        show_episode_no_label: '显示集数',
        pi_page_setting_sub_menu: 'Pi页面设置',
        pi_page_setting_page_breadcrumb: 'Pi页面设置',
        pi_label: 'PI设定',
        seo_label: '搜索引擎优化设置',
        meta_tag_label: '元标签',
        meta_robot_label: '元机器人',
        meta_googlebot_label: '元谷歌机器人',
        pi_page_setting_page_editpageheader: 'Pi页面设置',
        show_description_label: '显示说明',
        show_synopsis_label: '显示概要',
        show_production_year_label: '演出制作年份',
        show_pg_rating_label: '显示 PG 评级',
        show_cast_and_crew_label: '演出演员和工作人员',
        show_language_label: '显示语言',
        show_release_date_label: '显示发布日期',
        show_genre_label: '演出类型',
        show_season_no_label: '演出季号',
        meta_title_label: '元标题',
        meta_description_label: '元描述',
        select_Field_tooltip: '选择字段',
        screenshot_label: '截图',
        theme_sub_menu: '主题',
        theme_page_breadcrumb: '主题',
        cta_details_label: '计算机辅助技术协会',
        general_details_label: '一般',
        tray_glow_details_label: '托盘发光',
        player_details_label: '玩家',
        theme_setting_dialog_header: '主题设定',
        deal_rights_give_automatically_for_all_channels_label: '交易权自动授予所有渠道',
        add_channel_rights_button_tooltip: '添加频道权限',
        you_are_not_authorized_to_edit_this_channel_error_message: '您无权更改此频道',
        permalink_structure_label: '固定链接结构',
        plain_label: '平原',
        numeric_label: '数字',
        post_name_label: '帖子名称',
        excrate_label: '汇率',
        note_enter_exchange_rate_equal_to_usd_label: '注意：输入汇率等于美元',
        excrate_should_not_be_negative_error_message: '汇率不应该是负数',
        you_delete_this_deal_right_right_from_parent_series_only_media_episode_publishing_error_message: '您只能直接从父系列中删除此交易...',
        you_delete_this_deal_right_right_from_series_only_media_episode_publishing_error_message: '您可以直接从系列中删除此交易...',
        agency_type_sub_menu: '代理类型',
        agency_type_label: '代理类型',
        you_are_not_authorized_to_edit_please_go_to_parent_series_error_message: '您无权编辑/删除。请前往家长系列',
        you_are_not_authorized_to_edit_please_go_to_series_error_message: '您无权编辑/删除。请前往系列',
        create_group_header_dialog: '创建群组',
        episode_group_page_breadcrumb: '剧集组',
        delete_media_episode_button_tooltip: '删除媒体片段',
        rail_title_details_label: '铁路标题',
        menu_details_label: '菜单',
        segment_by_rc_label: '按 RC 细分',
        reference_code_column: '参考代码',
        two_epiosde_per_day_label: '每天两集',
        open_theme_new_tab_label: '在新选项卡中打开主题',
        refresh_theme_label: '刷新主题',
        update_slot_duration_label: '更新时段持续时间',
        duration_updated_success_message: '持续时间已成功更新',
        please_select_duration_error_message: '请选择持续时间',
        restricted_genre_label: '限制类型',
        application_configuration_menu: '应用程序配置',
        application_configuration_breadcrumb: '应用程序配置',
        please_select_genre_error_message: '请选择类型',
        font_size_should_be_greater_than_zero_error_message: '字体大小应大于零',
        data_already_exist_error_message: '数据已存在',
        you_can_not_delete_in_edit_mode_error_message: '编辑模式下不能删除',
        please_add_atleast_one_genre_value_error_message: '请添加至少一种类型值',
        invalid_short_forms: '无效的简表',
        invalid_tooltip: '无效',
        save_draft_button_tooltip: '保存草稿',
        save_draft_button_title: '保存草稿',
        publish_button_text: '发布',
        program_group_is_mandatory_when_applying_recursive_on_movie_error_message: "请选择节目组以在电影/节目上应用递归",
        trigger_start_time_label: '触发开始时间',
        trigger_end_time_label: '触发结束时间',
        please_select_all_data_while_importing_playlist: '导入播放列表时请选择所有数据',
        all_days_can_not_be_excluded_error_message: '不能排除所有日子',
        dont_show_this_message_again: '不再显示此消息',
        media_episode_group_grid_note: '注意：应用递归时，序列将与上面网格中的序列相同',
        please_wait_export_report_message: '正在导出报告，请稍候...',
        segment_can_not_be_variation_error_message: "段不能设置为变体",
        can_edit_duration_of_segment_error_message: "只能编辑片段的持续时间",
        jobs_schedule_sub_menu: '职位安排',
        jobs_schedule_page_breadcrumb: '职位安排',
        enable_error_log_lebel: '启用错误日志',
        hourly_button_tooltip: '每小时',
        hourly_button_title: '每小时',
        daily_button_tooltip: '每日',
        daily_button_title: '每日',
        weekly_button_tooltip: '每周',
        weekly_button_title: '每周',
        monthly_button_tooltip: '每月',
        monthly_button_title: '每月',
        yearly_button_tooltip: '每年',
        yearly_button_title: '每年',
        quick_schedule_lebel: '快速安排',
        create_jobs_schedule_dialog_header: '创建工作计划',
        invalid_input_only_number_and_star_are_allow_error_message: '输入无效。只允许使用数字和 *',
        please_enter_command_error_message: '请输入命令',
        can_not_greater_than_error_message: '不能大于',
        variance_sub_menu: '方差',
        variance_label: '方差',
        tc_in_without_timecode_label: '锝温度',
        tc_out_without_timecode_label: '温度输出',
        duration_without_timecode_label: '期间',
        minute_label: '分钟（0-59）',
        hour_label: '小时（0-23）',
        day_Of_month_label: '日（1-31）',
        week_label: '周（1-7）',
        month_label: '月份（1-12）',
        can_not_less_than_error_message: '不能小于',
        archived_column: '已存档',
        archived_label: '已存档',
        please_upload_doc_error_message: '请上传文档',
        variation_type_column: '变异类型',
        create_variance_dialog_header: '创造差异',
        global_search_bar_placeholder: '查找应用程序、内容等。 ( Ctrl + / )',
        note_variance_link_from_interstitial_edit_form_label: '注意：您可以通过插页式编辑表单将插页式广告与此差异链接起来',
        duplicate_item_selected_error_message: '选择了重复的项目',
        please_select_same_media_category_media_only_global_replacement_error: "请仅选择相同媒体类别的媒体",
        restore_schedule_draft_validation_error_message: "无法恢复当前日期和当前日期之前天数的计划草稿",
        schedule_draft_3_month_auto_delete_note: '*注：超过 3 个月的草稿将被自动丢弃。如果您想保留更长时间，请将草稿保存在文件中',
        delete_planning_log_message: '删除选定的计划项目',
        edited_using_form_log_message: '使用表格编辑',
        add_new_planning_item_log_message: '添加新的计划项目',
        edited_using_drag_drop_messgae: '使用拖放进行编辑',
        planning_logs_dialog_header: '规划日志',
        slot_column: '插槽',
        missing_slot_time_for_error_message: '缺少插槽 -',
        slot_label: '插槽',
        edit_slot_dialog_header: '编辑槽位',
        attached_media_label: '媒体',
        time_bound_label: '有时间限制',
        live_events_label: '现场活动',
        tournament_label: '锦标赛',
        create_event_button_tooltip: '创建事件',
        create_event_button_text: '创建事件',
        match_label: '比赛',
        venue_label: '场地',
        poster_url_label: '海报网址',
        please_select_tournament_error_message: '请选择比赛',
        publish_match_header_dialog: '发布比赛',
        un_publish_match_label: '取消发布匹配',
        publish_match_label: '发布比赛',
        selected_days_label: '选定日期',
        copy_transfer_schedule_header_dialog: '复制/移动时间表',
        created_date_label: '创建日期',
        countries_sub_menu: '国家',
        countries_page_breadcrumb: '国家',
        pincode_sub_menu: '密码',
        pincode_page_breadcrumb: '密码',
        states_sub_menu: '州',
        states_page_breadcrumb: '州',
        pincodes_label: '密码',
        states_label: '州',
        countries_label: '国家',
        show_media_button_tooltip: '展会媒体',
        show_media_button_text: '展会媒体',
        create_genre_button_text: '创建流派',
        time_zone_page_breadcrumb: '时区',
        time_zone_sub_menu: '时区',
        is_negative_offset_default_label: '为负偏移',
        offset_label: '偏移量（时:分:秒）',
        please_enter_valid_start_time_message: '请输入有效的开始时间',
        time_zone_label: '时区',
        date_time_column: '日期时间',
        time_zone_column: '时区',
        insert_live_event_actionbutton_menutext: '插入现场活动',
        insert_live_event_actionbutton_menutext_tooltip: '插入现场活动',
        virtual_segmentation_actionbutton_menutext: '虚拟分割',
        virtual_segmentation_actionbutton_menutext_tooltip: '虚拟分割',
        edit_actionbutton_menutext_tooltip: '编辑',
        select_all_Header_actionbutton_menutext_tooltip: '选择所有标题',
        delete_header_actionbutton_menutext_tooltip: '删除标题',
        insert_break_actionbutton_menutext_tooltip: '插入中断',
        program_replacement_actionbutton_menutext_tooltip: '程序替换',
        expand_all_breaks_actionbutton_menutext_tooltip: '展开所有中断',
        mnimize_all_breaks_actionbutton_menutext_tooltip: '尽量减少所有中断',
        attach_format_reload_actionbutton_menutext_tooltip: '附加格式',
        fast_segmentation_actionbutton_menutext_tooltip: '快速分割',
        remove_filter_actionbutton_menutext_tooltip: '删除过滤器',
        filter_actionbutton_menutext_tooltip: '筛选',
        revert_virtual_segmentation_actionbutton_menutext: '恢复虚拟段',
        revert_virtual_segmentation_actionbutton_menutext_tooltip: '恢复虚拟段',
        copy_actionbutton_menutext_tooltip: '复制',
        cut_actionbutton_menutext_tooltip: '切',
        paste_actionbutton_menutext_tooltip: '粘贴',
        delete_actionbutton_menutext_tooltip: '删除',
        se_overview_actionbutton_menutext_tooltip: 'SE概述',
        global_replacement_actionbutton_menutext_tooltip: '全球更换',
        delete_secondary_events_actionbutton_menutext: '删除次要事件',
        delete_secondary_events_actionbutton_menutext_tooltip: '删除次要事件',
        internal_drag_live_event_error_message: '无法更改直播活动。请删除并重新发布！！',
        search_name_label: '搜索名称',
        imdb_details_label: 'IMDb 详细信息',
        year_column: '年',
        imdb_id_column: 'IMD 数据库 ID',
        poster_column: '海报',
        imdb_label: '互联网医学数据库',
        actor_label: '演员',
        rated_label: '额定',
        country_label: '国家',
        director_label: '导演',
        writer_label: '作家',
        awards_label: '奖项',
        dvd_label: '光盘',
        imdb_votes_label: 'IMDb 投票',
        imdb_id_label: 'IMD 数据库 ID',
        production_label: '生产',
        website_label: '网站',
        box_office_label: '票房',
        meta_score_label: '元分数',
        release_label: '发布',
        please_enter_search_name_error_message: '请输入搜索名称',
        rails_type_details_dialog_header: '导轨类型详细信息',
        no_image_found_error_message: '没有找到图片',
        please_select_item_first_error_message: '请先选择商品！',
        update_imdb_label: '更新 IMDb',
        subscription_label: '订阅',
        revenue_label: '收入',
        total_subscriber_label: '订阅者总数',
        new_subscriber_label: '新订阅者',
        total_deactive_subscriber_label: '不活动订阅者',
        total_activation_label: '总激活数',
        expiring_users_label: '即将到期的订阅者',
        revenue_by_month_label: '每月收入',
        revenue_by_platform_label: '按平台划分的收入',
        revenue_by_payment_gateway_label: '支付网关收入',
        revenue_by_currency_label: '按货币划分的收入',
        customers_registration_count_graph: '每月订阅者注册数量',
        customers_registration_platform_wise: "订户注册平台明智",
        purchases_by_payment_gateway: "通过支付网关购买",
        subscriber_by_platform: '按平台划分的订阅者',
        maximum_devices_label: '最大设备数',
        please_select_platform_type_error_msg: '请选择平台',
        maximun_device_should_not_be_less_than_one: "最大设备数不应小于 1",
        region_details_monetization_dashboard_label: '地区产品、优惠券和订阅者',
        subscribers_by_plan_label: '按计划划分的订阅者',
        show_provider_icon_label: '显示提供商图标',
        subscriber_subscription_history: '订阅历史',
        provider_label: '提供者',
        auto_renew_subscription_label: '自动续订包',
        subscriber_login_history: '登录记录',
        create_payment_provider_dialog_header: '创建支付提供商',
        currency_code_label: '货币代码',
        branding_name_label: '品牌名称',
        branding_logo_label: '品牌标志',
        branding_color_label: '品牌颜色',
        message_label: '信息',
        sand_box_key_id_label: '沙盒密钥 ID',
        sand_box_secret_key_label: '沙箱秘钥',
        live_key_id_label: '实时密钥 ID',
        live_secret_key_label: '实时密钥',
        success_url_label: '成功网址',
        failure_url_label: '失败网址',
        please_enter_live_key_id_error_message: '请输入实时密钥 ID',
        please_enter_live_secret_key_error_message: '请输入实时密钥',
        please_enter_key_id_error_message: '请输入秘钥ID',
        please_enter_secret_key_error_message: '请输入密钥',
        please_enter_currency_code_error_message: '请输入货币代码',
        please_enter_branding_name_error_message: '请输入品牌名称',
        please_enter_branding_logo_error_message: '请输入品牌标志',
        please_enter_success_url_error_message: '请输入成功网址',
        please_enter_failure_url_error_message: '请输入失败网址',
        locale_label: '语言环境',
        payment_gateway_url_label: '支付网关网址',
        please_enter_payment_gateway_url_error_message: '请输入支付网关网址',
        some_attached_rails_are_full_page_type_and_can_be_attached_independently_only_error_message: '一些附加导轨是整页类型，只能独立附加',
        session_terminated_label: '会话终止',
        your_session_has_been_terminated_label: '您的会话已终止',
        next_publish_date_label: '下次发布日期',
        create_tournament_type_dialog_header: '创建锦标赛类型',
        create_live_event_type_dialog_header: '创建现场活动类型',
        please_select_house_number_error_message: '请选择门牌号',
        successfully_exported_success_message: '成功导出',
        please_enter_cast_and_crew_error_message: '在 Meta Data Cast and Crew 中输入艺术家',
        music_category_sub_menu: '音乐类别',
        music_category_page_breadcrumb: '音乐类别',
        create_music_category_dialog_header: '创建音乐类别',
        is_music_label: '是音乐',
        select_music_category_dialog_header: '选择音乐类别',
        music_category_label: '音乐类别',
        available_music_dialog_header: '可用的音乐',
        please_select_music_category_error_message: '请选择音乐类别',
        music_menu: '音乐',
        more_button_tooltip: '更多',
        more_button_text: '更多',
        text_color_label: '文字颜色',
        program_time_consumption_report_sub_menu: '程序耗时报告',
        program_time_consumption_report_page_breadcrumb: '程序耗时报告',
        music_report_sub_menu: '音乐报告',
        music_report_page_breadcrumb: '音乐报告',
        total_runs_column: '总运行次数',
        total_run_time_column: '总运行时间',
        translate_synopsis_level: '翻译概要',
        tx_mode_sub_menu: '发射模式',
        tx_mode_page_breadcrumb: '发射模式',
        series_library_label: '系列库',
        digital_sign_menu: '数字标牌',
        model_sub_menu: '型号',
        model_page_breadcrumb: '型号',
        dimensions_label: '尺寸',
        model_number_label: '型号',
        resolution_label: '分辨率',
        display_shape_label: '显示形状',
        brightness_label: '亮度',
        display_size_label: '显示尺寸',
        mounting_type_label: '安装类型',
        create_model_dialog_header: '创建模型',
        display_shape_sub_menu: '显示形状',
        display_shape_page_breadcrumb: '显示形状',
        resolution_sub_menu: '分辨率',
        resolution_page_breadcrumb: '分辨率',
        please_select_brand_error_message: '请选择品牌',
        please_enter_screen_dimensions_error_message: '请输入屏幕尺寸',
        please_enter_model_number_error_message: '请输入型号',
        please_enter_mounting_type_error_message: '请输入安装类型',
        please_select_module_resolution_error_message: '请选择模块分辨率',
        please_select_display_shape_error_message: '请选择显示形状',
        please_enter_brightness_error_message: '请输入亮度',
        please_enter_display_size_error_message: '请输入显示尺寸',
        digital_sign_brand_sub_menu: '品牌',
        digital_sign_brand_page_breadcrumb: '数字标牌品牌',
        create_node_dialog_header: '创建节点',
        parent_node_label: '父节点',
        digital_sign_node_page_breadcrumb: '数字标牌节点',
        node_sub_menu: '节点',
        add_sign_board_button_tooltip: '添加标牌',
        digital_sign_board_page_breadcrumb: '数字标牌',
        digital_sign_board_sub_menu: '董事会',
        model_label: '型号',
        node_label: '节点',
        warranty_start_date_label: '保修开始日期',
        warranty_End_date_label: '保修结束日期',
        sign_board_id_label: '标牌ID',
        model_column: '型号',
        sign_board_id_column: '标牌ID',
        warranty_date_column: '保修日期',
        delete_sign_board_button_tooltip: '删除标牌',
        date_wise_sheet_label: '日期明智表',
        tx_status_sub_menu: '发送状态',
        tx_status_page_breadcrumb: '发送状态',
        update_txstatus_actionbutton_menutext: '更新发送状态',
        add_comment_actionbutton_menutext: '添加评论',
        update_comment_actionbutton_menutext: '更新评论',
        tx_status_label: "发送状态",
        digital_sign_model_page_breadcrumb: '数字标牌模型',
        please_select_resolution_error_message: '请选择分辨率',
        please_enter_dimensions_error_message: '请输入尺寸',
        digital_sign_board_label: '数字标牌',
        warranty_end_date_label: '保修结束日期',
        create_board_dialog_header: '创建板',
        please_select_model_error_message: '请选择型号',
        please_enter_sign_board_id_error_message: '请输入标牌ID',
        create_resolution_dialog_header: '创建分辨率',
        length_label: '长度',
        please_enter_length_error_message: '长度应大于0',
        please_width_length_error_message: '宽度应大于 0',
        confirm_delete_all_label: '确认全部删除',
        are_you_sure_do_you_want_to_delete_all_label: '您确定要删除全部吗',
        serial_number_label: '序列号',
        please_enter_serial_number_error_message: '请输入序列号',
        aspect_ratio_label: '纵横比',
        width_should_be_greater_than_zero_error_message: '宽度应大于零',
        height_should_be_greater_than_zero_error_message: '高度应大于零',
        playlist_sub_menu: '播放列表',
        playlist_page_breadcrumb: '播放列表',
        nodes_lable: '节点',
        digital_sign_overlay_label: '叠加',
        can_not_add_same_parent_node_error_message: `无法添加相同的父节点`,
        publish_selected_match_label: '发布选定的比赛',
        choose_another_parent_node_error_message: '选择另一个父节点',
        digital_sign_overlay_page_breadcrumb: '数字标牌覆盖',
        overlay_page_breadcrumb: '叠加',
        digital_sign_overlay_sub_menu: '叠加',
        digital_sign_board_overlay_editpage_header: '板覆盖',
        shape_label: '形状',
        position_label: '位置',
        text_label: '文字',
        font_weights_label: '字体粗细',
        font_color_label: '字体颜色',
        please_enter_shape_error_message: '请输入形状',
        font_family_label: '字体家族',
        overlay_type_label: '覆盖类型',
        font_size_label: '字体大小',
        border_radius_label: '边界半径',
        opacity_label: '不透明度',
        text_marquee_label: '文本字幕',
        opacity_note: '注意：不透明度应在 0 到 1 之间',
        margin_lrtb_text_label: "文本边距",
        width_percentage_should_be_greater_than_zero_and_less_than_hundred_error_message: '宽度 % 应大于 0 且小于 100',
        height_percentage_should_be_greater_than_zero_and_less_than_hundred_error_message: '高度百分比应大于 0 且小于 100',
        asset_bundle_sub_menu: '资产包',
        asset_bundle_page_breadcrumb: '资产包',
        edit_asset_bundle_editpage_header: '编辑资源包',
        create_asset_bundle_editpage_header: '创建资源包',
        add_ott_asset_button_tooltip: '添加资产',
        channel_number_label: '通道数',
        create_tx_mode_dialog_header: '创建发送模式',
        is_type_live_label: '实时输入',
        sub_genre_label: '子流派',
        current_active_version_label: '当前有效版本',
        disable_live_event_section_label: '禁用现场活动部分',
        export_segmentation_tooltip_button: 'Export Segmentation',
        text_position_label: '文本位置',
        text_opacity_label: '文本不透明度',
        digital_sign_board_overlay_page_breadcrumb: '数字标牌覆盖',
        please_enter_valid_numbers_in_duration: '请输入有效的持续时间数字',
        text_shape_label: '文字形状',
        layer_label: '图层',
        spotify_label: 'Spotify',
        add_blank_label: '添加空白',
        sync_reference_code_message: '它将使用系列代码作为前缀并后跟剧集编号来更新链接的剧集参考代码。',
        geners_label: '几代人',
        sub_geners_label: '子属',
        downloading_please_wait_message: '正在下载，请稍候...',
        format_schedule_sub_menu: '格式化时间表',
        format_schedule_page_breadcrumb: '格式化时间表',
        create_schedule_format_dialog_header: '创建时间表格式',
        select_format_dialog_header: '选择格式',
        please_select_format_error_message: '请选择格式',
        please_enter_valid_from_error_message: '请输入有效日期',
        please_enter_valid_to_error_message: '请输入有效至',
        please_select_items_to_update_message: '请选择要更新的项目',
        update_successfully_message: '更新成功',
        please_select_pg_rating_error_message: '请选择PG评级',
        please_select_censor_rating_error_message: '请选择审查评级',
        please_select_languages_error_message: '请选择语言',
        please_select_categories_error_message: '请选择类别',
        please_select_genres_error_message: '请选择类型',
        please_select_sub_genres_error_message: '请选择子流派',
        please_enter_production_year_error_message: '请输入生产年份',
        please_select_technical_prototype_error_message: '请选择技术样机',
        please_enter_keywords_error_message: '请输入关键词',
        variation_label: '变化',
        execute_button_tooltip: '执行',
        execute_button_text: '执行',
        download_summary_tooltip: '下载摘要',
        from_date_should_be_current_date_error_message: '起始日期应为当前日期/未来日期',
        next_number_can_not_be_negative_or_zero_error_meessage: '下一个数字不能为负数或零',
        number_length_should_be_between_1_to_10_error_message: '号码长度应在 1 到 10 之间',
        create_fast_playlist_dialog_header: '创建快速播放列表',
        digital_sign_screen_group_page_breadcrumb: '屏幕组',
        digital_sign_screen_group_sub_menu: '屏幕组',
        activate_screen_button_tooltip: '激活屏幕',
        activate_button_text: '激活',
        activate_button_tooltip: '激活',
        activate_screen_dialog_header: '激活屏幕',
        please_enter_screen_name_error_message: '请输入屏幕名称',
        please_enter_otp_error_message: '请输入一次性密码',
        show_segmentation_actionbutton_menutext: '显示细分',
        show_segmentation_actionbutton_menutext_tooltip: '显示细分',
        screen_page_breadcrumb: '屏幕',
        create_screen_group_dialog_header: '创建屏幕组',
        screen_sub_menu: '屏幕',
        attach_screen_group_dialog_header: '附加屏幕组',
        digital_sign_content_page_breadcrumb: '内容',
        digital_sign_content_sub_menu: '内容',
        create_content_dialog_header: '创建内容',
        please_select_content_type_error_message: '请选择内容类型',
        please_select_url_error_message: '请选择网址',
        content_type_label: '内容类型',
        duration_type_label: '期间',
        playlist_label: '播放列表',
        screen_group_label: '屏幕组',
        player_label: '玩家',
        orientation_label: '方向',
        playing_now_label: '正在播放',
        restart_label: '重新启动',
        restart_app_label: '重新启动应用程序',
        cpu_usage_label: '中央处理器使用率',
        do_you_really_want_to_delete_question: "您真的要删除吗？",
        percentage_label: '百分比',
        digital_sign_content_label: "内容",
        digital_sign_dashboard_sub_menu: '仪表板',
        digital_sign_dashboard_page_breadcrumb: '仪表板',
        new_screen_group_button_title: '新银幕集团',
        new_playlist_button_title: '新播放列表',
        new_content_button_title: '新内容',
        new_screen_button_title: '新画面',
        add_screen_group_dialog_header: '添加屏幕组',
        playlist_dialog_header: '播放列表',
        same_screen_group_error_message: '无法添加相同的屏幕组',
        add_more_label: '添加更多',
        thumbnail_column: "缩略图",
        overlays_column: "叠加层",
        email_address_label: '电子邮件地址',
        sign_up_label: '注册',
        company_name_label: '公司名称',
        country_code_label: '国家/地区代码',
        industries_label: '行业',
        network_screen_size_label: '网络屏幕尺寸',
        how_did_you_found_us_label: '您是如何找到我们的',
        please_enter_password_error_message: '请输入密码',
        please_enter_company_name_error_message: '请输入公司名称',
        please_select_country_code_error_message: '请选择国家代码',
        please_enter_phone_error_message: '请输入电话',
        please_select_industry_error_message: '请选择行业',
        please_select_network_screen_size_error_message: '请选择网络屏幕尺寸',
        please_select_how_did_you_found_us_error_message: '请选择您是如何找到我们的',
        sign_up_dialog_header: '注册',
        login_label: '登录',
        do_not_have_an_account_label: '没有帐户？',
        forgot_password_label: '忘记密码？',
        screen_players_label: '掩护/球员',
        username_label: '用户名',
        manage_underoverrun_schedule_menu_text: '插槽自动填充',
        add_program_menutext: "添加节目",
        instance_label: '实例',
        instances_sub_menu: '实例',
        instances_page_breadcrumb: '实例',
        forgot_your_password_label: '忘记密码？',
        enter_email_note: '输入您的电子邮件和链接，我们将通过您的电子邮件发送新生成的密码',
        remember_password_label: '记住密码？',
        reset_password_button_text: '重置密码',
        progress_column: '进展',
        select_interstitial_group_dialoag_header: '选择插页式组',
        interstitial_group_button_tooltip: '插页式组',
        auto_planning_tooltip: "自动规划",
        auto_planning_with_boss_ai_tooltip: "Boss AI 自动规划",
        day_part_sub_menu: '日间部分',
        day_part_page_breadcrumb: '日间部分',
        create_day_part_dialog_header: '创建日间部分',
        priority_label: '优先级',
        please_enter_from_time_error_message: '请输入时间',
        please_enter_to_time_error_message: '请输入时间',
        please_enter_priority_error_message: '请输入有效的优先级',
        please_select_valid_days_error_message: '请选择有效日期',
        please_enter_youtube_link_error_message: '请输入 YouTube 链接',
        link_label: '链接',
        add_new_button_tooltip: '添加新内容',
        attach_screens_column: '连接屏幕',
        isAllChannel_label: '全频道',
        day_part_label: '日间部分',
        please_select_day_part_error_message: '请选择当日时段',
        please_enter_reference_code_error_message: "请输入参考代码",
        company_label: '公司',
        please_enter_correct_phone_number_error_message: '请输入正确的电话号码',
        header_address_font_size_label: '标题地址字体大小',
        spots_details_font_size_label: '斑点详细信息字体大小',
        digital_sign_company_plans_page_breadcrumb: '公司计划',
        myrepeatpattern_labe: '自创',
        style_sheet_dialog_header: '样式表',
        digital_sign_company_plans_sub_menu: '公司计划',
        download_the_app_label: '下载应用程序',
        in_house_label: '内部',
        digital_sign_admin_dashboard_menu: '管理仪表板',
        digital_sign_admin_dashboard_page_breadcrumb: '管理仪表板',
        last_five_user_login_label: '最后 5 位用户登录',
        create_content_button_tooltip: '创建内容',
        create_genre_button_tooltip: '创建流派',
        create_sub_genre_button_tooltip: '创建子流派',
        create_cast_type_button_tooltip: '创建演员类型',
        digital_sign_plans_sub_menu: '计划',
        digital_sign_plans_page_breadcrumb: '计划',
        edit_image_url_dialog_header: '编辑图片网址',
        attach_screen_dialog_header: '连接屏幕',
        attachments_label: '附件',
        file_attachment_button_tooltip: '文件附件',
        file_column: '文件',
        file_attachment_dialog_header: '文件附件',
        version_column: '版本',
        targets_label: '目标',
        weightage_label: '权重',
        weightage_column: '权重',
        play_count_label: '播放次数',
        play_count_column: '播放次数',
        isplaybycount_label: '按计数播放',
        isplaybycount_column: '按计数播放',
        weightage_should_be_less_than_fifty_error_message: '权重应小于 50',
        please_enter_correct_weightage_error_message: '请输入正确的重量',
        please_enter_correct_play_count_error_message: '请输入正确的播放次数',
        play_count_should_be_less_than_fifty_error_message: '播放次数应少于 50',
        isfetchfromlibrary_label: '从库中获取',
        create_instance_dialog_header: '创建实例',
        base_url_label: '基本网址',
        db_name_label: '数据库名称',
        digisign_socket_base_url_label: 'Digisign 套接字基本 URL',
        socket_base_url_label: '套接字基本 URL',
        storage_destination_label: '存储目的地',
        cloud_name_label: '云名称',
        api_key_label: 'API密钥',
        api_secret_label: 'API秘密',
        access_key_id_label: '访问密钥',
        secret_access_key_label: '秘密访问密钥',
        bucket_name_label: '桶名称',
        please_enter_base_url_error_message: '请输入基本网址',
        please_enter_bdname_error_message: '请输入BD名称',
        please_enter_digisign_socket_base_url_error_message: '请输入 Digisign 套接字基本 URL',
        please_enter_socket_base_url_error_message: '请输入套接字基本 URL',
        quality_label: '品质',
        quality_should_be_less_than_100_error_message: '质量应低于 100',
        file_label: '文件',
        keep_org_label: '保持原创',
        cdn_url_label: '域名网址',
        please_enter_cdn_url_error_message: '请输入CDN网址',
        please_cloud_name_error_message: '请输入云名称',
        please_api_key_error_message: '请输入API密钥',
        please_api_secret_error_message: '请输入API密码',
        please_access_keyid_error_message: '请输入访问密钥 ID',
        please_secret_access_key_error_message: '请输入秘密访问密钥',
        please_region_error_message: '请输入地区',
        please_bucket_name_error_message: '请输入存储桶名称',
        column_label: '专栏',
        please_select_column_error_message: "请选择栏目",
        please_select_operator_error_message: "请选择运营商",
        fill_gaps_label: "填补空白",
        digital_sign_content_group_sub_menu: '内容组',
        digital_sign_content_group_page_breadcrumb: '内容组',
        content_group_editpage_header: '创建内容组',
        add_content_button_tooltip: '添加内容',
        digital_sign_add_content_dialog_header: '添加内容',
        please_attach_atleast_one_content_error_message: '请附上至少一项内容',
        digital_sign_content_group_label: '内容组',
        minimum_gap_label: "最小间隙（以小时为单位）",
        segment_for_channel_rights_label: '如果您没有某些片段的频道权限，某些片段将被禁用。',
        already_have_an_account_label: '已经有帐户？',
        min_gap_error_message: "最小间隙不能为负",
        min_gap_invalid_error_message: "请输入有效的最小间隙",
        set_as_default_label: '设置为默认值',
        minimum_gap_in_primary_event_label: '最小间隙（以天为单位）',
        is_tx_status_label: '发送状态',
        tx_status_column: '发送状态',
        restricted_pg_rating_label: '限制PG评级',
        marker_label: '标记',
        in_label: '在',
        out_label: '出',
        marker_duration_label: '期间',
        time_code_markers: '时间码标记',
        duration_label_tooltip: '（时：分：秒：晚）',
        create_marker_button_tooltip: '创建标记',
        please_enter_valid_value_in_error_message: '请输入有效的输入',
        please_enter_valid_value_out_error_message: '请输入有效值，In 不应大于 Out',
        in_column: '在',
        out_column: '出',
        Tcm: '中医',
        please_select_time_code_marker_error_message: '请选择时间码标记',
        ott_platform_sub_menu: '平台',
        ott_platform_page_breadcrumb: '平台',
        module_restrictions_label: '模块限制',
        action_label: '行动',
        please_select_segment_header: '请选择细分',
        restriction_actions_label: "限制行动",
        no_permission_to_delete_header_info: '您无权删除标头。',
        please_contact_admin_message: "请联系管理员",
        privacy_policy_label: '隐私政策',
        ott_assets_used_in_archive_confirmation_message: "该资产用于",
        ott_assets_archive_confirmation_message: "您还想存档吗？",
        ingestion_report_sub_menu: '摄入报告',
        ingestion_report_page_breadcrumb: '摄入报告',
        cast_and_crew_column: '演员及工作人员',
        censor_rating_column: '审查评级',
        production_year_column: '生产年份',
        activity_dropdown_label: '活动',
        asset_type_column: '资产类型',
        provider_column: '提供者',
        access_level_column: '访问级别',
        vod_type_column: '点播类型',
        potrait_image_url_column: '肖像图片网址',
        landscape_image_url_column: '风景图片网址',
        playlist_import_buffer_label: '播放列表导入缓冲区',
        is_negative_playlist_import_buffer_label: "是 -ve 播放列表导入增益。",
        playlist_export_buffer_label: '播放列表导出缓冲区',
        is_negative_playlist_export_buffer_label: "是 -ve 播放列表导出增益。",
        add_user_dialog_header: '添加用户',
        add_new_company_dialog_header: '添加新公司',
        tenure_label: '终身教职',
        screens_label: '屏幕',
        storage_label: '存储',
        plan_label: '计划',
        users_label: '用户',
        please_enter_plan_name_error_message: '请输入计划名称',
        plan_tenure_should_be_greater_than_zero_error_message: '任期应大于 0',
        plan_screens_should_be_greater_than_zero_error_message: '屏幕数应大于 0',
        plan_storage_should_be_greater_than_zero_error_message: '存储量应大于0',
        please_add_atleast_one_user_error_message: '请添加至少一名用户',
        enter_your_pin_label: '输入您的 PIN 码',
        please_select_company_error_message: '请选择公司',
        event_country_level: '活动国家',
        please_enter_event_country_error_message: '请输入活动国家/地区',
        team_a_poster_url_label: 'A 队海报网址',
        team_b_poster_url_label: 'B 队海报网址',
        company_type_label: '公司类型',
        tournament_group_dialog_header: '比赛组别',
        tournament_group_page_breadcrumb: '比赛组别',
        tournament_group_sub_menu: '比赛组别',
        tournament_group_label: '比赛组别',
        please_select_tournament_group: '请选择比赛组别',
        add_playlist_button_tooltip: '添加播放列表',
        plans_label: '计划',
        change_password_button_tooltip: '更改密码',
        change_password_dialog_header: '更改密码',
        successfully_change_password_message: '密码修改成功',
        asrun_report_dialog_header: '阿斯伦报告',
        playlist_name_column: '播放列表名称',
        screen_name_column: '屏幕名称',
        serial_number_column: '序列号',
        every_label: '每个',
        is_auto_restart_enabled_label: '自动重启',
        daily_reboot_label: '每日重启',
        restart_time_label: '重新启动时间',
        screen_group_column: '屏幕组',
        playlist_column: '播放列表',
        epg_convertor_sub_menu: '电子节目指南转换器',
        source_epg_file_label: '源EPG文件',
        opta_file_label: 'OPTA文件',
        image_url_file_label: '图片网址文件',
        source_epg_tab_label: '来源电子节目指南',
        opta_tab_label: 'OPTA',
        image_url_tab_label: '图片网址',
        converted_epg_tab_label: '转换后的电子节目指南',
        convert_button_label: "转换",
        global_label: '全球',
        media_template_sub_menu: '媒体模板',
        media_template_page_breadcrumb: '媒体模板',
        media_template_dialog_header: '媒体模板',
        select_media_template_collection_header: '选择媒体模板',
        save_and_create_media_template_button_tooltip: '保存并创建媒体模板',
        select_media_template_button_tooltip: '选择媒体模板',
        save_as_media_template_button_text: '另存为模板',
        startup_button_tooltip: '启动',
        startup_button_title: '启动',
        task_label: "任务",
        curl_label: "卷曲/API",
        please_select_task_error_message: "请选择任务",
        command_label: "命令",
        execute_shell_label: "执行外壳",
        disable_lebel: "禁用",
        mudule_label: "模块",
        command_column: "命令",
        execute_shell_column: "执行外壳",
        schedule_column: "时间表",
        enable_error_log_column: "启用错误日志",
        disable_column: "禁用",
        success_count_column: "成功次数",
        last_activity_count_column: "上次活动",
        next_schedule_time_column: "下次预定时间",
        please_add_atleast_one_publishing_rights_error_message: '请添加至少一项出版权',
        genres_label: '流派',
        sub_genres_label: '子流派',
        avod_Configuration_sub_menu: "点播配置",
        avod_Configuration_label: "点播配置",
        ad_tags_column: "广告标签",
        avod_Configuration_dialog_header: "创建 Avod 配置",
        features_label: "特点",
        please_select_title_error_message: "请选择标题",
        ad_tag_column: "广告标签",
        avod_configuration_page_breadcrumb: "点播配置",
        avod_feature_label: "点播功能",
        ad_tag_label: "创建广告代码",
        please_select_ad_tag_error_message: "请选择广告标记",
        linked_channels_label: "链接频道",
        gender_label: "性别",
        please_select_gender_error_message: "请选择性别",
        parent_contract_label: "家长合同",
        select_contract_collection_header: "合同收集",
        non_linear_publishing_label: '非线性出版',
        video_not_found_error_message: "找不到视频",
        time_line_view_tooltip: '时间轴视图',
        response_area_label: "回复",
        job_schedule_base_url_label: '工作计划基本 URL',
        please_enter_job_schedule_base_url_error_message: '请输入工作计划基本网址',
        downloading_excel_please_wait_message: '正在下载 Excel 请稍候...',
        enable_notification_label: '启用通知',
        show_shedule_dialog_header: '演出时间表',
        please_select_atleast_one_item_error_message: '请选择至少一项',
        please_select_item_to_replace_error_message: '请选择要更换的项目',
        schedule_time_column: '安排时间',
        select_item_to_replace_label: '选择要替换的项目',
        save_and_run_button_text: '保存并运行',
        epg_template_label: "电子节目指南模板",
        message_sub_menu: "信息",
        message_provider_sub_menu: "消息提供者",
        message_template_sub_menu: "消息模板",
        message_configuration_sub_menu: "消息配置",
        message_provider_page_breadcrumb: "消息提供者",
        message_template_page_breadcrumb: "消息模板",
        message_configuration_page_breadcrumb: "消息配置",
        message_provider_dialog_header: "创建消息提供者",
        auth_key_lable: "验证密钥",
        message_template_dialog_header: "创建消息模板",
        is_unicode_label: "统一码",
        is_flash_label: "闪光灯",
        sender_id_lable: "发件人ID",
        message_configuration_dialog_header: "消息配置",
        message_type_label: "消息类型",
        message_template_label: "消息模板",
        message_provider_label: "消息提供者",
        please_enter_auth_key_error_message: "请输入授权密钥",
        please_enter_content_error_message: "请输入内容",
        please_enter_sender_id_error_message: "请输入发件人 ID",
        please_select_message_type_error_message: "请选择留言类型",
        message_variant_label: "消息变体",
        devices_label: "设备",
        device_name_column: "设备名称",
        last_login_time_column: "上次登录时间",
        important_update_successfully_message: "重要更新成功",
        param_label: "参数",
        please_add_atleast_one_Ad_tags_error_message: "请添加至少一个广告标签",
        ingestion_logs_dialog_header: "摄取日志",
        ingestion_logs_sub_menu: "摄取日志",
        status_label: "地位",
        ingestion_logs_page_breadcrumb: "摄取日志",
        partner_ingestion_template: "摄取模板",
        partner_ingestion_base_url: "摄取基础 URL",
        please_select_ingestion_template: "请选择摄取模板",
        please_enter_ingestion_base_url: "请输入摄取基础 URL",
        data_column: "数据",
        please_enter_curl_error_message: '请输入卷曲',
        params_label: '参数',
        row_label: "行",
        table_view_label: "表格视图",
        please_select_message_variant_error_message: "请选择消息变体",
        deactive_lebel: "停用",
        parent_genre_label: "家长类型",
        parent_language_label: "家长语言",
        parent_pg_rating_label: "家长 PG 评级",
        parent_censor_rating_label: "家长审查评级",
        censor_rating_sub_menu: "审查评级",
        pg_rating_dialog_header: "创建PG评级",
        censor_rating_dialog_header: "创建审查评级",
        match_type_label: '比赛类型',
        match_type_page_breadcrumb: "比赛类型",
        match_type_sub_menu: "比赛类型",
        match_type_dialog_header: "创建匹配类型",
        Column_column: '专栏',
        request_label: '请求',
        sales_dialog_header: '创建销售',
        concurrency_label: '并发性',
        force_upgrade_label: '强制升级',
        please_enter_version_error_message: '请输入版本',
        check_every_label: '检查每个',
        analytics_providers_sub_menu: '分析提供商',
        analytics_providers_page_breadcrumb: '分析提供商',
        analytics_events_sub_menu: '分析事件',
        analytics_events_page_breadcrumb: '分析事件',
        create_analytics_provider_dialog_header: '创建分析提供商',
        please_enter_api_key_error_message: '请输入API密钥',
        analytics_event_page_editpageheader: '分析事件',
        please_enter_provider_name_error_message: '请输入提供商名称',
        provider_name_label: '提供商名称',
        parental_control_label: '启用家长控制',
        symbol_label: '符号',
        please_enter_symbol_error_message: '请输入符号',
        independent_episode_page_breadcrumb: '独立剧集',
        subscriber_profile_dialog_header: '订户资料',
        enable_pg_restriction_label: '启用 PG 限制',
        pin_label: '销',
        enable_parent_control_label: '启用家长控制',
        restricted_pgratings_label: '限制级',
        debug_mode_label: '调试模式',
        auto_restart_percent_label: '自动重启',
        set_resolution_dialog_header: '设置分辨率',
        asrun_report_label: '阿斯润报告',
        asrun_report_tooltip: '阿斯伦报告',
        auto_fill_playlist_dialog_header: '自动填充播放列表',
        apply_fixed_sequence_label: '应用固定序列',
        apply_fixed_start_items_label: '应用固定启动项',
        auto_manage_footers_label: '自动管理页脚',
        allowed_footers_offset_label: '允许的页脚偏移',
        fix_playlist_label: '24 小时修复播放列表',
        categories_required_in_sequence: '按顺序需要的类别',
        select_format_label: '选择格式',
        select_format_collection_header: '选择格式',
        select_media_category_type_collection_header: '选择媒体类别类型',
        error_log_column: '错误日志',
        please_wait_loading_error_message: '请稍候加载中...',
        media_management_report_sub_menu: '媒体管理报告',
        media_management_report_dialog_header: '媒体管理报告',
        media_content_report_sub_menu: '媒体内容报道',
        media_content_report_page_breadcrumb: '媒体内容报道',
        long_form_label: '长格式',
        short_form_label: '简短形式',
        spot_label: '现货',
        play_mode_label: '播放模式',
        memory_label: '内存',
        used_label: '二手',
        free_label: '免费',
        delete_storage_button_tooltip: '删除存储',
        asrun_error_report_dialog_header: '运行错误',
        restart_history_dialog_header: '重启历史记录',
        enable_asrunlog_label: '启用AsrunLog',
        take_periodic_screenshots_label: '定期屏幕截图',
        image_format_label: '图片格式',
        video_format_label: '视频格式',
        restart_type_column: '重启类型',
        preset_label: '预设',
        commercial_schedule_list: "预定商业点",
        disable_profile_selection_label: "禁用配置文件选择",
        auto_fill_music: "自动填充音乐",
        content_group_label: '内容组',
        digital_sign_add_content_group_dialog_header: '添加内容组',
        digital_sign_add_overlays_dialog_header: '添加叠加层',
        restart_screen_label: '重新启动屏幕',
        sports_event_label: '体育赛事',
        mam_asset_report: '妈妈资产报告',
        successfully_delete_storage_label: '成功删除存储',
        live_event_details: '现场活动详情',
        please_create_screen_first_label: '请先创建一个屏幕...',
        screen_create_description_label: '添加屏幕后，您可以创建内容，然后创建播放列表。',
        add_screen_button_label: '添加屏幕',
        please_create_content_label: '请创建内容...',
        content_create_description_label: '添加内容后，您可以创建播放列表。',
        add_content_button_label: '添加内容',
        please_create_playlist_label: '请创建一个播放列表...',
        playlist_create_description_label: '您可以创建播放列表，单击添加播放列表',
        add_playlist_button_label: '添加播放列表',
        create_content_label: '创建内容',
        content_message_label: '您想添加内容吗？',
        create_playlist_label: '创建播放列表',
        playlist_message_label: '您想创建播放列表吗？',
        sync_mam_asset_label: '同步妈妈资产',
        localization_dialog_header: '本地化',
        cast_Type_dialog_header: '铸造类型',
        login_again_label: '再次登录',
        please_image_bucket_name_error_message: '请输入S3镜像桶名称',
        please_video_bucket_name_error_message: '请输入S3视频存储桶名称',
        please_enter_image_cdn_url_error_message: '请输入S3图片CDN URL',
        please_enter_video_cdn_url_error_message: '请输入S3视频CDN URL',
        base_api_key_label: '基础 API 密钥',
        s3_access_key_id_label: 'S3 访问密钥 ID',
        s3_secret_access_key_label: 'S3 秘密访问密钥',
        s3_region_label: 'S3地区',
        s3_image_bucket_name_label: 'S3镜像桶名称',
        s3_video_bucket_name_label: 'S3 视频存储桶名称',
        s3_image_cdn_url_label: 'S3 图像 CDN URL',
        s3_video_cdn_url_label: 'S3 视频 CDN 网址',
        how_to_create_google_slide: '如何创建 Google 幻灯片：',
        go_to_google_slide: '单击提供的链接转至 Google 幻灯片主页。',
        click_on_homepage_template_option_available: '进入主页后，从可用选项中选择空白幻灯片模板或预先设计的模板。',
        creating_presentation: '根据您的需要向幻灯片添加文本、图像和设计，开始创建演示文稿。',
        copy_url_of_google_slide: '单击“发布”按钮，复制演示文稿 URL，向其添加“loop=false”参数，然后将其粘贴到 URL 输入字段中。',
        custom_title_1_label: '自定义标题1',
        custom_title_2_label: '自定义标题2',
        scheduled_playlist_page_breadcrumb: '预定播放列表',
        scheduled_playlist_sub_menu: '预定播放列表',
        schedule_type_label: '时间表类型',
        scheduled_playlist_header: '预定播放列表',
        no_end_date_label: '无结束日期',
        digital_sign_report_page_breadcrumb: '报告',
        digital_sign_report_menu: '报告',
        digital_sign_report_header: '报告',
        isRightToLeft: '是从右到左',
        show_deal_label: '显示优惠',
        acquition_report_sub_menu: '收购报告',
        acquisition_report_page_breadcrumb: '收购报告',
        budget_column: '预算',
        licensor_column: '许可人',
        payee_column: '收款人',
        contract_media_library_label: '合同媒体库',
        total_acq_label: '总采集量',
        amortization_rule_sub_menu: '摊销规则',
        amortization_rule_page_breadcrumb: '摊销规则',
        amortization_rule_dialog_header: '摊销规则',
        rule_text_label: '规则文本',
        please_select_amortization_rule_message: '请选择摊销规则',
        please_enter_rule_text_message: '请输入规则文本',
        amortization_rule_label: '摊销规则',
        amortization_rule_report_button_tooltip: '摊销报告',
        amortization_rule_report_dialog_header: '摊销报告',
        rule_text_instruction: '输入以逗号分隔的百分比值，确保总数为 100%（例如 10、60、30）。',
        invalid_rule_text_total_error_message: '规则文本值的总和必须为 100%。',
        amortization_rule_column: '摊销规则',
        amortization_value_column: '摊销价值',
        detach_mam_asset_confirmation_msg: "您真的想从该媒体中分离该资产吗？",
        logo_height_label: '标志高度',
        select_custom_date_range: '选择自定义日期范围',
        exhibition_used_label: '展览使用',
        total_runs_label: '总运行次数',
        exhibition_number_label: '展览编号',
        amortized_value_label: '摊余价值',
        exhibition_schedule_label: '展览安排',
        trailer_label: '拖车',
        switch_to_planning_view_tooltip: '切换到规划视图',
        switch_to_series_timeline_view_tooltip: '切换到系列时间线视图',
        upcoming_events_page_breadcrumb: '即将举行的活动',
        upcoming_events_sub_menu: '即将举行的活动',
        upcoming_events_header: '即将举行的活动',
        start_date_lable: '开始日期',
        launch_date_label: '发布日期',
        upcoming_event_dialog_header: '即将举行的活动',
        social_media_menu: '社交媒体',
        budget_sub_menu: '预算',
        budget_page_breadcrumb: '预算',
        budget_dialog_header: '预算',
        client_po_no_label: '客户采购订单号',
        agency_commission_label: '代理委员会',
        can_only_be_in_Percentage: '只能是百分比 (%)',
        ad_status_column: '广告状态',
        objective_column: '目的',
        daily_budget_column: '每日预算',
        spend_cap_column: '支出上限',
        buying_type_column: '购买类型',
        please_enter_client_po_no_error_message: '请输入客户采购订单号',
        please_select_status_error_message: '请选择状态',
        please_enter_order_date_error_message: '请选择订购日期',
        please_enter_agency_error_message: '请输入代理机构',
        please_enter_client_error_message: '请输入客户',
        please_enter_currency_error_message: '请选择货币',
        please_enter_targetAmount_error_message: '请输入目标金额',
        please_enter_target_amount_error_message: '目标金额不能低于活动总支出上限',
        please_enter_agency_comission_error_message: '代理佣金不能为负',
        budget_label: '预算',
        campaign_dialog_header: '活动',
        objective_label: '目的',
        buying_type_label: '购买类型',
        bid_strategy_label: '出价策略',
        spend_cap_label: '支出上限',
        daily_budget_label: '每日预算',
        special_ad_categories_label: '特殊广告类别',
        only_two_special_ad_categories: '只能选择两个特殊广告类别。',
        audience_column: '观众',
        please_select_budget_error_message: '请选择预算',
        please_enter_start_time_error_message: '请输入开始时间',
        please_enter_end_time_error_message: '请输入结束时间',
        please_select_objective_error_message: '请选择目标',
        please_select_buying_type_error_message: '请选择购买类型',
        please_select_bid_strategy_error_message: '请选择出价策略',
        please_select_spend_cap_error_message: '请选择支出上限',
        please_enter_spend_cap_cannot_exceed_available_budget_error_message: '支出上限不能超过可用预算',
        please_enter_daily_budget_error_message: '请输入每日预算',
        please_enter_daily_budget_cannot_exceed_spend_cap_error_message: '每日预算不能超过支出上限',
        please_enter_valid_targetAmount_error_message: '请输入有效的目标金额',
        sm_ads_page_breadcrumb: '广告',
        title_label: '标题',
        ad_dialog_header: '广告',
        image_column: '图片',
        file_name_column: '文件名',
        format_column: '格式',
        please_enter_asset_id_error_message: '请输入资产ID',
        please_attach_at_least_one_asset_error_message: '请附上至少一项资产',
        ads_sub_menu: '广告',
        sm_audience_page_breadcrumb: '观众',
        audience_sub_menu: '观众',
        please_select_geo_location_error_message: '请选择地理位置',
        please_select_interest_error_message: '请选择兴趣',
        please_enter_minimum_age_error_message: '请输入最低年龄',
        please_enter_maximum_age_error_message: '请输入最大年龄',
        sm_channels_sub_menu: '渠道',
        sm_channels_page_breadcrumb: '渠道',
        publish_button_tooltip: '发布',
        un_publish_button_tooltip: '取消发布',
        spotsperTRP_label: "每个 TRP 的名额",
        target_trp_label: "目标TRP",
        upate_target_spots_button_tooltip: "更新目标点",
        advertising_channel_type_lable: "广告渠道类型",
        spand_cap_label: "支出上限",
        please_select_advertising_channel_type_error_message: "请选择广告渠道类型",
        please_enter_cpc_bid_micros_error_message: "请输入支出上限",
        to_date_cannot_be_earlier_than_from_date_message: '截止日期不能早于起始日期。',
        end_time_cannot_be_earlier_than_start_time_message: '结束时间不能早于开始时间。',
        stop_date_label: '停止日期',
        impressions_label: '印象数',
        clicks_label: '点击次数',
        spends_label: '花费',
        cpc_label: '中国共产党',
        cpm_label: '每千次展示费用',
        ctr_label: '点击率',
        show_insight_button_tooltip: '显示见解',
        create_audience_button_tooltip: '创建受众',
        audience_created_successfully: '受众创建成功',
        audience_updated_successfully: '受众更新成功',
        error_fetching_insights: '获取此营销活动的见解时出错',
        sm_dashboard_sub_menu: '仪表板',
        social_media_dashboard_page_breadcrumb: '仪表板',
        campaign_active_label: '活动活跃',
        campaign_inactive_label: '活动无效',
        publish_ads_label: '发布广告',
        unpublish_ads_label: '取消发布广告',
        campaign_insights_label: '活动见解',
        spent_column: '已用',
        bid_strategy_column: '出价策略',
        skednetwork_attribution_column: '斯卡德网络归因',
        split_test_variable_column: '分割测试变量',
        cpc_column: '中国共产党',
        cpm_column: '每千次展示费用',
        ctr_column: '点击率',
        sm_campaigns_sub_menu: '活动',
        sm_campaigns_page_breadcrumb: '活动',
        insight_dialog_header: '洞察力',
        facebook_access_token_invalid_message: 'Facebook 访问令牌无效或已过期。请重新验证',
        failed_to_fetch_facebook_pages_message: '无法获取 Facebook 页面',
        objective_type_label: '物镜类型',
        please_select_linkedin_objective_type_error_message: '请选择目标类型',
        please_select_linkedin_type_error_message: '请选择类型',
        upcoming_campaigns_label: '即将举行的活动',
        share_post_label: '在帖子中分享',
        create_post_button: '创建帖子',
        quote_label: '报价',
        hashtag_label: '标签',
        share_on_facebook_button: '在脸书上分享',
        share_on_linkedin_button: '在领英上分享',
        share_url_label: '分享网址',
        share_this_link_via_label: '通过以下方式分享此链接',
        cost_type_label: '成本类型',
        add_program_sub_menu: "添加节目",
        search_program_sub_menu: "搜索程序",
        search_program_by_category_sub_menu: "按类别搜索程序",
        create_add_program_dialog_header: "创建程序",
        inputs_sub_menu: "输入",
        dai_configurations_sub_menu: "配置",
        dai_configurations_page_breadcrumb: '配置',
        output_configuration_setting_label: '输出配置',
        segment_length_label: '线段长度',
        admarkers_label: '广告标记',
        caption_language_mappings_label: '字幕语言映射',
        caption_language_setting_label: '字幕语言设置',
        client_cache: '客户端缓存',
        codec_specification_label: '编解码器规格',
        directory_structure_label: '目录结构',
        discontinuity_tags_label: '不连续性标签',
        hlsId3_segment_tagging_label: 'HlsId3 段标记',
        iframe_only_playlists_label: 'IFrameOnly 播放列表',
        incomplete_segment_behavior_label: '不完整的段行为',
        indexn_segments_label: '索引 N 段',
        input_loss_action_label: '输入损耗动作',
        ivin_manifest_label: 'IVIN 清单',
        iv_source_label: '四源',
        keep_segments_label: '保留段',
        manifest_compression_label: "清单压缩",
        manifest_duration_format_label: '清单持续时间格式',
        matchMediaode_label: '模式',
        output_selection_label: '输出选择',
        program_datetime_label: '节目日期时间',
        program_datetimeclock_label: "节目日期时间时钟",
        program_datetime_period_label: '节目日期时间段',
        redundantManifest_label: '冗余清单',
        segmentation_mode_label: '分割模式',
        segmentsPer_subdirectory_label: '每个子目录的段',
        satisfiestreaminf_resolution_label: '流 InfResolution',
        timed_metadataid3frame_label: '定时元数据 Id3 帧',
        timed_metadataid3period_label: '定时元数据 Id3 周期',
        tsFile_mode_label: 'Ts 文件模式',
        avail_configuration_label: '可用配置',
        no_regional_blackout_flag_label: '无区域停电标志',
        web_delivery_allowed_flag_label: '网络传送允许标志',
        scte35_segmentation_scope_label: 'Scte35 分段范围',
        media_configuration_label: '媒体预告片配置',
        enableAd_markerpassthrough_label: '启用 AdMarker 直通',
        ad_insertionmode_label: '广告插播方式',
        avail_suppression_mode_label: '使用抑制模式',
        avail_suppression_valie_label: '有效抑制值',
        input_configuration_label: '输入配置',
        audio_selectors_label: '音频选择器',
        caption_selectors_label: '字幕选择器',
        deblock_filter_label: '去块过滤器',
        denoise_filter_label: '降噪滤波器',
        filter_strength_label: '过滤强度',
        input_filter_label: '输入滤波器',
        buffer_segments_label: '缓冲段',
        retries_label: '重试',
        retry_interval_label: '重试间隔',
        scte35_source_label: 'Scte35 源',
        server_validation_label: '服务器验证',
        smpte2038_data_preference_label: 'Smpte2038 数据偏好',
        source_end_behavior_label: '源端行为',
        deblock_kilter_label: '去块过滤器',
        dai_input_page_breadCrumb: '输入',
        dai_input_dialog_header: '输入',
        input_class_label: '输入类别',
        password_param_label: '密码',
        outputs_sub_menu: '输出',
        dai_output_page_breadCrumb: '输出',
        dai_output_dialog_header: '输出',
        dai_add_output_dialog_header: '添加输出',
        please_select_output_name_error_message: '请选择输出名称',
        name_modifier_label: "名称修饰符",
        audio_rendition_sets_label: "音频再现集",
        audio_frames_per_pes_label: "每个 PES 的音频帧数",
        audio_pids_label: "音频 PID",
        klv_behavior_label: "KLV 行为",
        nielsen_id3_behavior_label: "尼尔森 ID3 行为",
        pcr_control_label: "PCR控制",
        pmt_pid_label: "光电倍增管PID",
        program_num_label: "节目号",
        scte35_behavior_label: "SCTE35 行为",
        scte35_pid_label: "SCTE35 PID",
        timed_metadata_behavior_label: "定时元数据行为",
        timed_metadata_pid_label: "定时元数据PID",
        video_pid_label: "视频PID",
        video_descriptions_title: "视频说明",
        h264_settings_title: "H264 设置",
        afd_signaling_label: "AFD 信令",
        bitrate_label: "比特率",
        framerate_control_label: "帧率控制",
        gop_size_label: "共和党大小",
        gop_size_units_label: "GOP 大小单位",
        rate_control_mode_label: "速率控制模式",
        scan_type_label: "扫描类型",
        scene_change_detect_label: "场景变化检测",
        timecode_insertion_label: "时间码插入",
        audio_descriptions_title: '音频描述',
        audio_name_label: '姓名',
        audio_type_control_label: '音频类型控制',
        aac_settings_title: 'AAC 设置',
        coding_mode_label: '编码方式',
        input_type_label: '输入类型',
        profile_label: '公司简介',
        raw_format_label: '原始格式',
        sample_rate_label: '采样率',
        specification_label: '规格',
        output_name_label: '输出名称',
        timezone_label: '时区',
        addition_timezone_label: '附加时区',
        enable_additional_timezone_label: '启用附加时区',
        main_timezone_label: '主要时区',
        enable_main_timezone_label: "启用主时区",
        dai_channels_sub_menu: "渠道",
        dai_channels_page_breadcrumb: "渠道",
        dai_channel_dialog_header: "创建频道",
        input_label: '输入',
        output_label: '输出',
        configuration_label: '配置',
        please_select_input_error_message: '请选择输入',
        please_select_output_error_message: '请选择输出配置',
        please_select_transcoding_configuration_error_message: '请选择转码配置',
        please_enter_destination_s3_url_error_message: '请输入目标 S3 URL',
        destinatio_s3_url_label: '目标 S3 URL',
        avail_suppression_fill_policy_label: '利用抑制填充策略',
        dai_inputs_page_breadCrumb: '输入',
        dai_outputs_page_breadCrumb: '输出',
        add_avail_offset_label: "可用偏移量",
        avail_suppression_value_label: '有效抑制值',
        preview_label: '预览',
        ad_decision_server_url_label: '广告决策服务器',
        video_content_source_url_label: '视频源网址',
        hls_url_label: 'HLS 网址',
        dash_url_label: '达世币网址',
        file_name_label: '文件名',
        please_enter_file_name_error_message: '请输入文件名',
        no_preview_available_label: '没有可用的预览',
        dai_sctes_sub_menu: 'SCTE',
        dai_sctes_page_breadcrumb: 'SCTE',
        dai_sctes_dialog_header: '添加 SCTE',
        action_name_label: '动作名称',
        time_label: '时间',
        please_enter_date_time_error_message: '请输入日期时间',
        choose_file_button: '选择文件',
        no_file_selected: '未选择文件',
        import_file_dialog_header: '导入文件',
        sctes_label: 'SCTE',
        upload_file_button_text: '上传文件',
        import_label: '进口',
        event_id_column: '事件 ID',
        publish_all_button_text: '全部发布',
        publish_all_button_tooltip: '全部发布',
        update_SCTE_marker_actionbutton_menutext: "更新 SCTE 标记",
        scte_marker_label: "SCTE标记",
        dai_configuration_sub_menu: '配置',
        create_input_button_tooltip: '创建输入',
        create_output_button_tooltip: '创建输出配置',
        create_configuration_button_tooltip: '创建配置',
        outputs_label: '输出',
        edit_input_button_tooltip: '编辑输入',
        edit_output_button_tooltip: '编辑输出配置',
        edit_configuration_button_tooltip: '编辑配置',
        scte_on_actionbutton_menutext: "应用 SCTE ON",
        scte_off_actionbutton_menutext: "应用 SCTE 关闭",
        remove_scte_actionbutton_menutext: "删除 SCTE",
        cannot_apply_SCTE_marker_error_message: "无法在段上应用 SCTE 标记。",
        show_invalid_format_label: "格式无效",
        music_library_dialog_header: '音乐库',
        scte_start_and_end_error_message: "SCTE 开始和结束计数不同。",
        wrong_scte_marker_sequence_error_message: "SCTE 标记序列错误。",
        start_date_time_label: '开始日期时间',
        end_date_time_label: '结束日期时间',
        downlaod_sctes_button_tooltip: '下载SCTES',
        dai_channel_delete_error_messgae: '您无权删除该频道，请联系管理员',
        un_publish_button_text: '取消发布',
        scte_duplicate_error_message: 'SCTE 已经存在',
        re_publish_button_text: '重新发布',
        re_publish_button_tooltip: '重新发布',
        music_playlist_sub_menu: '音乐播放列表',
        music_playlist_page_breadCrumb: '音乐播放列表',
        music_playlist_dialog_header: '音乐播放列表',
        ott_asset_library_dialog_header: '奥特资产库',
        please_select_playlist: '请选择播放列表',
        music_list_label: '音乐列表',
        please_add_mp3_video_for_music: '请为音乐播放器添加 MP3 视频类型',
        create_media_subcategory_type_button_tooltip: "创建媒体子类别类型",
        channel_type_label: '通道类型',
        transcoding_label: '转码',
        ad_insertion_label: '广告插入',
        please_select_channel_type_error_message: '请选择渠道类型',
        destination_label: '目的地',
        please_enter_destination_error_message: '请输入目的地',
        please_enter_video_source_url_error_message: '请输入视频源网址',
        please_enter_ad_decision_server_error_message: '请输入广告决策服务器',
        please_enter_valid_video_source_url_error_message: '请输入有效的视频源网址',
        dai_transcodings_sub_menu: '转码',
        dai_transcodings_page_breadcrumb: '转码',
        dai_transcoding_dialog_header: '创建转码',
        dai_ad_insertions_sub_menu: '广告插播',
        dai_ad_insertions_page_breadcrumb: '广告插播',
        dai_ad_insertion_dialog_header: '创建广告插播',
        skip_media_category_type_for_SCTE_label: "跳过媒体 SCTE",
        import_commercials: "进口广告",
        please_select_route_type_error_message: "请选择路线类型",
        please_select_ad_insertion_configuration_error_message: "请选择广告插入配置",
        file_date_and_schedule_date_mismatch: "文件日期和计划日期不匹配",
        fetch_ahead_label: '提前获取',
        station_code_label: '车站代码',
        please_enter_fetch_ahead_error_message: '请输入提前获取',
        please_select_station_code_error_message: '请选择车站代码',
        please_enter_valid_fetch_ahead_error_message: '仅范围 0 到 6',
        total_count_label: '总计数',
        last_air_time_label: '最后播出时间',
        output_configuration_label: '输出配置',
        create_adInsertion_button_tooltip: '创建广告插入配置',
        edit_adInsertion_button_tooltip: '编辑广告插入配置',
        verify_button_text: "验证",
        import_commercial_file_label: "进口商业",
        to_date_should_not_be_less_than_from_date_error_message: "截止日期不应早于起始日期",
        from_date_to_date_should_not_be_more_than_7_days: "开始日期和结束日期之间的差异不得超过 7 天",
        ch_number_label: '章。不。',
        channel_suffix_label: '频道后缀',
        filter_template_tooltip: "过滤器模板",
        please_select_language_media_episode_cast_and_crew_error_message: "请选择演员和工作人员语言",
        filter_criteria_label: "过滤标准",
        keyword_label: '关键词',
        attach_mam_asset_tooltip: "附加 MAM 资产",
        EMRC_label: 'EMRC',
        MRC_days_label: 'MRC 日',
        mrc_days_valid_error_message: '范围只能是 0 到 10',
        EMRC_tooltip_msg: '启用后，系统会根据 EMRC 设置检查 MRC 天之前或之后的媒体重复情况。',
        export_missing_segment_mam_report_button_tooltip: 'Export Missing Segment/MAM Report',
        please_select_filters_msg: '请选择过滤器/搜索',
        missing_segment_planning_report_dialog_header: '缺失片段/MAM 报告',
        planned_slot_time_label: '计划时段',
        mam_id_column: 'MAM ID',
        hard_disk_label: "硬盘",
        add_time_repeat_block_button: "添加时间重复",
        exceeding_slot_duration_error_message: "超过时隙持续时间",
        overlapping_timecodes_error_message: "重叠时间码",
        from_date_to_date_should_not_be_more_than_days_error_message: "起始日期和截止日期之间的差异不应超过",
        invalid_duration_segment_error_message: '请输入有效的持续时间/时间码',
        please_select_media_category_error_message: '请选择媒体类别',
        please_enter_classification_error_message: '请输入分类',
        please_enter_officer_error_message: '请输入官员',
        please_select_result_error_message: '请选择结果',
        ott_aggregator_sub_menu: "聚合器",
        ott_aggregator_page_breadCrumb: "聚合器",
        ott_aggregator_dialog_header: "创建聚合器",
        content_distribution_sub_menu: "内容分发",
        content_distribution_page_breadCrumb: "内容分发",
        content_distribution_dialog_header: "创建内容分发",
        aggregator_label: "聚合器",
        access_key_label: "访问密钥",
        assets_label: "资产",
        copied_to_clipboard_message: "已复制到剪贴板",
        please_select_aggregator_error_message: "请选择聚合商",
        distribution_label: "分布",
        content_distribution_response_type_label: "内容分发响应类型",
        content_distribution_api_label: "内容分发API",
        please_select_distribution_api: "请选择分发 API 和基本 URL",
        delivery_label: "发货",
        please_select_delivery_error_message: "请选择配送类型",
        please_enter_ftp_host_error_message: "请输入 FTP 主机。",
        please_enter_ftp_username_error_message: "请输入 FTP 用户名。",
        please_enter_ftp_password_error_message: "请输入FTP密码。",
        please_enter_ftp_remote_path_error_message: "请输入FTP远程路径。",
        ftp_host_label: "主持人",
        ftp_remote_path_label: "远程路径",
        please_generate_access_key_error_message: "请生成访问密钥",
        create_loop_actionbutton_menutext: '创建循环',
        create_loop_dialog_header: '创建循环',
        start_time_cannot_be_greater_than_end_time_error_message: '开始时间不能大于结束时间',
        publishable_key_label: "可发布的密钥",
        add_provider_button_tooltip: "添加提供商",
        select_provider_label: "选择提供商",
        select_create_from_button_tooltip: "创建自",
        save_and_close_text: "保存并关闭",
        os_label: "操作系统",
        period_label: "时期",
        media_filter_label: "介质过滤器",
        media_filter_dialog_header: "介质过滤器",
        remove_filter_button_tooltip: "删除过滤器",
        media_filter_info: "媒体过滤器允许您根据各种条件（例如资产类型、提供商、访问级别、VOD 类型、分段等）过滤媒体。您可以创建自定义过滤器来简化媒体管理流程并快速查找相关内容。",
        branding_logo_column: "品牌标志",
        os_column: '操作系统',
        please_select_period_error_message: '请选择期间',
        please_select_os_error_message: '请选择操作系统',
        product_id_label: "产品编号",
        sandbox_mode_label: "沙盒模式",
        please_select_name_error_message: "请选择姓名",
        please_enter_country_code_error_message: "请输入国家代码",
        please_enter_product_id_required_for_applesubscription_in_payments_error_message: "请在 Payments 中输入 AppleSubscription 所需的 ProductId。",
        product_id_info_message: "产品 ID 是移动应用程序中用于管理应用内购买或订阅的唯一标识符。它可以帮助应用程序准确识别用户试图购买的产品，例如本例中的每周订阅。此 ID 已在应用商店中注册，并且必须与应用代码中使用的 ID 相匹配。",
        dummy_planning_dialog_header: "虚拟规划",
        break_template_label: "中断模板",
        repeat_pattern_column: "重复模式",
        slot_date_label: "时段日期",
        duration_without_format_label: "期间",
        add_mam_asset_label: "添加 MAM 资产",
        mam_assets_label: "妈妈资产",
        please_select_media_sub_category_error_message: "请选择媒体子类别类型",
        default_region_label: "默认区域",
        device_access_control_label: "设备访问控制",
        authentication_type_label: "认证类型",
        splash_screen_mobile_label: "手机闪屏",
        splash_screen_tv_label: "闪屏电视",
        aspect_ratio_mobile_message: "移动设备（iOS 和 Android）的宽高比：9:16",
        aspect_ratio_tv_message: "电视 (Android TV) 的宽高比：普通和 4K UHD - 16:9",
        notification_menu: "通知",
        notification_manager_sub_menu: "通知管理器",
        notification_manager_page_breadCrumb: "通知管理器",
        notification_manager_dialog_header: "通知管理器",
        user_select_dialog_header: "用户选择",
        asset_select_dialog_header: "资产选择",
        notification_send_label: "发送",
        please_select_group_error_message: "请选择群组",
        please_select_user_error_message: "请选择用户",
        please_select_image_url_error_message: "请选择图片网址",
        select_asset_label: "选择资产",
        user_label: "用户",
        amortisation_value_report: "摊销价值报告",
        remove_as_important: "删除重要内容",
        set_as_important: "设置为重要",
        router_command_label: "路由器命令",
        add_router_command: "添加路由器命令",
        add_router_command_actionbutton_menutext: "添加路由器命令",
        update_router_command_actionbutton_menutext: "更新路由器命令",
        router_command_can_only_be_added_for_live_and_sdd: "只能为 Live 和 SDD 添加 Router 命令",
        measurement_id_label: "测量 ID",
        please_enter_measurement_id_error_message: "请输入测量 ID",
        please_enter_api_secret_error_message: "请输入API密钥",
        analytics_provider_label: "分析提供商",
        token_label: "代币",
        please_enter_token_error_message: "请输入令牌",
        commercial_consumption_report_sub_menu: "商业消费报告",
        commercial_consumption_report_header: "商业消费报告",
        download_commercial_consumption_report_tooltip_button: '下载商业消费报告',
        schedule_export_history_sub_menu: '计划导出历史记录',
        schedule_export_history_header: '计划导出历史记录',
        manual_label: "手册",
        add_cast_and_crew_tooltip: "添加多个演员和工作人员",
        please_enter_cast_name_error_message: "请输入演员姓名",
        please_select_cast_type_error_message: "请选择演员类型",
        macro_name_label: "宏名称",
        ott_subtitle_label: "副标题",
        create_subtitle_header: "创建字幕",
        language_code_column: "语言代码",
        video_thumbnail_vtt_url_message: "支持直接图像 URL 或 Web vtt 文件进行缩略图预览。",
        show_menu_label: "展示",
        logs_menu_label: '日志',
        exhibitions_menu_label: '展览',
        deal_menu_label: '优惠',
        media_menu_label: '媒体',
        run_button_text_planning: '运行',
        update_properties_button_text_planning: '更新属性',
        update_multiple_title_button: "更新多个",
        update_cast_and_crew_title_button: "更新演职人员",
        ott_assets_label: "奥特资产",
        sync_with_media_episodes_label: "与媒体剧集同步",
        foreground_color_label: "前景色",
        foreground_color_sm_label: "前景色",
        background_color_label: "背景颜色",
        background_color_sm_label: "背面颜色",
        large_video_compress_message: '对于大视频，请在上传前进行压缩',
        video_format_mpeg_message: '确保视频格式为 MPEG-4。要转换，请使用',
        click_here_to_currency_code_message: '点击此处查看货币代码',
        export_commercials_label: "Export Commercials",
        please_save_season_first_error_message: "请先保存系列",
        setting_header: "设置",
        settings_updated_successfully_message: "设置更新成功",
        music_airing_report_sub_menu: "音乐播放报告",
        music_airing_report_page_breadcrumb: "音乐播放报告",
        performance_year_column: "表现年份",
        performance_month_column: "表现月",
        performance_day_column: "演出日",
        performer_artist_column: "表演艺术家",
        record_label_column: "唱片公司",
        publisher_column: "出版商",
        composer_column: "作曲家",
        risa_member_column: "里沙会员",
        duration_min_column: "最短持续时间",
        duration_sec_column: "持续时间秒",
        break_pattern_report_sub_menu: "中断模式报告",
        break_pattern_report_page_breadcrumb: "中断模式报告",
        record_label_label: "唱片公司",
        publisher_label: "出版商",
        is_expired_label: "已过期",
        only_label: "仅",
        bucket_configurations_breadcrumb: '铲斗配置',
        bucket_breadcrumb: '水桶',
        bucket_configurations_menu: "铲斗配置",
        bucket_menu: "水桶",
        bucket_configurations_sub_menu: "铲斗配置",
        bucket_sub_menu: "桶",
        bucket_config_label: '铲斗配置',
        please_enter_access_key_error_message: '请输入访问密钥',
        folder_path_label: '文件夹路径',
        please_select_bucket_configuration_error_message: "请选择桶配置",
        please_enter_folder_path_error_message: "请输入文件夹路径",
        check_label: "检查",
        move_to_media_management_label: "转向媒体管理",
        move_to_Archive: "移至存档",
        size_label: "尺寸",
        detach_file_confirmation_msg: "您确定要分离该文件吗？",
        offer_sub_menu: "优惠",
        price_code_sub_menu: "价格代码",
        offer_page_breadcrumb: "优惠",
        price_code_breadcrumb: "价格代码",
        programs_generic_label: "程序通用",
        price_label: '价格',
        price_code_label: '价格代码',
        please_enter_display_title_error_message: '请输入显示标题',
        offer_label: "优惠",
        runs_label: "跑步",
        offer_type_label: '报价类型',
        content_tree_view_menu: "内容树",
        node_tree_view_menu: "节点树",
        content_tree_view_page_breadcrumb: "内容树",
        node_tree_view_page_breadcrumb: "节点树",
        select_a_category_from_the_tree_to_view_media_message: "从树中选择一个类别以查看媒体",
        no_media_found_for_this_category_message: "找不到该类别的媒体",
        try_selecting_another_category_message: "尝试选择其他类别",
        copybreak_schedule_menu_text: '复制中断项目',
        pastebreak_schedule_menu_text: '粘贴中断项目',
        no_categories_found_message: "没有找到类别",
        no_nodes_found_message: "未找到节点",
        content_categories_label: "内容类别",
        nodes_label: "节点",
        add_content_category_label: "添加内容类别",
        edit_content_category_label: "编辑内容类别",
        delete_content_category_label: "删除内容类别",
        please_enter_runs_error_message: "请输入运行次数",
        please_select_offer_error_message: "请选择报价",
        select_offers_label: "选择优惠",
        you_delete_this_offer_from_parent_series_only_error_message: "未经授权：您只能从父系列中删除此优惠",
        you_delete_this_offer_from_series_only_error_message: "未经授权：您只能从系列中删除此优惠",
        you_delete_this_offer_from_contract_only_error_message: "未经授权：您只能从合同中删除此优惠",
        create_offer_button_tooltip: "创建报价",
        vod_report_sub_menu: "点播报告",
        vod_report_page_breadcrumb: "点播报告",
        attech_media_category_button_tooltip: "Attech媒体类别",
        please_select_media_category_selection_error_message: "请选择特定的媒体类别。 “全部”是仅查看模式",
        update_all_media_by_category_button_tooltip: "按类别更新所有媒体",
        export_appendix12_tooltip: 'Export Appendix 12 XML',
        export_appendix11_tooltip: 'Export Appendix 11 XML',
        export_appendix8_tooltip: 'Export Appendix 8 XML',
        appendix8: '附录8',
        appendix11: '附录11',
        appendix12: '附录12',
        mark_as_catch_up_actionbutton_menutext: '标记为追赶',
        un_marked_as_catch_up_actionbutton_menutext: '未标记为追赶',
        translated_display_title_label: '翻译后的显示标题',
        translated_Description_label: '翻译说明',
        please_enter_translated_display_title_error_message: '请输入翻译后的显示标题',
        please_enter_translated_description_error_message: '翻译说明',
        pay_per_time_label: '按次付费',
        ris_label: '里斯',
        image_groups_sub_menu: '图像组',
        catalogues_sub_menu: '目录',
        image_groups_page_breadcrumb: '图像组',
        catalogues_page_breadcrumb: '目录',
        transmission_type_label: "传动方式",
        transmission_type_column: "传动方式",
        parental_rating_label: '家长评级',
        image_group_label: '图像组',
        external_reference_label: '外部参考',
        nodes_sub_menu: '节点',
        nodes_page_breadcrumb: '节点',
        please_select_image_group_error_message: '请选择图像组',
        please_enter_valid_parental_rating_error_message: '请输入有效的家长评级',
        please_select_parent_error_message: '请选择父级',
        please_select_vod_channel_error_message: '请选择点播频道',
        please_enter_external_reference_error_message: '请输入外部参考',
        create_transmission_button_tooltip: '创建传输',
        channels_label: '渠道',
        vod_channels_label: '点播频道',
        attach_nodes_button_tooltip: '附加节点',
        select_nodes_dialog_header: '选择节点',
        catalogue_label: '目录',
        please_select_catalogue_error_message: '请选择目录',
        transmission_types_page_breadcrumb: '传输类型',
        transmission_types_sub_menu: '传输类型',
        transmission_type_header: '传动方式',
        VODtype_label: '点播类型',
        please_select_vod_channels_error_message: '请选择点播频道',
        please_select_nodes_error_message: '请选择节点',
        vod_channels_column: '点播频道',
        nodes_column: '节点',
        publish_transmission_button_tooltip: '发布传输',
        please_save_media_first_error_message: '请先保存媒体',
        mam_asset_menu: 'MAM资产',
        transcode_definition_sub_menu: '转码定义',
        transcode_definition_header: '转码定义',
        technical_details_label: '技术细节',
        bit_rate_label: '比特率',
        file_size_label: '文件大小',
        file_location_label: '文件位置',
        checksum_label: '校验和',
        please_select_parent_rating_error_message: '请选择家长评分',
        sid_label: '安全识别码',
        node_browser_menu: '节点浏览器',
        node_browser_page_breadcrumb: '节点浏览器',
        ingest_prototype_page_breadcrumb: '摄取原型',
        ingest_prototype_sub_menu: '摄取原型',
        direct_ingest_label: '直接摄取',
        censorship_flag_label: '审查旗帜',
        asset_group_label: '资产组',
        dual_sound_label: '双声',
        subtitles_flag_label: '字幕标志',
        subtitling_code_label: '字幕代码',
        subtitling_lang_label: '字幕语言',
        subtitling_mode_label: '字幕模式',
        thumbnail_label: '缩略图',
        language1_label: '语言1',
        hd_label: '高清',
        please_select_asset_group_error_message: '请选择资产组',
        ingest_prototype_header: '摄取原型',
        ingest_prototype_label: '摄取原型',
        ingest_prototype_column: '摄取原型',
        ingest_prototype_tooltip: '摄取原型',
        please_select_ingest_prototype_error_message: '请选择摄取原型',
        transcode_definition_page_breadcrumb: '转码定义',
        transcode_Prototypes_page_breadcrumb: '转码原型',
        transcode_Prototypes_sub_menu: '转码原型',
        transcode_Prototypes_header: '转码原型',
        title_flag_label: '标题标志',
        logo_flag_label: '标志旗',
        logo_opposite_label: '反面标志',
        ending_flag_label: '结束标志',
        definition_label: '定义',
        reverse_audio_channel_flag_label: '反向音频通道标志',
        tag_flag_label: '标记标志',
        please_enter_audio_mode_error_message: '请进入音频模式',
        transcode_prototype_label: '转码原型',
        please_select_direct_ingest_error_message: '请选择直接摄取',
        please_select_transcode_prototype_error_message: '请选择转码原型',
        transcode_prototype_column: '转码原型',
        transmission_status_column: "传输状态",
        mam_asset_status_column: "MAM状态",
        hide_node_label: '隐藏节点',
        show_node_label: '显示节点',
        node_hidden_success_message: '节点隐藏成功',
        node_show_success_message: '节点显示成功',
        node_hidden_error_message: '隐藏节点失败',
        node_show_error_message: '无法显示节点',
        ingest_work_order_exported_successfully_message: '摄取工单已成功导出',
        genreId_label: '类型ID',
        subGenreId_label: '子类型 ID',
        channel_groups_page_breadcrumb: '频道组',
        channel_groups_sub_menu: '频道组',
        channel_groups_header: '频道组',
        select_channel_groups_collection_header: '选择渠道组集合',
        select_channel_groups_tooltip: '选择频道组',
        offer_already_published_error_message: '报价已发布',
        some_offers_already_published_error_message: '部分优惠已经发布',
        attach_offers_button_tooltip: '附上优惠',
        create_mamasset_and_wo_button_tooltip: '创建 MAM 资产和工单',
        you_cannot_delete_published_offer_error_message: '您无法删除已发布的优惠，如果要删除，请先取消发布优惠',
        please_enter_valid_copy_from_date_error_message: '请输入有效副本起始日期',
        please_enter_valid_copy_to_date_error_message: '请输入迄今为止的有效副本',
        please_enter_valid_copy_to_from_date_error_message: '请输入有效的复制到起始日期',
        please_enter_valid_copy__to_todate_error_message: '请输入有效的 CopyTo 日期',
        export_dublist_label: 'Export Dublist',
        export_vod_catalogue_label: 'Export VOD Catalogue',
        export_incremental_catalogue_label: 'Export Incremental Catalogue',
        export_inc_catalogue_label: "Export Inc Catalogue",
        export_delete_list_label: 'Export Delete List',
        asset_offer_link_browser_menu: '优惠浏览器',
        asset_offer_link_browser_page_breadcrumb: '优惠浏览器',
        asset_offer_multiple_update_tooltip: '全部发布',
        asset_offer_multiple_unpublish_tooltip: '全部取消发布',
        multiple_update_label: '多次更新',
        publish_confirmation_title: '发布优惠确认',
        multiple_publish_update_confirmation_message: '您想发布所有选定的资产报价吗？',
        multiple_publish_update_note: '注意：已发布的资产报价将被跳过',
        unpublish_confirmation_title: '取消发布优惠确认',
        multiple_unpublish_update_confirmation_message: '您想取消发布所有选定的资产报价吗？',
        multiple_upublish_update_note: '注意：已经未发布的资产报价将被跳过',
        external_refrence_label: '外部参考',
        please_select_media_error_message: "请选择媒体",
        un_mark_as_black_out_actionbutton_menutext: '取消标记为停电',
        mark_as_black_out_actionbutton_menutext: '标记为停电',
        you_cannot_edit_published_offer_error_message: '您无法编辑已发布的优惠，如果要编辑，请先取消发布优惠',
        simul_cast_channel_configuration_page_breadcrumb: '联播频道配置',
        simul_cast_channel_configuration_sub_menu: '联播频道配置',
        primary_channel_label: '主要渠道',
        simul_cast_channel_configuration_header: '联播频道配置',
        mapped_channels_label: '映射频道',
        cannot_mark_default_for_segments_with_transmission_type_selected_error_message: '无法为所选传输类型的段标记默认值',
        non_linear_transmission_label: '非线性传输',
        linear_transmission_label: '线性传动',
        media_sub_type_label: '媒体子类型',
        select_provider_collection_header: '选择提供商',
        select_pgrating_collection_header: '选择光栅化',
        confirm_alert_delete_all_message: '确认警报 全部删除',
        delete_all_label: '全部删除',
        error_exporting_xml_error_message: '导出 XML 时出错',
        trailer_booking_sub_menu: '拖车预订',
        publish_menu: '发布',
        publish_page_breadcrumb: '发布',
        publish_type_label: '发布类型',
        report_is_not_exported_error_message: '报告未导出，请重试',
        simulcast_label: '联播',
        please_enter_price_error_message: '请输入价格',
        please_enter_start_date_time_error_message: '请输入开始日期时间',
        please_enter_end_date_time_error_message: '请输入结束日期时间',
        please_wait_export_message: '请等待导出...',
        exported_successfully_message: 'Exported successfully',
        report_type_label: '报告类型',
        please_select_report_type_error_message: '请选择报告类型',
        you_are_not_authorized_to_publish_please_go_to_parent_series_error_message: "您无权从此处发布/取消发布。请前往家长系列",
        you_are_not_authorized_to_publish_please_go_to_series_error_message: "您无权从此处发布/取消发布。请前往系列",
        you_edit_this_offer_from_contract_only_error_message: "您只能从合同中编辑此报价",
        you_publish_this_offer_from_contract_only_error_message: "您只能通过合同发布/取消发布此优惠",
        sid_column: '安全识别码',
        offer_csid_column: '提供CSID',
        offer_id_column: '报价 ID',
        nodes_id_column: '节点ID',
        search_label: '搜索',
        node_csid_label: '节点号',
        offer_csid_label: '报价 ID',
        price_code_csid_label: '价格代码 ID',
        catalogue_dashboard: '目录仪表板',
        epg_file_status_label: 'EPG 文件状态',
        vod_file_status_label: 'VOD 文件状态',
        publish_file_status_label: '发布文件状态',
        target_types_page_breadcrumb: '目标类型',
        target_types_sub_menu: '目标类型',
        target_type_header: '目标类型',
        transcoding_Work_order_label: '创建转码WO',
        ingest_Work_order_label: '创建摄取WO',
        set_mam_status_as_pending_label: '将 Mam 状态设置为 Pending',
        reset_button_text: '重置',
        some_spots_are_txready_selected_spots_error_message: '某些点已 TXReady，无法创建转码工单',
        transcoding_work_order_confirmation_message: '转码WO确认！',
        transcoding_work_order_confirmation_text: '转码工单已创建 您想再次创建吗？',
        publish_provider_label: '发布提供商',
        vod_catalogue_menu: '点播目录',
        vod_catalogue_page_breadcrumb: '点播目录',
        epgs_menu: '电子节目指南',
        epgs_page_breadcrumb: '电子节目指南',
        schedule_export_menu: '时间表',
        schedule_export_page_breadcrumb: '时间表',
        promo_campaign_page_breadcrumb: '促销活动',
        promo_campaign_sub_menu: '促销活动',
        broadcast_windows_label: '广播窗口',
        broadcast_windows_tooltip: '广播窗口',
        from_date_cannot_be_greater_than_to_date: '起始日期不能大于截止日期',
        target_type_label: '目标类型',
        target_type_column: '目标类型',
        weightage_header: '权重',
        weightage_type: '计重类型',
        frequency_type: '频率类型',
        weightage_value: '权重值',
        frequency_value: '频率值',
        please_select_weightage_type_error_message: '请选择权重类型',
        please_select_frequency_type_error_message: '请选择频率类型',
        percentage_should_not_exceed_100_error_message: '百分比不应超过100%',
        trailers_cardlist_header: '拖车',
        sidefix_trailers_tooltip: '拖车',
        target_value: '目标值',
        optional_label: '可选',
        no_valid__offer_to_unpublish_error_message: "该优惠已取消发布/只能从父源取消发布。",
        select_mam_ingestion_header: "摄取MAM",
        please_select_transmission_type_error_message: "请选择传输类型",
        version_type_label: "版本类型",
        please_select_verison_type_error_message: "请选择版本类型",
        log_browser_page_breadcrumb: '日志浏览器',
        file_log: '文件日志',
        epg_export_label: "电子节目指南导出",
        vod_import_label: "点播导入",
        vod_export_label: "点播导出",
        work_order_import_label: "工单导入",
        work_order_export_label: "工单导出",
        version_category_label: "版本类别",
        version_category_column: "版本类别",
        file_publish_label: "文件发布",
        mam_report_sub_menu: "MAM",
        mam_report_page_breadcrumb: "MAM",
        dublist_report_sub_menu: "都柏林人",
        dublist_report_page_breadcrumb: "都柏林人",
        purge_list_report_sub_menu: "清除列表",
        purge_list_report_page_breadcrumb: "清除列表",
        select_transcode_prototype: "选择转码原型",
        process_monitoring_label: "过程监控",
        transmission_list_report_sub_menu: "传输列表",
        transmission_list_report_page_breadcrumb: "传输列表",
        vod_sub_menu: "视频点播",
        ingest_tooltip: "摄取至 MAM",
        node_report_sub_menu: '节点报告',
        node_page_breadcrumb: '节点',
        please_select_node_error_message: '请选择节点',
        schedule_sub_menu: '时间表',
        versions_label: "版本",
        mamassets_label: "MAM资产",
        offers_label: "优惠",
        transmission_browser_menu: '传输浏览器',
        schedule_export_label: '计划导出',
        purge_button_text: '清除',
        ingest_to_mam_tooltip: '摄取到 MAM 选定的项目',
        ingest_to_mam_all_tooltip: '将所有项目摄取到 MAM',
        ingest_to_mam_all_text: '全部摄取',
        please_select_ott_platform_error_message: '请选择OTT平台',
        offer_status_label: '报价状态',
        add_offers_dialog_header: '添加优惠',
        has_versions_label: "有版本",
        has_mam_assets_label: "有妈妈资产",
        has_offers_label: "有优惠",
        has_transmissions_label: "有变速箱",
        contract_title_column: '合同名称',
        offer_status_column: '报价状态',
        offer_title_column: '优惠标题',
        price_code_column: '价格代码',
        please_selest_transmission_type_error_message: '请选择传输类型',
        offers_dialog_header: '优惠',
        offer_delete_confirmation_message: "此优惠已在传输中，您想删除此优惠吗？",
        select_channel_groups_label: '选择频道组',
        season_episode_identifier_setting_menu: '季集标识符设置',
        duplicate_transmission_error_message: "已经存在同一个VOD频道的传输。",
        epg_export_status: "EPG 导出状态",
        filename_label: "文件名",
        filename_not_found_error_message: "找不到文件名",
        unable_to_download_all_files_error_message: "无法下载所有文件",
        channel_groups_label: "频道组",
        download_label: "下载",
        fixed_value: "固定值",
        is_fixed_value_column: "是固定值",
        fixed_value_column: "固定值",
        select_season_label: "选择季节",
        season_attached_success_message: "赛季附加成功",
        unable_to_attach_season_error_message: "无法附加季节",
        please_select_vod_type_error_message: "请选择点播类型",
        scte_break_duration_label: "SCTE 休息时间（以分钟为单位）",
        auto_segment_rule_sub_menu: '自动分段规则',
        auto_segment_rule_page_breadcrumb: '自动分段规则',
        auto_segment_rule_dialog_header: '自动分段规则',
        segment_details_label: '细分详情',
        segment_details_total_should_not_be_greater_than_100_percentage: "细分详细信息总计不应大于 100%",
        segment_details_should_be_equal_to_segment_count: '段详细信息应等于段计数',
        import_mam_asset_success_message: "MAM资产导入成功",
        download_mam_asset_template_label: "下载 MAM 资产模板",
        import_mam_asset_from_excel_label: "从 Excel 导入 MAM 资产",
        please_select_company_type_error_message: "请选择公司类型",
        please_select_at_least_one_instance_error_message: "请至少选择一个实例",
        please_select_time_zone_error_message: "请选择时区",
        instances_label: "实例",
        select_instance_label: "选择实例",
        please_select_instance_error_message: "请选择实例",
        total_booked_amount_label: "预订总额",
        missing_spots_amount_label: "缺失点数量",
        billed_amount_label: "计费金额",
        payment_recieved_label: "已收到付款",
        agency_wise_revenue_label: "代理明智收入",
        client_wise_revenue_label: "客户明智的收入",
        recent_invoices_label: "最近的发票",
        pending_invoices_label: "待处理的发票",
        export_and_mail_saved_booking_label: 'Export & Mail Saved Booking',
        send_booking_to_email_label: '将预订发送至电子邮件',
        agency_email_label: '代理邮箱',
        client_email_label: '客户邮箱',
        booking_mailed_success_message: "预约邮寄成功",
        target_groups_page_breadcrumb: '目标群体',
        target_groups_sub_menu: '目标群体',
        minimum_age_label: '最低年龄',
        maximum_age_label: '最大年龄',
        minimum_age_should_be_greater_than_zero_error_message: '最低年龄应大于零',
        maximum_age_should_be_greater_than_zero_error_message: '最大年龄应大于零',
        target_group_label: '目标群体',
        email_sub_menu: '电子邮件',
        email_page_breadcrumb: '电子邮件',
        email_configuration_menu: '电子邮件配置',
        authentication_label: "认证",
        service_label: "服务",
        app_pass_label: "应用通行证",
        tenant_id_label: "租户ID",
        client_id_label: "客户ID",
        client_secret_value_label: "客户秘密值",
        refresh_token_label: "刷新令牌",
        access_token_label: "访问令牌",
        enter_email_error_message: "请输入电子邮件",
        please_select_authentication_error_message: "请选择身份验证",
        please_enter_app_pass_error_message: "请输入应用程序通行证",
        please_enter_tenant_id_error_message: "请输入租户 ID",
        please_enter_client_id_error_message: "请输入客户ID",
        please_enter_refresh_token_error_message: "请输入刷新令牌",
        please_enter_client_secret_error_message: "请输入客户密码",
        brand_product_report_sub_menu: '品牌产品报告',
        brand_product_report_header: '品牌产品报告',
        telecast_date_column: '电视转播日期',
        telecast_day_column: '电视广播日',
        sales_unit_column: '销售单位',
        aired_time_column: '播出时间',
        episode_code_column: '剧集代码',
        campaign_id_column: '活动 ID',
        agency_gst_column: '代理消费税',
        client_gst_column: '客户消费税',
        agency_pos_column: '代理销售点',
        client_pos_column: '客户销售点',
        commercial_id_column: '商业ID',
        campaign_report_sub_menu: '活动报告',
        campaign_report_header: '活动报告',
        booked_fct_column: '已预订 FCT',
        booked_spots_column: '预订地点',
        total_spots_column: '总名额',
        booked_budget_column: '预订预算',
        total_budget_column: '总预算',
        email_template_menu_breadcrumb: '电子邮件模板',
        email_template_sub_menu: '电子邮件模板',
        sender_label: "发件人",
        cc_label: "抄送",
        bcc_label: "密件抄送",
        subject_label: "主题",
        deleted_success_message: "删除成功",
        error_deleting_file_message: "删除文件时出错",
        error_downloading_file_message: '下载文件时出错',
        please_enter_subject_error_message: "请输入主题",
        please_enter_body_error_message: "请输入正文",
        please_select_sender_error_message: "请选择发件人",
        template_saved_successfully_message: "模板保存成功",
        error_saving_template_message: "保存模板时出错",
        file_already_attached_error_message: "文件已附加",
        unable_to_delete_file_error_message: "无法删除文件",
        unable_to_upload_file_error_message: "无法上传文件",
        email_sent_success_message: "邮件发送成功",
        please_select_email_template_error_message: "请选择电子邮件模板",
        please_enter_to_error_message: "请输入至",
        file_not_found_label: "找不到文件",
        downloading_template_error_message: "无法下载模板",
        choose_file_label: "选择文件",
        please_select_a_file_label: "请选择一个文件",
        export_label: "Export",
        update_label: "更新",
        epg_report_success_message: "EPG 报告已成功生成",
        epg_import_Configuration_label: 'EPG导入配置',
        file_type_label: '文件类型',
        header_index_label: '标题索引',
        data_index_label: '数据索引',
        auto_epg_import_enabled_label: '启用自动 EPG 导入',
        input_dir_label: '输入目录',
        identifier_label: '标识符',
        output_dir_label: '输出方向',
        create_Channel_Dir_label: '创建频道目录',
        sent_to_wf_label: '发送至 WF',
        please_select_atleast_one_prototype_error_message: "请选择至少一个原型",
        channel_epg_mapping_config_sub_menu: '频道 EPG 映射配置',
        channel_epg_mapping_config_menu_breadcrumb: '频道 EPG 映射配置',
        channel_epg_mapping_config_dialog_header: '频道 EPG 映射配置',
        form_field_label: '表单字段',
        import_field_label: '进口领域',
        fixed_value_label: '固定值',
        find_label: '查找',
        replace_value_label: '重置值',
        replace_dialog_header: '更换',
        find_column: '查找',
        replace_value_column: '重置值',
        epg_import_type_label: 'EPG导入类型',
        please_enter_find_error_message: '请输入查找',
        epg_import_field_type_label: 'EPG 导入字段类型',
        template_module_label: '模板模块',
        field_validation_menu: '现场验证',
        field_validation_menu_breadcrumb: '现场验证',
        field_validation_dialog_header: '现场验证',
        validation_level_label: '验证级别',
        validation_type_label: '验证类型',
        please_select_validation_level_error_message: '请选择验证级别',
        please_select_form_field_error_message: '请选择表单字段',
        add_validation_dialog_header: '添加验证',
        data_type_label: '数据类型',
        error_message_column: '错误信息',
        regex_pattern_label: '正则表达式模式',
        fields_label: '领域',
        error_message_label: '错误信息',
        number_label: '数量',
        boolean_label: '布尔值',
        any_label: '任意',
        pattern_label: '图案',
        date_type_label: '日期类型',
        allowed_values_label: '允许值',
        please_select_validation_type_error_message: '请选择验证类型',
        please_select_data_type_error_message: '请选择数据类型',
        please_select_entityname_error_message: '请选择实体名称',
        please_enter_error_message: '请输入错误信息',
        add_validation_type_label: '添加验证类型',
        done_label: '完成',
        please_add_atleast_one_validation_type_error_message: '请添加至少一种验证类型',
        please_enter_pattern_error_message: '请输入图案',
        please_enter_allowed_values_error_message: '请输入允许的值',
        please_enter_fields_error_message: '请输入字段',
        show_segment_details_full_screen_button_tooltip: '全屏显示分段详细信息',
        no_validation_type_message: '无验证类型',
        add_type_message: '添加类型消息',
        image_dir_label: '图片目录',
        download_image_label: '下载图片',
        chinese_title_label: '中文标题',
        spanish_title_label: '西班牙语标题',
        schedule_music_qsheet__menu: '安排音乐 QSheet',
        schedule_music_qsheet_export_page_breadcrumb: '安排音乐 QSheet',
        sheet_index_label: '板材索引',
        box_channel_number_label: "盒子通道号",
        please_select_entity_name_error_message: "请选择实体名称",
        epg_import_label: "电子节目指南导入",
        epg_publish_label: '电子节目指南发布',
        report_type_config_column: '报告类型配置',
        publishing_days_column: '出版日',
        report_type_config_label: '报告类型配置',
        publishing_days_label: '出版日',
        extension_label: '扩展',
        working_title_label: '工作名称',
        content_platform_label: '内容平台',
        cable_vod_label: '有线视频点播',
        iptv_vod_label: '网络电视点播',
        internet_vod_label: '网络视频点播',
        ott_vod_label: '互联网视频点播',
        ssai_vod_label: 'SSAI视频点播',
        download_video_label: '下载视频',
        image_url1_label: '图片网址1',
        image_url2_label: '图片网址2',
        origin_countries_label: '原籍国',
        validity_start_label: '有效期开始',
        validity_end_label: '有效期结束',
        premier_start_date_label: '高级开始日期',
        premier_start_time_label: '总理开始时间',
        premier_end_date_label: '首要结束日期',
        premier_end_time_label: '首播结束时间',
        thumbnail_required_label: '需要缩略图',
        game_id_label: '游戏ID',
        home_team_label: '主队',
        away_team_label: '客队',
        new_title_label: '新标题',
        audio_language1_label: '音频语言1',
        audio_language2_label: '音频语言2',
        subtitle_embedded_label: '嵌入字幕',
        closed_caption_file_format_label: '隐藏式字幕文件格式',
        subtitle_file_name_label: '字幕文件名',
        subtitle_languages_label: '字幕语言',
        audio_mode_label: '音频模式',
        censorship_label: '审查制度',
        folder_name_label: '文件夹名称',
        episode_number_for_press_label: '新闻集数',
        total_episodes_label: '总集数',
        deal_reference_label: '交易参考',
        relative_start_date_label: '相对开始日期',
        relative_start_date_column: '相对开始日期',
        program_language_id_label: '程序语言ID',
        etv_display_label: '东视显示',
        is_start_over_label: '是重新开始',
        short_display_title_label: '简短的显示标题',
        short_display_title_chinese_label: '简短的显示标题（中文）',
        chinese_synopsis_label: '中文剧情简介',
        edit_all_button_tooltip: '全部编辑',
        add_field_button_tooltip: '添加字段',
        prototype_already_exists_error_message: '具有相同 ID 的原型已存在。',
        do_still_want_to_create_message: '你还想创作吗？',
        create_and_attach_offers_button_tooltip: '创建并附加报价',
        translated_description_label: '翻译说明',
        info_bar_rating_label: '信息栏评级',
        mapping_label: '测绘',
        mapping_on_bxf_file_label: 'Bxf 文件上的映射',
        genre_subgenre_mapping_menu_breadcrumb: '类型子类型映射',
        genre_subgenre_mapping_sub_menu: '类型子类型映射',
        genre_subgenre_mapping_dialog_header: '类型子类型映射',
        dvb_content_label: 'DVB内容',
        please_enter_dvb_content_error_message: '请输入 DVB 内容',
        edit_action_button_tooltip: '编辑动作',
        sync_mam_asset_with_S3_label: "将 MAM 资产与 S3 同步",
        valid_file_extensions_label: "有效的文件扩展名",
        itxml_parser_sub_menu: 'ITXML解析器',
        itxml_parser_dialog_header: 'ITXML解析器',
        default_value_label: '默认值',
        cue_tone_in_label: "提示音输入",
        cue_tone_out_label: "提示音输出",
        delete_selected_menutext: '删除',
        delete_selected_in_whole_menutext: '全部删除',
        please_select_production_year_error_message: '请选择生产年份',
        not_linked_label: "未链接",
        version_browser_page_breadcrumb: '版本浏览器',
        transmissions_label: '变速箱',
        price_code_details_label: '价格代码详情',
        create_price_code_button_tooltip: '创建价格代码',
        create_node_button_tooltip: '创建节点',
        edit_node_button_tooltip: '编辑节点',
        transmission_browser_header: '传输浏览器',
        update_node__button_tooltip: '更新节点',
        auto_create_nodes_label: '自动创建节点',
        frame_duration_label: '帧持续时间',
        languages_label: '语言',
        dubbed_languages_label: '配音语言',
        channel_version_id_label: '频道版本ID',
        l2v_channel_mapping_page_breadcrumb: 'L2V 通道映射',
        l2v_channel_mapping_dialog_header: 'L2V 通道映射',
        please_enter_channel_number_error_message: '请输入频道号',
        no_scheduling_found_to_resync_segments_error_message: "找不到重新同步段的调度",
        show_attached_media_dialog_header: '显示附加媒体',
        chinese_cast_label: '中国演员阵容',
        client_type_label: '客户类型',
        address_code_label: '地址码',
        advertiser_label: '广告商',
        channel_header: '渠道',
        transmission_id_prefix_label: '传输 ID 前缀',
        channel_number_column: '通道数',
        transmission_id_prefix_column: '传输 ID 前缀',
        insert_cuetone_label: '插入提示音',
        insert_scte_label: '插入 SCTE 标记',
        delete_cuetone_label: '删除提示音',
        delete_scte_label: '删除 SCTE 标记',
        please_select_only_2_items_to_insert_cuetone_error_message: "请再选择一项以插入提示音",
        cuetone_inserted_successfully_message: "提示音添加成功",
        scte_inserted_successfully_message: "SCTE 标记添加成功",
        some_selected_items_already_have_cuetone_error_message: "某些选定的项目已经有提示音。请选择没有提示音的项目。",
        cuetone_deleted_successfully_message: "提示音删除成功",
        scte_deleted_successfully_message: "SCTE 标记已成功删除",
        ref_export_segment_label: "出口段。",
        planning_browser_sub_menu: '规划浏览器',
        planning_browser_header: '规划浏览器',
        event_type_label: '事件类型',
        episode_title_column: '剧集标题',
        catchup_up_column: '追赶',
        black_out_column: '停电',
        status_text_label: '状态文本',
        segment_extension_header: '段延伸',
        add_extension_tooltip: '添加扩展',
        time_shift_configuration_label: '时移配置',
        Start_trigger_type_label: '启动触发类型',
        copy_slot_prototype_sub_menu: '复制插槽原型',
        copy_slot_prototype_page_breadcrumb: '复制插槽原型',
        day_buffer_label: '日间缓冲',
        slot_start_time: '时段开始时间 (hh:mm:ss:ff)',
        day_buffer_column: '日间缓冲',
        slot_start_time_column: '时段开始时间',
        copy_slot_page_breadcrumb: '复制槽',
        copy_slot_dialog_header: '复制槽',
        copy_slot_prototype_label: '复制插槽原型',
        copy_slot_button_tooltip: '复制槽',
        content_custom_label: "定制",
        is_catch_up_label: "正在迎头赶上",
        item_already_planned_error_message: "无法粘贴：项目已计划在此位置中。",
        add_slot_button_tooltip: '添加插槽',
        copy_slot_success_message: "槽位复制成功",
        create_copy_slot_prototype_label: '创建复制槽原型',
        duplicate_daybuffer_slot_error_message: '不允许重复的 DayBuffer 和 Slot',
        please_fill_daybuffer_and_slot_error_message: '请填写DayBuffer和Slot',
        edit_copy_slot_prototype_label: '编辑复制槽原型',
        day_buffer_can_not_be_lass_than_one_error_message: 'Day Buffer 不能小于 1',
        platforms_column: '平台',
        video_format_column: '视频格式',
        working_title_column: '工作名称',
        deal_reference_column: '交易参考',
        advance_catchup_schedule_days_label: '高级补习安排天数',
        trans_end_offset_type_label: '传输端偏移类型',
        trans_end_offset_value_label: '传输端偏移值',
        time_range_difference_error_message: '选择时间范围差异应小于或等于 6 小时',
        please_select_copy_slot_prototype_error_message: '请选择复制插槽原型',
        no_slots_found_to_copy_error_message: '找不到可复制的插槽',
        l2v_time_shift_configuration_label: 'L2V 时移配置',
        selected_period_label: '选定期间',
        contract_type_label: '合约类型',
        purchase_type_label: '购买类型',
        is_signed_label: '已签署',
        contract_type_page_breadcrumb: '合约类型',
        contract_type_sub_menu: '合约类型',
        campaign_category_page_breadcrumb: '活动类别',
        campaign_category_sub_menu: '活动类别',
        campaign_category_header: '活动类别',
        campaign_category_label: '活动类别',
        please_select_campaign_category_error_message: '请选择活动类别',
        planning_export_label: '计划出口',
        export_break_pattern_button_text: 'Export Break Pattern',
        export_pdf_button_text: 'Export PDF',
        mismatch_in_selected_time_range_and_slots_time_range_error_message: "所选时间范围和时段黑白开始时间不匹配",
        chinese_episode_title_column: '中文剧集标题',
        please_select_country_error_message: '请选择国家',
        slot_start_time_is_less_than_day_buffer_error_message: `选定的复制原型当天“到时间”应大于选定的复制槽“到时间”`,
        please_add_atleast_one_slot_error_message: '请添加至少一个插槽',
        please_complete_save_changes_error_message: "请保存编辑更改",
        custom_episode_title_1_label: '自定义剧集标题 1',
        custom_episode_title_2_label: '自定义剧集标题 2',
        chinese_episode_title_label: '中文剧集标题',
        spanish_episode_title_label: '西班牙语剧集标题',
        custom_description_label: '定制说明',
        short_title_label: '短标题',
        custom_short_title_label: '自定义短标题',
        studio_label: '工作室',
        rental_duration_label: '租赁时间（天）',
        time_unit_label: '时间单位',
        publish_to_vod_actionbutton_menutext: '发布到点播',
        create_offers_label: '创建报价',
        attach_offers_label: '附上优惠',
        segment_detail_type_column: '类型',
        delete_start_end_credits_label: '删除制作人员名单',
        delete_start_credits_label: '开始信贷',
        delete_end_credits_label: '结束信用',
        delete_both_credits_label: '两个学分',
        premier_start_date_column: '高级开始日期',
        premier_end_date_column: '首要结束日期',
        sync_metadata_to_episodes_label: "将元数据同步到剧集",
        sync_metadata_to_episodes_confirmation_message: "这将覆盖本季所有剧集的元数据。您想继续吗？",
        number_of_exhibition_available_tooltip_message: '可用的展览数量。',
        number_of_repeat_telecast_available_tooltip_message: '可用的重复电视广播数量。',
        playtime_tooltip_message: '计划有效性的持续时间段类型（例如天/周）。',
        playtime_number_tooltip_message: '在选定的播放时间段内可以安排内容的次数。',
        language2_label: '语言2',
        secondary_copy_label: '次要副本',
        language1_length_error_message: '语言 1 长度不能超过 3 个字符',
        language2_length_error_message: '语言 2 长度不能超过 3 个字符',
        custom_slot_duration: "自定义时段持续时间",
        please_enter_custom_duration_error_message: "请输入有效的自定义持续时间",
        please_enter_custom_duration_min_time_error_message: "自定义持续时间应大于等于 5 分钟",
        please_select_version_type_error_message: "请选择版本类型",
        auto_delete_start_end_credits_label: "自动删除开始和结束制作人员名单",
        delete_start_end_credits_note_message: "注意：这将在应用递归时自动删除开始和结束学分",
        program_group_episode_range_disable_note_message: "注意：如果选择“节目组”，则“情节范围”应被禁用",
        platform_groups_page_breadcrumb: '平台组',
        platform_groups_sub_menu: '平台组',
        platform_groups_header: '平台组',
        platform_groups_label: '平台组',
        select_platform_groups_collection_header: '选择平台组',
        select_program_groups_tooltip: '选择节目组',
        platforms_label: '平台',
        please_select_linear_channels_error_message: '请选择线性通道',
        linear_channels_label: '线性通道',
        non_linear_platforms_label: '非线性平台',
        expected_date_label: '预计日期',
        promotion_report_menu: '推广报告',
        promotion_report_header: '推广报告',
        please_select_linear_start_date_error_message: '请选择线性开始日期',
        please_select_non_linear_start_date_error_message: '请选择非线性开始日期',
        please_select_linear_end_date_error_message: '请选择线性结束日期',
        please_select_non_linear_end_date_error_message: '请选择非线性结束日期',
        linear_start_and_end_date_error_message: '线性开始日期应小于结束日期',
        non_linear_start_and_end_date_error_message: '非线性开始日期应小于结束日期',
        thumbnail_status_reset_success_message: "缩略图状态重置成功",
        reset_thumbnail_status_label: '重置缩略图状态',
        you_are_not_authorized_to_attach_contract_please_go_to_parent_series_error_message: '您无权附加合同。请前往家长系列',
        you_are_not_authorized_to_attach_contract_please_go_to_series_error_message: '您无权附加合同。请前往系列',
        you_are_not_authorized_to_attach_contract_please_go_to_contract_error_message: '您无权附加合同。请前往合同',
        successfully_attached_success_message: '已成功附加',
        exclusive_start_date_label: '独家开始日期',
        exclusive_end_date_label: '独家结束日期',
        ref_attach_media_label: '附加媒体',
        attach_label: '附加',
        delete_label: '删除',
        please_enter_valid_custom_duration_recusive_error_message: '请以逗号分隔的格式输入有效的持续时间（以分钟为单位）。',
        enter_comma_separated_durations_error_message: '示例：5、10、15（分钟）对应相应编号。 eps。',
        number_of_episode_not_eqaul_error_message: '剧集数应等于或小于输入的持续时间数',
        duration_format_note: "以 ( hh:mm:ss:ff ) 格式输入。",
        image_url1_landscape_label: '图片 URL 1（横向）',
        image_url2_portrait_label: '图片 URL 2（肖像）',
        time_restriction_label: '时间限制',
        to_should_be_grater_than_from_error_message: 'To 应大于 From',
        please_enter_to_error_message: '请输入收件人',
        please_enter_from_error_message: '请输入发件人',
        cannot_paste_due_to_time_restriction_error_message: "由于时间限制，某些项目在所选时段无效。",
        program_last_airing_report_header: '节目最后播出报告',
        schedule_date_column: '安排日期',
        program_last_airing_sub_menu: '节目最后播出报告',
        enable_auto_epg_export_label: '启用自动 EPG 导出',
        channel_start_date_label: '频道开始日期',
        dev_logs_label: '开发日志',
        media_actual_duration_sub_menu: '媒体实际持续时间报告',
        media_actual_duration_report_header: '媒体实际持续时间报告',
        program_title_column: '节目名称',
        program_episode_season_column: '节目集季',
        program_episode_number_column: '节目集数',
        segment_number_column: '段数',
        delete_channel_button_tooltip: '删除频道',
        is_hard_parted_has_been_changed_please_generated_segments_again_error_message: '是否很难分开已更改。请在保存之前重新生成段。',
        secondary_event_label: '次要活动',
        scte_exc_media_category_type_label: 'SCTE 执行官媒体类别类型',
        sync_label: '同步',
        applying_program_group_status_message: '正在申请计划组，请稍候...',
        blackout_column: '停电',
        show_blackout_tooltip: '显示停电',
        clash_genre_label: '冲突类型',
        producer_label: '制片人',
        promos_trailers_label: '宣传片/预告片',
        default_genre_label: '默认类型',
        please_select__clash_genre_error_message: '请选择冲突类型',
        import_export_module_wise_count_label: '导入/导出模块明智计数',
        show_import_export_module_wise_full_screen_button_tooltip: '全屏显示导入/导出模块',
        edit_slot_metadata_label:"编辑插槽元数据",
        subgenre_label:"子流派",
        slot_metadata_updated_successfully:"插槽元数据已成功更新",
        failed_to_load_slot_metadata_error_message:"插槽元数据加载失败",
        please_select_avail_suppression_fill_policy_error_message:"请选择“使用抑制填充策略”",
        please_select_ad_insertion_mode_error_message :"请选择广告插入模式",
        please_select_avail_suppression_mode_error_message :"请选择可用抑制模式",
        please_enter_avail_suppression_value_error_message :"请输入有效抑制值",
        default_audioTrack_label: '默认音轨',
        default_programme_language_id_label: '默认程序语言 ID',
        fix_follow_label: "修复/关注",
        info_message_title: "信息",
        success_message_title: "成功",
        invalid_error_message_title: "无效",
        warning_message_title: "警告",
        loading_label: "加载中",
        failed_to_generate_data_error_message: "生成数据失败。",
        ready_to_generate_data_label: "准备生成数据",
        boss_ai_gernerate_data_message: "输入标题，根据需要选择语言，然后单击“显示”按钮使用Boss AI生成数据。",
        apply_filter_button: "应用过滤器",
        transmissions_header: "传输",
        dai_ad_insertions_menu: "动态广告插入",
        utility_menu: "实用工具",
        linear_deal_rights_label: "线性交易权利",
        non_linear_deal_rights_label: "非线性交易权利",
        timing_and_classification_section_header: "时间和分类",
        content_and_identification_section_header: "内容和识别",
        title_and_description_section_header: "标题和描述",
        confirm_button: "确认",
        confirm_button_tooltip: "确认",
        genre_categorization_and_metadata_section_header: "流派分类和元数据",
        images_label: "图片",
        sports_label: "体育",
        audio_and_video_label: "音频和视频",
        deep_archive_menu: "深度归档",
        planning_export_dialog_header: "导出",
        start_label: "开始",
        hide_next_day_show_continuation_label: "隐藏次日节目继续",
        show_title_only_label: "仅显示标题",
        month_export_label: "月度导出",
        export_break_pattern_button: "导出休息模式",
        export_pdf_button: "导出PDF",
        media_content_header: "媒体内容",
        content_category_header: "内容类别",
        segment_and_mam_label: "片段/MAM",
        next_day_label: "第二天",
        audience_label: "受众",
        ad_label: "广告",
        create_ad_header: "创建广告",
        select_ad_label: "选择广告",
        sunday_short_text: "周日",
        monday_short_text: "周一",
        tuesday_short_text: "周二",
        wednesday_short_text: "周三",
        thursday_short_text: "周四",
        friday_short_text: "周五",
        saturday_short_text: "周六",
        create_planning_slot_header: "创建计划时段",
        series_library_header: "系列库",
        media_versions_header: "媒体版本",
        auto_id_label: "自动ID",
        selected_items_label: "已选项",
        total_duration_label: "总时长",
        total_bookings_label: "总预订量",
        filter_bookings_label: "筛选预订",
        make_good_menu_label: "补偿",
        purge_menu_label: "清除",
        open_campaign_menu_label: "打开活动",
        go_to_schedule_button: "转到日程表",
        cpld_label: "CPLD",
        expd_label: "EXPD",
        previous_day_end_time_label: "前一天结束时间",
        schedule_header: "日程表",
        file_menu_label: "文件",
        new_schedule_menu_label: "新日程表",
        open_draft_menu_label: "打开草稿",
        save_as_draft_menu_label: "保存为草稿",
        unlock_schedule_menu_label: "解锁日程表",
        lock_schedule_menu_label: "锁定日程表",
        open_planning_menu_label: "打开计划",
        show_logs_menu_label: "显示日志",
        export_menu_label: "导出",
        export_playlist_menu_label: "导出播放列表",
        export_partial_playlist_menu_label: "导出部分播放列表",
        export_sftp_playlist_menu_label: "导出SFTP播放列表",
        download_pdf_menu_label: "下载PDF",
        export_excel_menu_label: "导出Excel",
        export_itxml_menu_label: "导出ITXML",
        export_announcement_menu_label: "导出公告",
        export_imagine_playlist_menu_label: "导出Imagine播放列表",
        export_epg_menu_label: "导出EPG",
        export_ross_playlist_menu_label: "导出ROSS播放列表",
        export_jazler_commercial_menu_label: "导出Jazler商业广告",
        push_playlist_menu_label: "推送播放列表",
        export_and_deliver_playlist_menu_label: "导出并交付播放列表",
        edit_menu_label: "编辑",
        cut_menu_label: "剪切",
        copy_menu_label: "复制",
        paste_menu_label: "粘贴",
        delete_menu_label: "删除",
        insert_break_menu_label: "插入休息",
        find_and_replace_menu_label: "查找和替换",
        insert_live_event_menu_label: "插入直播事件",
        revert_virtual_segment_menu_label: "还原虚拟片段",
        delete_all_footer_menu_label: "删除所有页脚",
        match_prev_day_end_time_menu_label: "匹配前一天结束时间",
        view_menu_label: "视图",
        go_to_menu_label: "转到",
        refresh_schedule_menu_label: "刷新日程表",
        show_breaks_only_menu_label: "仅显示休息",
        expand_menu_label: "展开",
        collapse_menu_label: "折叠",
        secondary_events_menu_label: "次要事件",
        delete_all_menu_label: "删除全部",
        delete_selected_menu_label: "删除所选",
        se_overview_menu_label: "次要事件概览",
        apply_style_sheet_menu_label: "应用样式表",
        run_menu_label: "运行",
        auto_fill_short_forms_menu_label: "自动填充短表单",
        auto_fill_booked_spots_menu_label: "自动填充已预订时段",
        execute_promo_campaigns_menu_label: "执行促销活动",
        fill_playlist_menu_label: "填充播放列表",
        auto_fill_music_menu_label: "自动填充音乐",
        create_fast_playlist_menu_label: "创建快速播放列表",
        cue_tones_menu_label: "提示音",
        scte_markers_menu_label: "SCTE标记",
        reset_auto_fill_menu_label: "重置自动填充",
        reset_schedule_menu_label: "重置日程表",
        sync_all_headers_segment_menu_label: "同步所有标题片段",
        reset_header_to_nominal_menu_label: "将标题重置为名义值",
        create_automatic_breaks_menu_label: "创建自动休息",
        check_lists_menu_label: "清单",
        settings_menu_label: "设置",
        schedule_preference_menu_label: "日程偏好",
        column_preference_menu_label: "列偏好",
        checklist_preference_menu_label: "清单偏好",
        exit_draft_mode_menu_label: "退出草稿模式",
        restore_menu_label: "还原",
        select_itxml_file_label: "选择ITXML文件",
        file_ready_label: "文件就绪",
        create_storage_provider_header: "创建存储提供程序",
        transaction_id_column: "交易ID",
        action_type_column: "操作类型",
        request_column: "请求",
        response_column: "响应",
        response_header: "响应",
        campaign_status_label: "活动状态",
        create_product_header: "创建产品",
        create_target_group_header: "创建目标组",
        social_media_channel_type_header: "社交媒体频道类型",
        meta_label: "Meta",
        google_label: "Google",
        linkedin_label: "LinkedIn",
        youtube_label: "YouTube",
        snapchat_label: "Snapchat",
        create_adset_label: "创建广告组",
        adsets_label: "广告组",
        update_adset_label: "更新广告组",
        conversion_location_label: "转换位置",
        choose_where_you_want_to_generate_leads_tooltip_message: "选择您要生成潜在客户的位置。",
        learn_more: "了解更多",
        billing_event_label: "计费事件",
        optimization_goal_label: "优化目标",
        application_id_label: "应用程序ID",
        object_store_url_label: "对象存储URL",
        custom_event_type_label: "自定义事件类型",
        pixel_id_label: "Pixel ID",
        button_type_label: "按钮类型",
        button_link_label: "按钮链接",
        billing_event_tooltip_message: "计费事件告诉Meta在广告投放过程中何时向您收费——它在广告组级别设置，并取决于您的活动目标。",
        optimization_goal_tooltip_message: "优化目标告诉Meta您最关心的结果，这样它可以向最可能采取该行动的人展示您的广告。潜在客户：潜在客户、转化潜在客户、链接点击。应用程序安装：应用程序安装、应用程序事件。销售/转化：转化、价值、购买。",
        page_not_found_tooltip_message: "如果没有找到页面，请检查您的api令牌是否已过期。如果已过期，请重新验证您的Meta频道。",
        enter_application_id_placeholder: "输入应用程序ID",
        enter_object_store_url_placeholder: "输入对象存储URL",
        enter_pixel_id_placeholder: "输入Pixel ID",
        enter_link_placeholder: "输入链接",
        enter_button_action_link_placeholder: "输入按钮操作链接",
        enter_ad_description_message_placeholder: "输入广告描述信息",
        app_id_displayed_at_top_help_text: "App ID显示在顶部。",
        find_pixel_id_help_text: "在事件管理器的数据源顶部找到Pixel ID。",
        facebook_feed_tab: "Facebook动态",
        instagram_feed_tab: "Instagram动态",
        instagram_story_tab: "Instagram快拍",
        update_audience_header: "更新受众",
        add_audience_header: "添加受众",
        geo_locations_label: "地理位置",
        interests_label: "兴趣",
        special_add_category_label: "特殊广告类别",
        genders_label: "性别",
        scroll_together_label: "一起滚动",
        manage_asrun_header: "管理Asrun",
        add_subtitle_dialog_title: "添加字幕",
        edit_subtitle_dialog_title: "编辑字幕",
        app_bar_label: "应用栏",
        menu_label: "菜单",
        rail_type_label: "栏目类型",
        cta_label: "号召性用语",
        message_box_label: "消息框",
        background_label: "背景",
        icon_color_label: "图标颜色",
        icon_selector_color_label: "图标选择器颜色",
        font_weight_label: "字体粗细",
        icon_size_label: "图标大小",
        focus_color_label: "焦点颜色",
        focus_width_label: "焦点宽度",
        page_title_label: "页面标题",
        block_title_label: "块标题",
        link_hover_label: "链接悬停",
        page_skeleton_label: "页面骨架",
        box_shadow_label: "框阴影",
        primary_label: "主要",
        primary_hover_label: "主要悬停",
        secondary_label: "次要",
        secondary_hover_label: "次要悬停",
        border_color_label: "边框颜色",
        border_width_label: "边框宽度",
        box_label: "框",
        button_label: "按钮",
        show_logo_label: "显示徽标",
        source_1_label: "来源 1",
        source_2_label: "来源 2",
        create_price_code_dialog_title: "创建价格代码",
        edit_offer_dialog_title: "编辑优惠",
        create_offer_dialog_title: "创建优惠",
        create_bucket_configuration_dialog_title: "创建存储桶配置",
        create_bucket_dialog_title: "创建存储桶",
        enter_extensions_separated_by_comma_label: "输入以逗号分隔的扩展名（例如 .jpg, .png 等）。",
        deep_archive_header: "深度归档",
        syncing_button_text: "同步中...",
        sync_button_text: "同步",
        media_overview_label: "媒体概览",
        no_folder_data_available_use_sync_to_pull_data_placeholder: "无可用文件夹数据。使用同步提取数据。",
        loading_folders_label: "加载文件夹中...",
        restore_from_deep_archive_label: "从深度归档还原",
        restoring_button_text: "还原中...",
        restore_button_text: "还原",
        create_email_configuration_dialog_header: "创建电子邮件配置",
        create_email_template_dialog_header: "创建电子邮件模板",
        application_configuration_dialog_header: "应用程序配置",
        season_episode_identifier_settings_dialog_header: "季集标识符设置",
        season_form_field_label: "季表单字段",
        season_identifier_label: "季标识符",
        episode_form_field_label: "集表单字段",
        episode_identifier_label: "集标识符",
        add_publish_setting_dialog_header: "添加发布设置",
        publish_settings_page_breadcrumb: "发布设置",
        make_sure_to_logout_and_login_again_to_see_the_changes_message: "请确保注销并重新登录以查看更改。",
        create_catalogue_dialog_header: "创建目录"
    }
};